var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import styled, { css, keyframes, ThemeContext, withTheme } from "styled-components";
import React from "react";
const Padding = css`
  padding: ${(props) => props.padding};
`;
const Margin = css`
  margin: ${(props) => props.margin};
`;
const Zindex = css`
  z-index: ${(props) => props.zIndex ? props.zIndex : 1};
`;
const Position = css`
  position: ${(props) => props.position};
`;
const Overflow = css`
  overflow: ${(props) => props.overflow};
`;
const Border = css`
  border: ${(props) => props.border};
`;
const BorderStyle = css`
  border-style: ${(props) => props.borderStyle};
`;
const WordBreak = css`
  word-break: ${(props) => props.wordBreak};
`;
const Transition = css`
  transition: ${(props) => props.transition};
`;
const Cursor = css`
  cursor: ${(props) => props.cursor};
`;
const MaxWidth = css`
  max-width: ${(props) => props.maxWidth};
`;
const MaxHeight = css`
  max-height: ${(props) => props.maxHeight};
`;
const Shrink = css`
  flex-shrink: ${(props) => props.shrink};
`;
const Wrap = css`
  flex-wrap: ${(props) => props.wrap};
`;
const LineHeight = css`
  line-height: ${(props) => props.lineHeight || "160%"};
`;
const LetterSpacing = css`
  letter-spacing: ${(props) => props.letterSpacing};
`;
const FontSize = css`
  font-size: ${(props) => props.fontSize};
`;
const Color = css`
  color: ${(props) => props.color};
`;
const FontWeight = css`
  font-weight: ${(props) => props.fontWeight};
`;
const TextAlign = css`
  text-align: ${(props) => props.align || props.textAlign};
`;
const TextTransform = css`
  text-transform: ${(props) => props.textTransform};
`;
const FontStyle = css`
  font-style: ${(props) => props.fontStyle};
`;
const FontFamily = css`
  font-family: ${(props) => props.fontFamily};
`;
const UserSelect = css`
  user-select: ${(props) => props.userSelect};
`;
const Background = css`
  background: ${(props) => props.background};
`;
const Left = css`
  left: ${(props) => props.left};
`;
const Top = css`
  top: ${(props) => props.top};
`;
const Opacity = css`
  opacity: ${(props) => props.opacity};
`;
const CommonProps = {
  LineHeight,
  LetterSpacing,
  FontSize,
  FontWeight,
  FontFamily,
  FontStyle,
  Opacity,
  Color,
  TextAlign,
  TextTransform,
  UserSelect,
  Padding,
  Margin,
  Cursor
};
const colorPalette = {
  primary: {
    charcoal: "#2a2b2b",
    oak: "#F7F4F2"
  },
  secondary: {
    yellow: "#fcfe7d",
    navy: "#211e2c",
    black: "#000",
    blackTransparent: "rgba(30,30,30,0.1)",
    white: "#fff",
    whiteTransparent: "rgba(255,255,255,0.3)",
    cyan: "#9ffbf5",
    blue: "#0000FF",
    streetBlue: "#0D4D99",
    streetGreen: "#080",
    streetRed: "#ff0000",
    lightBlue: "#7AC9EA",
    purple: "#6d56fb",
    promoPurple: "#5937f9",
    darkPurple: "#201F2C",
    lavender: "#dcdbff",
    red: "#f5665d",
    green: "#7ecb00",
    brightGreen: "#1AD36F",
    brightRed: "#FF5000",
    darkRed: "#bc332c",
    darkGreen: "#5a7a00",
    silver: "#c0c0c0",
    lightCharcoal: "#343434",
    orange: "rgb(255,156,34)",
    cream: "#F6F3EF",
    lighterGrey: "rgb(235,235,235)",
    osGrey: "rgb(218,224,227)",
    cloud: "#777777",
    darkCloud: "#333",
    lightCloud: "#f6f7f7"
  },
  element: {
    borderLight: "rgba(31,31,31, 0.05)",
    borderDark: "rgba(247,244,242, 0.05)"
  }
};
const tornadoColorPalette = {
  primary: {
    charcoal: "#2a2b2b",
    oak: "#F7F4F2"
  },
  secondary: {
    yellow: "#fcfe7d",
    yellowDarker: "#faf07a",
    navy: "#211e2c",
    black: "#000",
    lightenedCharcoal: "#3c3d3c",
    white: "#fff",
    lightBlue: "#7AC9EA",
    cyan: "#9ffbf5",
    purple: "#6d56fb",
    purpleDarker: "#6a50e8",
    promoPurple: "#5937f9",
    lavender: "#dcdbff",
    red: "#f5665d",
    green: "#7ecb00",
    darkRed: "#ff5400",
    darkGreen: "#5a7a00",
    brightGreen: "#23d977",
    charcoalHighlight: "rgba(42, 43, 43, 0.05)",
    oakHighlight: "rgba(247, 244, 242, 0.05)"
  },
  element: {
    borderLight: "rgba(31,31,31, 0.05)",
    borderDark: "rgba(247,244,242, 0.05)"
  }
};
const theStreetColorPalette = {
  primary: {
    darkCloud: "#474747",
    white: "#fff"
  },
  secondary: {
    black: "#000",
    cloud: "#777777",
    darkCloud: "#474747",
    lightCloud: "#f6f7f7",
    streetBlue: "#0D4D99",
    red: "#ff0000",
    green: "#080",
    osGrey: "rgb(218,224,227)",
    blackTransparent: "rgba(30,30,30,0.1)",
    whiteTransparent: "rgba(255,255,255,0.3)"
  },
  element: {
    borderLight: "rgba(31,31,31, 0.05)",
    borderDark: "rgba(247,244,242, 0.05)"
  }
};
const colorThemes = {
  light: "light-color-scheme",
  dark: "dark-color-scheme",
  theStreet: "the-street-color-scheme"
};
const convertHexToRGBA = (hex, a) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return `rgba(${[c >> 16 & 255, c >> 8 & 255, c & 255].join(",")},${a})`;
  }
  return false;
};
const isInteger = (n) => {
  return Number.isInteger(n);
};
const { charcoal: charcoal$1, oak: oak$1 } = colorPalette.primary;
const {
  white: white$1,
  darkCloud: darkCloud$1,
  lightCloud: lightCloud$1,
  cloud: cloud$1,
  streetBlue: streetBlue$1,
  streetGreen: streetGreen$1,
  streetRed: streetRed$1,
  orange: orange$1,
  purple: purple$1,
  lightCharcoal,
  green: green$1,
  red,
  darkRed,
  brightGreen: brightGreen$1,
  yellow: yellow$1,
  lightBlue: lightBlue$1
} = colorPalette.secondary;
const themes = {
  [colorThemes.light]: {
    header: white$1,
    appBackground: oak$1,
    component: convertHexToRGBA(white$1, 0.9),
    componentNoOpacity: convertHexToRGBA(white$1, 1),
    disabled: convertHexToRGBA(charcoal$1, 0.05),
    overlay: convertHexToRGBA(charcoal$1, 0.6),
    border: convertHexToRGBA(charcoal$1, 0.2),
    lowContrastBorder: convertHexToRGBA(charcoal$1, 0.05),
    text: charcoal$1,
    secondaryText: convertHexToRGBA(charcoal$1, 0.3),
    buttonText: white$1,
    proColor: brightGreen$1,
    conColor: red,
    neutral: lightCharcoal,
    negative: red,
    positive: brightGreen$1,
    inputBg: "transparent",
    avatarBackgroundColor: purple$1,
    buttonColor: purple$1,
    primaryCtaButton: purple$1,
    primaryEyeCatchingCtaButton: lightBlue$1,
    badge: purple$1,
    error: red,
    warning: orange$1,
    hoverComponentBackground: convertHexToRGBA(purple$1, 0.1)
  },
  [colorThemes.dark]: {
    header: charcoal$1,
    appBackground: charcoal$1,
    component: lightCharcoal,
    componentNoOpacity: convertHexToRGBA(lightCharcoal, 1),
    disabled: convertHexToRGBA(white$1, 0.05),
    overlay: convertHexToRGBA(oak$1, 0.4),
    border: convertHexToRGBA(oak$1, 0.2),
    lowContrastBorder: convertHexToRGBA(oak$1, 0.05),
    text: white$1,
    secondaryText: convertHexToRGBA(white$1, 0.4),
    buttonText: charcoal$1,
    proColor: brightGreen$1,
    conColor: red,
    neutral: white$1,
    negative: red,
    positive: brightGreen$1,
    inputBg: "transparent",
    badge: yellow$1,
    avatarBackgroundColor: yellow$1,
    buttonColor: yellow$1,
    primaryCtaButton: yellow$1,
    primaryEyeCatchingCtaButton: lightBlue$1,
    error: red,
    warning: orange$1,
    hoverComponentBackground: convertHexToRGBA(yellow$1, 0.1)
  },
  [colorThemes.theStreet]: {
    header: white$1,
    appBackground: lightCloud$1,
    darkerAppBackground: cloud$1,
    component: convertHexToRGBA(white$1, 0.9),
    componentNoOpacity: convertHexToRGBA(white$1, 1),
    disabled: convertHexToRGBA(darkCloud$1, 0.05),
    overlay: convertHexToRGBA(darkCloud$1, 0.6),
    border: convertHexToRGBA(darkCloud$1, 0.2),
    lowContrastBorder: convertHexToRGBA(darkCloud$1, 0.05),
    text: darkCloud$1,
    secondaryText: convertHexToRGBA(darkCloud$1, 0.6),
    badge: streetBlue$1,
    proColor: streetGreen$1,
    conColor: streetRed$1,
    neutral: cloud$1,
    negative: streetRed$1,
    warning: orange$1,
    positive: streetGreen$1,
    avatarBackgroundColor: streetBlue$1,
    inputBg: "transparent",
    buttonColor: streetBlue$1,
    primaryCtaButton: streetBlue$1,
    buttonText: white$1,
    primaryEyeCatchingCtaButton: streetBlue$1,
    error: streetRed$1,
    hoverComponentBackground: convertHexToRGBA(streetBlue$1, 0.5)
  }
};
const breakpoints = {
  mobile: "768px",
  table: "1024px",
  desktop: "1368px"
};
const SCREEN_SIZES = {
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop"
};
const INPUT_MASK_TYPES = {
  phone: "phone",
  dollarAmount: "dollarAmount",
  centsAmount: "centsAmount"
};
const ELEMENT_COLOR_NAMES = {
  nvstrRewardCardFront: "nvstrRewardCardFront",
  nvstrRewardCardBack: "nvstrRewardCardBack",
  nvstrReferralRewardProbability: "nvstrReferralRewardProbability",
  nvstrRewardValueColor: "nvstrRewardValueColor",
  nvstrRedeemableRewardCard: "nvstrRedeemableRewardCard",
  nvstrRedeemableRewardCardStripe: "nvstrRedeemableRewardCardStripe",
  rewardsIconColor: "rewardsIconColor",
  statusBarColor: "statusBarColor",
  statusBarContent: "statusBarContent",
  eyeCatchingActionButton: "eyeCatchingActionButton",
  bgColor: "bgColor",
  bgAccentColor: "bgAccentColor",
  bgBorderShadow: "bgBorderShadow",
  darkThemeBgColor: "darkThemeBgColor",
  componentBg: "componentBg",
  componentBgFullOpacity: "componentBgFullOpacity",
  componentBgHighlight: "componentBgHighlight",
  launchBg: "launchBg",
  disabledBg: "disabledBg",
  overlayBg: "overlayBg",
  eyeCatchingBgTextColor: "eyeCatchingBgTextColor",
  eyeCatchingBg: "eyeCatchingBg",
  eyeCatchingBgShadow: "eyeCatchingBgShadow",
  primaryTextColor: "primaryTextColor",
  dropdownItemColor: "dropdownItemColor",
  lightThemePrimaryTextColor: "lightThemePrimaryTextColor",
  darkThemePrimaryTextColor: "darkThemePrimaryTextColor",
  secondaryTextColor: "secondaryTextColor",
  inactiveTextColor: "inactiveTextColor",
  headingTextColor: "headingTextColor",
  thoughtBannerTextColor: "thoughtBannerTextColor",
  coloredBgTextColor: "coloredBgTextColor",
  eyeCatchingTextColor: "eyeCatchingTextColor",
  labelTextColor: "labelTextColor",
  inputTextColor: "inputTextColor",
  inputActiveTextColor: "inputActiveTextColor",
  errorTextColor: "errorTextColor",
  warningTextColor: "warningTextColor",
  placeholderTextColor: "placeholderTextColor",
  primaryDropdownTextColor: "primaryDropdownTextColor",
  communityCountAvatarBgColor: "communityCountAvatarBgColor",
  borderAccent: "borderAccent",
  tableBorder: "tableBorder",
  darkerBorderAccent: "darkerBorderAccent",
  inputBorderAccent: "inputBorderAccent",
  infoIcon: "infoIcon",
  counterBgColor: "counterBgColor",
  counterTextColor: "counterTextColor",
  communityAvatarBg: "communityAvatarBg",
  defaultAvatarBg: "defaultAvatarBg",
  defaultAvatarText: "defaultAvatarText",
  headerNavBg: "headerNavBg",
  navBarBg: "navBarBg",
  navBarBgShadow: "navBarBgShadow",
  navBarBottomBorder: "navBarBottomBorder",
  headerNavItemColor: "headerNavItemColor",
  activeFooterNavItemColor: "activeFooterNavItemColor",
  inactiveFooterNavItemColor: "inactiveFooterNavItemColor",
  cardShadow: "cardShadow",
  increaseColor: "increaseColor",
  decreaseColor: "decreaseColor",
  neutralColor: "neutralColor",
  buyColor: "buyColor",
  sellColor: "sellColor",
  ctlBannerBg: "ctlBannerBg",
  thoughtBubbleColor: "thoughtBubbleColor",
  thoughtEmbeddedLinkBgColor: "thoughtEmbeddedLinkBgColor",
  thoughtBannerIconColor: "thoughtBannerIconColor",
  proColor: "proColor",
  conColor: "conColor",
  agreeColor: "agreeColor",
  disagreeColor: "disagreeColor",
  increaseColorDark: "increaseColorDark",
  decreaseColorDark: "decreaseColorDark",
  moneyColor: "moneyColor",
  successColor: "successColor",
  successHighlight: "successHighlight",
  successContrast: "successContrast",
  failureColor: "failureColor",
  fireColor: "fireColor",
  primaryBtnColor: "primaryBtnColor",
  primaryBtnTextColor: "primaryBtnTextColor",
  secondaryBtnColor: "secondaryBtnColor",
  secondaryBtnTextColor: "secondaryBtnTextColor",
  primaryBtnColorAlt: "primaryBtnColorAlt",
  disabledBtnTextColor: "disabledBtnTextColor",
  disabledBtnColor: "disabledBtnColor",
  feedFilterTagBg: "feedFilterTagBg",
  feedFilterTagText: "feedFilterTagText",
  linkColor: "linkColor",
  linkColorAlt: "linkColorAlt",
  linkColorLowContrast: "linkColorLowContrast",
  searchIconColor: "searchIconColor",
  chartAxisColor: "chartAxisColor",
  loadingIcon: "loadingIcon",
  refreshIndicatorIOS: "refreshIndicatorIOS",
  blueGreenGradient: "blueGreenGradient",
  haloGradient: "haloGradient",
  modalTrayBg: "modalTrayBg",
  modalTrayActionRowBg: "modalTrayActionRowBg",
  warning: "warning",
  inputBg: "inputBg",
  inputIconColor: "inputIconColor",
  frameColor: "frameColor",
  topFrameColor: "topFrameColor",
  bottomFrameColor: "bottomFrameColor",
  darkThemeTopFrameColor: "darkThemeTopFrameColor",
  darkThemeBottomFrameColor: "darkThemeBottomFrameColor",
  toggleSwitchTrackToggledOn: "toggleSwitchTrackToggledOn",
  toggleSwitchTrackToggledOff: "toggleSwitchTrackToggledOff",
  depositPickerButtonBg: "depositPickerButtonBg",
  depositPickerButtonText: "depositPickerButtonText",
  depositPickerSelectedButtonBg: "depositPickerSelectedButtonBg",
  depositPickerSelectedButtonTextColor: "depositPickerSelectedButtonTextColor",
  white: "white",
  transparent: "transparent",
  forceCharcoal: "forceCharcoal"
};
const { primary, secondary, element } = colorPalette;
const { charcoal, oak } = primary;
const {
  yellow,
  navy,
  black,
  white,
  purple,
  lightBlue,
  green,
  brightGreen,
  brightRed,
  silver,
  orange,
  cream,
  lighterGrey,
  osGrey,
  blue,
  lightCloud,
  cloud,
  darkCloud,
  streetBlue,
  streetGreen,
  streetRed
} = secondary;
const bgColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const bgBorderShadow = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: black
};
const statusBarColor = bgColor;
const statusBarContent = {
  [colorThemes.light]: "dark-content",
  [colorThemes.dark]: "light-content"
};
const darkThemeBgColor = {
  [colorThemes.light]: bgColor.dark,
  [colorThemes.dark]: bgColor.dark
};
const componentBg = {
  [colorThemes.light]: "rgba(255,255,255, 0.9)",
  [colorThemes.dark]: "rgba(52,52,52, 0.9)"
};
const componentBgFullOpacity = {
  [colorThemes.light]: "rgba(255,255,255, 1)",
  [colorThemes.dark]: "rgba(52,52,52, 1)"
};
const componentBgHighlight = componentBg;
const launchBg = {
  [colorThemes.light]: bgColor.dark,
  [colorThemes.dark]: bgColor.dark
};
const disabledBg = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const overlayBg = {
  [colorThemes.light]: "rgba(246,243,239, 0.6)",
  [colorThemes.dark]: "rgba(31,31,31,0.6)"
};
const eyeCatchingBgTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: charcoal
};
const eyeCatchingTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: charcoal
};
const headerNavItemColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const activeFooterNavItemColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const inactiveFooterNavItemColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const inputBg = {
  [colorThemes.light]: bgColor.light,
  [colorThemes.dark]: bgColor.dark
};
const inputIconColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const eyeCatchingActionButton = {
  [colorThemes.light]: lightBlue,
  [colorThemes.dark]: lightBlue
};
const toggleSwitchTrackToggledOn = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const toggleSwitchTrackToggledOff = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const primaryTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const placeholderTextColor = {
  [colorThemes.light]: "rgba(31,31,31, 0.5)",
  [colorThemes.dark]: "rgba(247,244,242, 0.5)"
};
const eyeCatchingBg = primaryTextColor;
const eyeCatchingBgShadow = primaryTextColor;
const dropdownItemColor = {
  [colorThemes.light]: primaryTextColor.light,
  [colorThemes.dark]: primaryTextColor.light
};
const lightThemePrimaryTextColor = {
  [colorThemes.light]: primaryTextColor.light,
  [colorThemes.dark]: primaryTextColor.light
};
const darkThemePrimaryTextColor = {
  [colorThemes.light]: primaryTextColor.dark,
  [colorThemes.dark]: primaryTextColor.dark
};
const primaryDropdownTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const labelTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: cream
};
const communityCountAvatarBgColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const secondaryTextColor = {
  [colorThemes.light]: "rgba(31,31,31, 0.5)",
  [colorThemes.dark]: "rgba(247,244,242, 0.5)"
};
const inactiveTextColor = primaryTextColor;
const headingTextColor = primaryTextColor;
const thoughtBannerTextColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: white
};
const coloredBgTextColor = {
  [colorThemes.light]: white,
  [colorThemes.dark]: white
};
const inputTextColor = primaryTextColor;
const inputActiveTextColor = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const errorTextColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const warningTextColor = {
  [colorThemes.light]: orange,
  [colorThemes.dark]: yellow
};
const warning = {
  [colorThemes.light]: orange,
  [colorThemes.dark]: yellow
};
const defaultAvatarBg = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: yellow
};
const communityAvatarBg = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const defaultAvatarText = {
  [colorThemes.light]: white,
  [colorThemes.dark]: charcoal
};
const headerNavBg = {
  [colorThemes.light]: cream,
  [colorThemes.dark]: charcoal
};
const navBarBg = {
  [colorThemes.light]: white,
  [colorThemes.dark]: charcoal
};
const navBarBgShadow = componentBg;
const frameColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const topFrameColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const bottomFrameColor = {
  [colorThemes.light]: white,
  [colorThemes.dark]: charcoal
};
const darkThemeTopFrameColor = {
  [colorThemes.light]: navBarBg.dark,
  [colorThemes.dark]: navBarBg.dark
};
const darkThemeBottomFrameColor = darkThemeTopFrameColor;
const borderAccent = {
  [colorThemes.light]: element.borderLight,
  [colorThemes.dark]: element.borderDark,
  [colorThemes.light]: element.borderLight
};
const tableBorder = bgColor;
const darkerBorderAccent = borderAccent;
const inputBorderAccent = borderAccent;
const infoIcon = primaryTextColor;
const searchIconColor = activeFooterNavItemColor;
const navBarBottomBorder = borderAccent;
const cardShadow = {
  [colorThemes.light]: "transparent",
  [colorThemes.dark]: "transparent"
};
const buttonShadow = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: white
};
const successColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const successHighlight = successColor;
const successContrast = successColor;
const failureColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const fireColor = {
  [colorThemes.light]: orange,
  [colorThemes.dark]: orange
};
const increaseColorDark = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const decreaseColorDark = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const increaseColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const decreaseColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const buyColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const sellColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const ctlBannerBg = {
  [colorThemes.light]: cream,
  [colorThemes.dark]: charcoal
};
const thoughtBubbleColor = bgColor;
const thoughtEmbeddedLinkBgColor = primaryTextColor;
const proColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const conColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const agreeColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const disagreeColor = {
  [colorThemes.light]: brightRed,
  [colorThemes.dark]: brightRed
};
const neutralColor = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const primaryBtnColor = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const primaryBtnColorAlt = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: charcoal
};
const feedFilterTagBg = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: cream
};
const feedFilterTagText = {
  [colorThemes.light]: cream,
  [colorThemes.dark]: charcoal
};
const secondaryBtnColor = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: charcoal
};
const secondaryBtnTextColor = {
  [colorThemes.light]: white,
  [colorThemes.dark]: white
};
const primaryBtnTextColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const disabledBtnColor = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const disabledBtnTextColor = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const linkColor = {
  [colorThemes.light]: blue,
  [colorThemes.dark]: yellow
};
const linkColorAlt = primaryTextColor;
const thoughtBannerIconColor = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const linkColorLowContrast = secondaryTextColor;
const chartAxisColor = {
  [colorThemes.light]: "rgba(241,241,241,0.4)",
  [colorThemes.dark]: "rgba(77,77,77,0.4)"
};
const loadingIcon = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const refreshIndicatorIOS = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const modalTrayActionRowBg = {
  [colorThemes.light]: lighterGrey,
  [colorThemes.dark]: lighterGrey
};
const modalTrayBg = {
  [colorThemes.light]: osGrey,
  [colorThemes.dark]: osGrey
};
const blueGreenGradient = {
  [colorThemes.light]: [navy, green, green],
  [colorThemes.dark]: [navy, green, green]
};
const haloGradient = {
  [colorThemes.light]: [purple, charcoal, yellow],
  [colorThemes.dark]: [yellow, oak, purple]
};
const whiteFixed = {
  [colorThemes.light]: white,
  [colorThemes.dark]: white
};
const depositPickerButtonBg = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const depositPickerButtonText = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const depositPickerSelectedButtonTextColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: charcoal
};
const depositPickerSelectedButtonBg = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: oak
};
const moneyColor = {
  [colorThemes.light]: green,
  [colorThemes.dark]: green
};
const nvstrRewardCardFront = {
  [colorThemes.light]: purple,
  [colorThemes.dark]: yellow
};
const nvstrRewardCardBack = componentBg;
const nvstrRedeemableRewardCard = eyeCatchingBg;
const nvstrRedeemableRewardCardStripe = {
  [colorThemes.light]: silver,
  [colorThemes.dark]: silver
};
const nvstrReferralRewardProbability = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const nvstrRewardValueColor = {
  [colorThemes.light]: brightGreen,
  [colorThemes.dark]: brightGreen
};
const counterBgColor = primaryBtnColor;
const counterTextColor = {
  [colorThemes.light]: primaryTextColor.dark,
  [colorThemes.dark]: primaryTextColor.light
};
const rewardsIconColor = {
  [colorThemes.light]: oak,
  [colorThemes.dark]: oak,
  [colorThemes.light]: white
};
const transparent = {
  [colorThemes.light]: "rgba(255,255,255,0)",
  [colorThemes.dark]: "rgba(0,0,0,0)"
};
const forceCharcoal = {
  [colorThemes.light]: charcoal,
  [colorThemes.dark]: charcoal
};
const bgAccentColor = {
  [colorThemes.light]: "rgba(31,31,31, 0.05)",
  [colorThemes.dark]: "rgba(247,244,242, 0.05)"
};
const TornadoItemColors = {
  [ELEMENT_COLOR_NAMES.nvstrRewardCardFront]: nvstrRewardCardFront,
  [ELEMENT_COLOR_NAMES.nvstrRewardCardBack]: nvstrRewardCardBack,
  [ELEMENT_COLOR_NAMES.nvstrReferralRewardProbability]: nvstrReferralRewardProbability,
  [ELEMENT_COLOR_NAMES.nvstrRewardValueColor]: nvstrRewardValueColor,
  [ELEMENT_COLOR_NAMES.nvstrRedeemableRewardCard]: nvstrRedeemableRewardCard,
  [ELEMENT_COLOR_NAMES.nvstrRedeemableRewardCardStripe]: nvstrRedeemableRewardCardStripe,
  [ELEMENT_COLOR_NAMES.rewardsIconColor]: rewardsIconColor,
  [ELEMENT_COLOR_NAMES.counterBgColor]: counterBgColor,
  [ELEMENT_COLOR_NAMES.counterTextColor]: counterTextColor,
  [ELEMENT_COLOR_NAMES.white]: whiteFixed,
  [ELEMENT_COLOR_NAMES.statusBarColor]: statusBarColor,
  [ELEMENT_COLOR_NAMES.statusBarContent]: statusBarContent,
  [ELEMENT_COLOR_NAMES.bgColor]: bgColor,
  [ELEMENT_COLOR_NAMES.bgAccentColor]: bgAccentColor,
  [ELEMENT_COLOR_NAMES.bgBorderShadow]: bgBorderShadow,
  [ELEMENT_COLOR_NAMES.darkThemeBgColor]: darkThemeBgColor,
  [ELEMENT_COLOR_NAMES.componentBg]: componentBg,
  [ELEMENT_COLOR_NAMES.componentBgFullOpacity]: componentBgFullOpacity,
  [ELEMENT_COLOR_NAMES.componentBgHighlight]: componentBgHighlight,
  [ELEMENT_COLOR_NAMES.launchBg]: launchBg,
  [ELEMENT_COLOR_NAMES.disabledBg]: disabledBg,
  [ELEMENT_COLOR_NAMES.overlayBg]: overlayBg,
  [ELEMENT_COLOR_NAMES.eyeCatchingBgTextColor]: eyeCatchingBgTextColor,
  [ELEMENT_COLOR_NAMES.eyeCatchingBg]: eyeCatchingBg,
  [ELEMENT_COLOR_NAMES.eyeCatchingBgShadow]: eyeCatchingBgShadow,
  [ELEMENT_COLOR_NAMES.primaryTextColor]: primaryTextColor,
  [ELEMENT_COLOR_NAMES.placeholderTextColor]: placeholderTextColor,
  [ELEMENT_COLOR_NAMES.lightThemePrimaryTextColor]: lightThemePrimaryTextColor,
  [ELEMENT_COLOR_NAMES.dropdownItemColor]: dropdownItemColor,
  [ELEMENT_COLOR_NAMES.darkThemePrimaryTextColor]: darkThemePrimaryTextColor,
  [ELEMENT_COLOR_NAMES.primaryDropdownTextColor]: primaryDropdownTextColor,
  [ELEMENT_COLOR_NAMES.communityCountAvatarBgColor]: communityCountAvatarBgColor,
  [ELEMENT_COLOR_NAMES.secondaryTextColor]: secondaryTextColor,
  [ELEMENT_COLOR_NAMES.inactiveTextColor]: inactiveTextColor,
  [ELEMENT_COLOR_NAMES.headingTextColor]: headingTextColor,
  [ELEMENT_COLOR_NAMES.thoughtBannerTextColor]: thoughtBannerTextColor,
  [ELEMENT_COLOR_NAMES.coloredBgTextColor]: coloredBgTextColor,
  [ELEMENT_COLOR_NAMES.eyeCatchingTextColor]: eyeCatchingTextColor,
  [ELEMENT_COLOR_NAMES.labelTextColor]: labelTextColor,
  [ELEMENT_COLOR_NAMES.inputTextColor]: inputTextColor,
  [ELEMENT_COLOR_NAMES.inputActiveTextColor]: inputActiveTextColor,
  [ELEMENT_COLOR_NAMES.errorTextColor]: errorTextColor,
  [ELEMENT_COLOR_NAMES.warningTextColor]: warningTextColor,
  [ELEMENT_COLOR_NAMES.borderAccent]: borderAccent,
  [ELEMENT_COLOR_NAMES.tableBorder]: tableBorder,
  [ELEMENT_COLOR_NAMES.darkerBorderAccent]: darkerBorderAccent,
  [ELEMENT_COLOR_NAMES.inputBorderAccent]: inputBorderAccent,
  [ELEMENT_COLOR_NAMES.infoIcon]: infoIcon,
  [ELEMENT_COLOR_NAMES.defaultAvatarBg]: defaultAvatarBg,
  [ELEMENT_COLOR_NAMES.communityAvatarBg]: communityAvatarBg,
  [ELEMENT_COLOR_NAMES.defaultAvatarText]: defaultAvatarText,
  [ELEMENT_COLOR_NAMES.headerNavBg]: headerNavBg,
  [ELEMENT_COLOR_NAMES.navBarBg]: navBarBg,
  [ELEMENT_COLOR_NAMES.navBarBgShadow]: navBarBgShadow,
  [ELEMENT_COLOR_NAMES.navBarBottomBorder]: navBarBottomBorder,
  [ELEMENT_COLOR_NAMES.cardShadow]: cardShadow,
  [ELEMENT_COLOR_NAMES.buttonShadow]: buttonShadow,
  [ELEMENT_COLOR_NAMES.increaseColor]: increaseColor,
  [ELEMENT_COLOR_NAMES.decreaseColor]: decreaseColor,
  [ELEMENT_COLOR_NAMES.neutralColor]: neutralColor,
  [ELEMENT_COLOR_NAMES.buyColor]: buyColor,
  [ELEMENT_COLOR_NAMES.sellColor]: sellColor,
  [ELEMENT_COLOR_NAMES.ctlBannerBg]: ctlBannerBg,
  [ELEMENT_COLOR_NAMES.thoughtBubbleColor]: thoughtBubbleColor,
  [ELEMENT_COLOR_NAMES.thoughtEmbeddedLinkBgColor]: thoughtEmbeddedLinkBgColor,
  [ELEMENT_COLOR_NAMES.thoughtBannerIconColor]: thoughtBannerIconColor,
  [ELEMENT_COLOR_NAMES.proColor]: proColor,
  [ELEMENT_COLOR_NAMES.conColor]: conColor,
  [ELEMENT_COLOR_NAMES.agreeColor]: agreeColor,
  [ELEMENT_COLOR_NAMES.disagreeColor]: disagreeColor,
  [ELEMENT_COLOR_NAMES.increaseColorDark]: increaseColorDark,
  [ELEMENT_COLOR_NAMES.decreaseColorDark]: decreaseColorDark,
  [ELEMENT_COLOR_NAMES.moneyColor]: moneyColor,
  [ELEMENT_COLOR_NAMES.successColor]: successColor,
  [ELEMENT_COLOR_NAMES.successHighlight]: successHighlight,
  [ELEMENT_COLOR_NAMES.successContrast]: successContrast,
  [ELEMENT_COLOR_NAMES.failureColor]: failureColor,
  [ELEMENT_COLOR_NAMES.fireColor]: fireColor,
  [ELEMENT_COLOR_NAMES.primaryBtnColor]: primaryBtnColor,
  [ELEMENT_COLOR_NAMES.primaryBtnTextColor]: primaryBtnTextColor,
  [ELEMENT_COLOR_NAMES.primaryBtnColorAlt]: primaryBtnColorAlt,
  [ELEMENT_COLOR_NAMES.secondaryBtnColor]: secondaryBtnColor,
  [ELEMENT_COLOR_NAMES.secondaryBtnTextColor]: secondaryBtnTextColor,
  [ELEMENT_COLOR_NAMES.disabledBtnTextColor]: disabledBtnTextColor,
  [ELEMENT_COLOR_NAMES.disabledBtnColor]: disabledBtnColor,
  [ELEMENT_COLOR_NAMES.feedFilterTagBg]: feedFilterTagBg,
  [ELEMENT_COLOR_NAMES.feedFilterTagText]: feedFilterTagText,
  [ELEMENT_COLOR_NAMES.linkColor]: linkColor,
  [ELEMENT_COLOR_NAMES.linkColorAlt]: linkColorAlt,
  [ELEMENT_COLOR_NAMES.linkColorLowContrast]: linkColorLowContrast,
  [ELEMENT_COLOR_NAMES.searchIconColor]: searchIconColor,
  [ELEMENT_COLOR_NAMES.chartAxisColor]: chartAxisColor,
  [ELEMENT_COLOR_NAMES.loadingIcon]: loadingIcon,
  [ELEMENT_COLOR_NAMES.refreshIndicatorIOS]: refreshIndicatorIOS,
  [ELEMENT_COLOR_NAMES.blueGreenGradient]: blueGreenGradient,
  [ELEMENT_COLOR_NAMES.haloGradient]: haloGradient,
  [ELEMENT_COLOR_NAMES.modalTrayBg]: modalTrayBg,
  [ELEMENT_COLOR_NAMES.modalTrayActionRowBg]: modalTrayActionRowBg,
  [ELEMENT_COLOR_NAMES.warning]: warning,
  [ELEMENT_COLOR_NAMES.headerNavItemColor]: headerNavItemColor,
  [ELEMENT_COLOR_NAMES.activeFooterNavItemColor]: activeFooterNavItemColor,
  [ELEMENT_COLOR_NAMES.inactiveFooterNavItemColor]: inactiveFooterNavItemColor,
  [ELEMENT_COLOR_NAMES.inputBg]: inputBg,
  [ELEMENT_COLOR_NAMES.inputIconColor]: inputIconColor,
  [ELEMENT_COLOR_NAMES.frameColor]: frameColor,
  [ELEMENT_COLOR_NAMES.topFrameColor]: topFrameColor,
  [ELEMENT_COLOR_NAMES.bottomFrameColor]: bottomFrameColor,
  [ELEMENT_COLOR_NAMES.darkThemeTopFrameColor]: darkThemeTopFrameColor,
  [ELEMENT_COLOR_NAMES.darkThemeBottomFrameColor]: darkThemeBottomFrameColor,
  [ELEMENT_COLOR_NAMES.toggleSwitchTrackToggledOn]: toggleSwitchTrackToggledOn,
  [ELEMENT_COLOR_NAMES.eyeCatchingActionButton]: eyeCatchingActionButton,
  [ELEMENT_COLOR_NAMES.toggleSwitchTrackToggledOff]: toggleSwitchTrackToggledOff,
  [ELEMENT_COLOR_NAMES.depositPickerButtonBg]: depositPickerButtonBg,
  [ELEMENT_COLOR_NAMES.depositPickerButtonText]: depositPickerButtonText,
  [ELEMENT_COLOR_NAMES.depositPickerSelectedButtonBg]: depositPickerSelectedButtonBg,
  [ELEMENT_COLOR_NAMES.depositPickerSelectedButtonTextColor]: depositPickerSelectedButtonTextColor,
  [ELEMENT_COLOR_NAMES.transparent]: transparent,
  [ELEMENT_COLOR_NAMES.forceCharcoal]: forceCharcoal
};
class _ColorTheme {
  constructor(defaultColorThemeName2) {
    __publicField(this, "_setCurrentColorThemeName", (newColorThemeName) => {
      return this._currentColorThemeName = newColorThemeName;
    });
    __publicField(this, "onColorThemeChange", (newColorThemeName) => {
      if (!Object.values(colorThemes).includes(newColorThemeName)) {
        console.error("cannot change to non-defined color theme: " + (newColorThemeName || "nullish"));
        return;
      }
      this._setCurrentColorThemeName(newColorThemeName);
    });
    __publicField(this, "_buildColorThemes", () => {
      const light = this._buildColorTheme(colorThemes.light);
      const dark = this._buildColorTheme(colorThemes.dark);
      return {
        [colorThemes.light]: light,
        [colorThemes.dark]: dark
      };
    });
    __publicField(this, "_buildColorTheme", (key) => {
      const theme = {};
      const keys = Object.keys(TornadoItemColors);
      keys.forEach((k) => {
        theme[k] = TornadoItemColors[k][key];
      });
      return theme;
    });
    if (!defaultColorThemeName2) {
      console.error("defaultColorThemeName param missing in _ColorTheme creation");
    }
    this._colorThemes = this._buildColorThemes();
    this._currentColorThemeName = defaultColorThemeName2;
  }
}
const defaultColorThemeName = colorThemes.dark;
const ColorTheme = new _ColorTheme(defaultColorThemeName);
const parseBreakpointToInt = (v) => parseFloat(v.split("px")[0]);
const getScreenSize = () => {
  const width = window.innerWidth;
  if (width <= parseBreakpointToInt(breakpoints.mobile))
    return SCREEN_SIZES.mobile;
  if (width <= parseBreakpointToInt(breakpoints.desktop))
    return SCREEN_SIZES.tablet;
  return SCREEN_SIZES.desktop;
};
const useScreenSize = () => {
  const [screenSize, setScreenSize] = React.useState(getScreenSize());
  const setScreenSizeState = React.useCallback(
    (newScreenSize) => {
      if (newScreenSize !== screenSize) {
        setScreenSize(newScreenSize);
      }
    },
    [screenSize]
  );
  React.useEffect(() => {
    const handleResize = () => {
      setScreenSizeState(getScreenSize());
    };
    window.addEventListener("resize", handleResize, true);
    return () => window.removeEventListener("resize", handleResize, true);
  }, [setScreenSizeState]);
  return screenSize;
};
const LAYOUT = {
  top: "flex-start",
  left: "flex-start",
  right: "flex-end",
  center: "center",
  bottom: "flex-end"
};
const Width$1 = css`
  width: ${(props) => props.width};
`;
const Height$1 = css`
  height: ${(props) => props.height ? props.height : "auto"};
`;
const HorizontalAlign$1 = css`
  justify-content: ${(props) => props.hAlign && LAYOUT[props.hAlign] ? LAYOUT[props.hAlign] : LAYOUT.left};
`;
const VerticalAlign$1 = css`
  align-items: ${(props) => props.vAlign && LAYOUT[props.vAlign] ? LAYOUT[props.vAlign] : "stretch"};
`;
const Row = styled("div")`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  ${(props) => props.shrink ? Shrink : ""};
  ${(props) => props.wrap ? Wrap : ""};

  ${(props) => props.width ? Width$1 : ""};
  ${(props) => props.height ? Height$1 : ""};

  ${(props) => props.hAlign ? HorizontalAlign$1 : ""};
  ${(props) => props.vAlign ? VerticalAlign$1 : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.borderStyle ? BorderStyle : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.background ? Background : ""};

  ${(props) => props.left ? Left : ""};
  ${(props) => props.top ? Top : ""};
`;
const Width = css`
  flex-basis: ${(props) => props.width};
`;
const Height = css`
  height: ${(props) => props.height};
`;
const HorizontalAlign = css`
  align-items: ${(props) => props.hAlign && LAYOUT[props.hAlign] ? LAYOUT[props.hAlign] : "stretch"};
`;
const VerticalAlign = css`
  justify-content: ${(props) => props.vAlign && LAYOUT[props.vAlign] ? LAYOUT[props.vAlign] : "stretch"};
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  ${(props) => props.shrink ? Shrink : ""};
  ${(props) => props.wrap ? Wrap : ""};

  ${(props) => props.width ? Width : ""};
  ${(props) => props.height ? Height : ""};

  ${(props) => props.hAlign ? HorizontalAlign : ""};
  ${(props) => props.vAlign ? VerticalAlign : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.borderStyle ? BorderStyle : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.background ? Background : ""};
  ${(props) => props.left ? Left : ""};
  ${(props) => props.top ? Top : ""};
`;
const Place = styled("div")`
  position: relative;
  top: ${(props) => props.top || "auto"};
  bottom: ${(props) => props.bottom || "auto"};
  right: ${(props) => props.right || "auto"};
  left: ${(props) => props.left || "auto"};
  display: ${(props) => props.display || "block"};
  height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "auto"};
  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
`;
const Wrapper$r = styled.div`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Close = ({ width, color }) => {
  const ratio = 13 / 12;
  const height = width / ratio;
  return /* @__PURE__ */ React.createElement(Wrapper$r, {
    color
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M12.3327 1.34163L11.1577 0.166626L6.49935 4.82496L1.84102 0.166626L0.666016 1.34163L5.32435 5.99996L0.666016 10.6583L1.84102 11.8333L6.49935 7.17496L11.1577 11.8333L12.3327 10.6583L7.67435 5.99996L12.3327 1.34163Z"
  })));
};
const animation = keyframes`
  0% {
    transform: translateY(20px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
`;
const ModalPosition = styled.div`
  margin-top: 50px;

  height: 100vh;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 101;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 625px) {
    margin-top: 16px;
  }
`;
const ModalStyle = styled.div`
  max-width: 570px;
  height: ${({ height }) => height || "500px"};

  position: relative;
  z-index: 102;

  border-radius: 5px;
  background: ${({ isDarkTheme }) => isDarkTheme ? colorPalette.primary.charcoal : colorPalette.primary.oak};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  overflow: auto;

  -webkit-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  -moz-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  -o-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
`;
const BackgroundStyle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  border-radius: 2px;
`;
const DismissButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
`;
const Modal = ({ children, isAnimated, onDismiss, modalProps }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Overlay, {
    isAnimated,
    onDismiss
  }), /* @__PURE__ */ React.createElement(ModalPosition, null, /* @__PURE__ */ React.createElement(ModalStyle, {
    isAnimated,
    ...modalProps
  }, children, /* @__PURE__ */ React.createElement(DismissButton, {
    onClick: onDismiss
  }, /* @__PURE__ */ React.createElement(Close, {
    width: 16
  })), /* @__PURE__ */ React.createElement(BackgroundStyle, null))));
};
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 0.9;
  }
`;
const Wrapper$q = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  opacity: 0.9;
  background-color: ${({ isDarkTheme }) => isDarkTheme ? colorPalette.primary.charcoal : colorPalette.primary.oak};

  -webkit-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  -moz-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  -o-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
`;
const Overlay = ({ isAnimated, onDismiss }) => {
  return /* @__PURE__ */ React.createElement(Wrapper$q, {
    isAnimated,
    onClick: onDismiss
  });
};
const convertToPx = (v) => `${v}px`;
const Spacing = ({
  name: name2,
  horizontal,
  vertical,
  all,
  top,
  bottom,
  left,
  right,
  style: additionalStyling,
  children
}) => {
  let style2 = {};
  if (all) {
    style2.paddingLeft = convertToPx(all);
    style2.paddingRight = convertToPx(all);
    style2.paddingTop = convertToPx(all);
    style2.paddingBottom = convertToPx(all);
  }
  if (horizontal) {
    style2.paddingLeft = convertToPx(horizontal);
    style2.paddingRight = convertToPx(horizontal);
  }
  if (vertical) {
    style2.paddingTop = convertToPx(vertical);
    style2.paddingBottom = convertToPx(vertical);
  }
  if (top) {
    style2.paddingTop = convertToPx(top);
  }
  if (bottom) {
    style2.paddingBottom = convertToPx(bottom);
  }
  if (left) {
    style2.paddingLeft = convertToPx(left);
  }
  if (right) {
    style2.paddingRight = convertToPx(right);
  }
  return /* @__PURE__ */ React.createElement("div", {
    name: name2,
    style: { ...style2, ...additionalStyling }
  }, children);
};
const Container = (props) => {
  const {
    name: name2,
    style: additionalStyling,
    children,
    height,
    width,
    fullWidth,
    maxWidth,
    maxHeight,
    textCenter,
    gap,
    borderRadius,
    flex,
    flexWrap,
    centerAll,
    verticallyCenter,
    spaceBetween,
    spaceAround,
    row,
    column,
    relative,
    columnCenter,
    alignCenter,
    alignRight,
    background,
    border,
    borderBottom,
    zIndex,
    debugBorder
  } = props;
  const style2 = {};
  if (background) {
    style2.backgroundColor = background;
  }
  if (textCenter) {
    style2.textAlign = "center";
  }
  if (border) {
    style2.borderWidth = 1;
    style2.borderColor = border;
  }
  if (debugBorder) {
    style2.borderWidth = 1;
    style2.borderStyle = "solid";
    style2.borderColor = typeof debugBorder === "string" ? debugBorder : "#e1a";
  }
  if (borderBottom) {
    style2.borderBottomWidth = 1;
    style2.borderBottomColor = borderBottom;
  }
  if (gap) {
    style2.gap = gap;
  }
  if (isInteger(borderRadius)) {
    style2.borderRadius = borderRadius;
  }
  if (isInteger(flex)) {
    style2.display = "flex";
    style2.flex = flex;
  }
  if (flexWrap) {
    style2.flexWrap = "wrap";
  }
  if (isInteger(height)) {
    style2.height = height;
  }
  if (isInteger(width)) {
    style2.width = width;
  }
  if (fullWidth) {
    style2.width = "100%";
  }
  if (isInteger(maxWidth)) {
    style2.maxWidth = maxWidth;
  }
  if (isInteger(maxHeight)) {
    style2.maxHeight = maxHeight;
  }
  if (isInteger(zIndex)) {
    style2.zIndex = zIndex;
  }
  if (column) {
    style2.display = "flex";
    style2.flexDirection = "column";
  }
  if (centerAll) {
    style2.display = "flex";
    style2.alignItems = "center";
    style2.justifyContent = "center";
  }
  if (verticallyCenter) {
    style2.display = "flex";
    style2.flexDirection = "row";
    style2.alignItems = "center";
  }
  if (columnCenter) {
    style2.display = "flex";
    style2.flexDirection = "column";
    style2.alignItems = "center";
    style2.justifyContent = "flex-start";
  }
  if (alignCenter) {
    style2.display = "flex";
    style2.flexDirection = "row";
    style2.justifyContent = "center";
  }
  if (row) {
    style2.display = "flex";
    style2.flexDirection = "row";
  }
  if (alignRight) {
    style2.flexDirection = column ? "column" : "row";
    style2[column ? "alignItems" : "justifyContent"] = "flex-end";
  }
  if (spaceBetween) {
    style2.justifyContent = "space-between";
  }
  if (spaceAround) {
    style2.justifyContent = "space-around";
  }
  if (relative) {
    style2.position = "relative";
  }
  return /* @__PURE__ */ React.createElement(Spacing, {
    ...props,
    style: { ...style2, ...additionalStyling || {} }
  }, children);
};
const Wrapper$p = styled.div`
  max-width: ${({ maxWidth }) => maxWidth || "95%"};
  width: ${({ width }) => width || "800px"};
  position: relative;
  margin: 12px auto;
  padding: ${({ noPadding }) => noPadding ? "0px" : " 16px 24px"};
  border-radius: 5px;
  text-align: left;
  cursor: default;

  background: ${({ theme, transparentBackground }) => transparentBackground ? "transparent" : theme.screenSize === SCREEN_SIZES.mobile ? theme.themeColors.componentNoOpacity : theme.themeColors.component};
  color: ${({ theme }) => theme.themeColors.text};

  ${({ expandHeight }) => expandHeight ? "flex: 0 1 auto; display: flex; justify-content: center; height: unset;" : ""}
  min-height: ${({ minHeight }) => minHeight || "min-content"};
  height: ${({ fullHeight, height }) => fullHeight ? "calc(100vh - 60px)" : height || "min-content"};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;

    max-width: ${({ width }) => width || "100%"};
    width: 100%;
    height: ${({ fullHeight, expandHeight, height }) => height || (fullHeight || expandHeight ? "calc(100vh - 64px)" : "unset")}; // 64px === nav height
    max-height: ${({ expandHeight }) => expandHeight ? "800px" : "unset"}; // 64px === nav height

    ${({ theme, mobileTransparentBackground }) => mobileTransparentBackground && theme.screenSize === SCREEN_SIZES.mobile ? "background: " + theme.themeColors.componentNoOpacity + ";" : ""};
  }

  @media (max-width: 430px) {
    padding: ${({ noPadding }) => noPadding ? "0px" : " 16px"};
  }
  @media (max-width: 340px) {
    padding: ${({ noPadding }) => noPadding ? "0px" : " 8px"};
  }
`;
const Page = (props) => {
  const { children } = props;
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []);
  return /* @__PURE__ */ React.createElement(Wrapper$p, {
    ...props
  }, children);
};
const Text = styled("div")`
  box-sizing: border-box;
  line-height: 160%;
  ${(props) => props.lineHeight ? LineHeight : ""};
  ${(props) => props.letterSpacing ? LetterSpacing : ""};
  ${(props) => props.fontSize ? FontSize : ""};
  ${(props) => props.fontWeight ? FontWeight : ""};
  ${(props) => props.fontFamily ? FontFamily : ""};
  ${(props) => props.fontStyle ? FontStyle : ""};
  ${(props) => props.color ? Color : ""};
  ${(props) => props.opacity ? Opacity : ""};

  ${(props) => props.textAlign ? TextAlign : ""};
  ${(props) => props.textTransform ? TextTransform : ""};
  ${(props) => props.userSelect ? UserSelect : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.cursor ? Cursor : ""};
`;
const Wrapper$o = styled.span`
  box-sizing: border-box;
  line-height: 160%;

  ${(props) => props.lineHeight ? LineHeight : ""};
  ${(props) => props.letterSpacing ? LetterSpacing : ""};
  ${(props) => props.fontSize ? FontSize : ""};
  ${(props) => props.bold ? "font-weight: 800;" : props.thin ? "font-weight: 100;" : props.fontWeight ? FontWeight : ""};
  ${(props) => props.fontStyle ? FontStyle : ""};

  ${(props) => props.opacity ? Opacity : ""};

  ${(props) => props.textAlign ? TextAlign : ""};
  ${(props) => props.textTransform ? TextTransform : ""};
  ${(props) => props.userSelect ? UserSelect : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.truncate ? "display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" : ""};

  color: ${({ color, isLowContrast, theme }) => isLowContrast ? theme.themeColors.secondaryText : color || theme.themeColors.text};
  ${(props) => props.fontFamily ? FontFamily : ""};

  * {
    color: ${({ color, isLowContrast, theme }) => isLowContrast ? theme.themeColors.secondaryText : color || theme.themeColors.text};
    ${(props) => props.fontFamily ? FontFamily : ""};
    ${(props) => props.fontSize ? FontSize : ""};
    ${(props) => props.letterSpacing ? LetterSpacing : ""};
    ${(props) => props.lineHeight ? LineHeight : ""};
    ${(props) => props.truncate ? "display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" : ""};
  }
`;
const BaseText = (props) => {
  const {
    isLowContrast,
    isSmall,
    isLarge,
    fontSettings: props_fontSettings,
    uppercase,
    center,
    bold,
    truncate,
    children
  } = props;
  const theme = React.useContext(ThemeContext);
  const screenSize = (theme == null ? void 0 : theme.screenSize) || null;
  const isMobile = screenSize === SCREEN_SIZES.mobile;
  const fontSettings = props_fontSettings || { small: {}, standard: {} };
  const fontSettingsStyleProps = (isSmall || isMobile) && !isLarge ? fontSettings.small : fontSettings.standard;
  const aliasedStyles = {};
  if (uppercase) {
    aliasedStyles.textTransform = "uppercase";
  }
  if (center) {
    aliasedStyles.textAlign = "center";
  }
  if (bold) {
    return /* @__PURE__ */ React.createElement(Wrapper$o, {
      className: "base-text",
      ...fontSettingsStyleProps,
      ...aliasedStyles,
      ...props
    }, /* @__PURE__ */ React.createElement("b", null, children));
  }
  return /* @__PURE__ */ React.createElement(Wrapper$o, {
    className: "base-text",
    ...fontSettingsStyleProps,
    ...aliasedStyles,
    ...props
  }, children);
};
const Wrapper$n = styled.span`
  * {
    color: ${({ value, theme }) => value === 0 ? theme.themeColors.neutral : value > 0 ? theme.themeColors.positive : theme.themeColors.negative};
  }
`;
const ValueChangeText = ({ value, children }) => {
  return /* @__PURE__ */ React.createElement(Wrapper$n, {
    value
  }, children);
};
const defineFontSettings = (small, standard) => {
  return {
    small,
    standard
  };
};
const Body1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "14px", lineHeight: "20px" },
    { fontSize: "18px", lineHeight: "24px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body2 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "16px", lineHeight: "24px" },
    { fontSize: "20px", lineHeight: "28px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "12px", lineHeight: "18px" },
    { fontSize: "16px", lineHeight: "24px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body4 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "14px", lineHeight: "18px" },
    { fontSize: "16px", lineHeight: "18px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "12px", lineHeight: "18px" },
    { fontSize: "14px", lineHeight: "18px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body6 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "18px", lineHeight: "24px" },
    { fontSize: "24px", lineHeight: "28px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body7 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "10px", lineHeight: "14px" },
    { fontSize: "12px", lineHeight: "14px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body8 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "9px", lineHeight: "12px" },
    { fontSize: "12px", lineHeight: "14px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body9 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "14px", lineHeight: "18px" },
    { fontSize: "14px", lineHeight: "18px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Body10 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "12px", lineHeight: "14px" },
    { fontSize: "14px", lineHeight: "18px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, children);
};
const Wrapper$m = styled.h1`
  font-size: inherit;
  line-height: inherit;
`;
const H1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "36px", lineHeight: "40px", textCase: "uppercase" },
    { fontSize: "64px", lineHeight: "76px", textCase: "uppercase" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, /* @__PURE__ */ React.createElement(Wrapper$m, null, children));
};
const Wrapper$l = styled.h3`
  font-size: inherit;
  line-height: inherit;
`;
const H3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "24px", lineHeight: "36px", textCase: "uppercase" },
    { fontSize: "36px", lineHeight: "68px", textCase: "uppercase" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, /* @__PURE__ */ React.createElement(Wrapper$l, null, children));
};
const Wrapper$k = styled.h5`
  font-size: inherit;
  line-height: inherit;
`;
const H5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: "18px", lineHeight: "24px" },
    { fontSize: "24px", lineHeight: "36px" }
  );
  return /* @__PURE__ */ React.createElement(BaseText, {
    fontSettings,
    ...props
  }, /* @__PURE__ */ React.createElement(Wrapper$k, null, children));
};
const smallSize = css`
  svg {
    width: 150px;
  }
`;
const Wrapper$j = styled.div`
  ${(props) => props.isSmall ? smallSize : ""};
  g {
    fill: ${(props) => props.isDarkMode ? "#fff" : "#222"};
  }
`;
function LogoFull({ isDarkMode, isSmall }) {
  return /* @__PURE__ */ React.createElement(Wrapper$j, {
    isDarkMode,
    isSmall
  }, /* @__PURE__ */ React.createElement("svg", {
    width: 184,
    height: 21,
    viewBox: "0 0 184 21",
    className: "full-logo-tornado"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M45.674 4.201v16.542h-4.55V4.201h-8.723V0h21.982v4.201h-8.71zm29.118 7.304v.153c0 5.732-3.2 9.21-10.838 9.21-7.638 0-10.865-3.492-10.865-9.21v-.153c0-5.731 3.227-9.21 10.865-9.21 7.624 0 10.838 3.492 10.838 9.21zm-4.591.126v-.098c0-3.812-1.934-5.133-6.26-5.133-4.327 0-6.261 1.321-6.261 5.133v.098c0 3.812 1.934 5.133 6.26 5.133 4.327.014 6.26-1.307 6.26-5.133zm18.587-9.335c.64 0 .946.027 1.35.125v4.535c-3.103-.71-8.404-.556-8.404 2.337v11.45h-4.577V2.421h4.577v6.024c0-3.144 1.837-6.15 7.054-6.15zm8.25 5.954c0-3.005 1.836-5.954 7.331-5.954 5.273 0 8.348 2.518 8.348 7.373v11.074h-4.578V10.24c0-2.393-1.502-3.965-5.467-3.965-2.727 0-5.62.557-5.62 2.825v11.658h-4.578V2.421h4.577V8.25h-.014zm23.205.96h-4.633v-.098c0-4.354 3.59-6.816 9.642-6.816 6.775 0 9.766 2.03 9.766 6.942v11.505h-4.549v-4.535c0 1.878-1.962 4.66-7.61 4.66-5.217 0-8.097-1.224-8.097-4.813v-.223c0-5.398 6.97-5.273 15.707-6.51v-.029c0-2.142-1.113-3.158-5.398-3.158-3.534 0-4.842 1.016-4.842 3.005v.07h.014zm3.13 8.653c3.618 0 7.096-.375 7.096-2.462v-2.616c-8.473.946-11.116 1.405-11.116 3.033v.098c0 1.21.974 1.947 4.02 1.947zM154.606 0h4.55v20.743h-4.55V15.61c0 2.337-1.934 5.272-7.665 5.272-6.776 0-9.516-3.687-9.516-9.238v-.097c0-5.55 2.754-9.238 9.516-9.238 5.731 0 7.665 2.922 7.665 5.273V0zm-6.218 6.135c-4.272 0-6.386 1.35-6.386 5.398v.098c0 4.048 2.114 5.398 6.386 5.398 3.255 0 6.204-.46 6.204-2.296V8.417c.014-1.823-2.949-2.282-6.204-2.282zm34.85 5.37v.153c0 5.732-3.2 9.21-10.838 9.21-7.638 0-10.865-3.492-10.865-9.21v-.153c0-5.731 3.227-9.21 10.865-9.21 7.624 0 10.838 3.492 10.838 9.21zm-4.591.126v-.098c0-3.812-1.934-5.133-6.261-5.133s-6.26 1.321-6.26 5.133v.098c0 3.812 1.933 5.133 6.26 5.133 4.327.014 6.261-1.307 6.261-5.133zM14.872 20.743c-.139-.556-.626-1.071-1.21-1.725-1.586-1.753-3.604-6.233 1.655-9.057C19.964 7.471 24.792 4.438 26.628 0H11.756c.139.556.626 1.071 1.21 1.725 1.586 1.753 3.604 6.233-1.655 9.057C6.664 13.272 1.822 16.305 0 20.743h14.872z"
  }))));
}
const Wrapper$i = styled.div`
  g {
    fill: ${(props) => props.isDarkMode ? "#fff" : "black"};
  }

  @media (prefers-color-scheme: dark) {
    g {
      fill: #fff;
    }
  }
`;
function LogoShort({ isDarkMode, height, width }) {
  return /* @__PURE__ */ React.createElement(Wrapper$i, {
    isDarkMode
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: `0 0 59 51`
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M31.3589 51C31.0356 49.6297 29.8906 48.3508 28.5032 46.7457C24.7719 42.4522 20.0169 31.4378 32.4096 24.4821C43.3205 18.3485 54.6895 10.8969 59 0L27.6546 0C27.9779 1.37027 29.1228 2.64918 30.5103 4.25435C34.2416 8.54785 38.9966 19.5622 26.6039 26.5179C15.6795 32.6515 4.3105 40.1031 0 51L31.3589 51Z"
  }))));
}
const Wrapper$h = styled.div`
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  overflow: visible;
  margin: 12px 24px;
  width: 60px;
  height: 60px;
  & > svg {
    width: 45px;
    height: 45px;
  }

  & > svg {
    display: block;
    overflow: visible;
    animation-name: spin-cycle;
  }

  @keyframes spin-cycle {
    from {
      fill: ${({ theme }) => theme.themeColors.primaryCtaButton};
      transform: scale(1);
    }
    to {
      fill: rgba(255, 255, 255, 0);
      transform: scale(1);
    }
  }

  & > svg > * {
    transform: translate3d(0, 0, 0);
    transform-origin: center;
    animation-iteration-count: infinite;
    fill: rgba(255, 255, 255, 0.2);
    animation-name: spin-cycle;
    animation-duration: 0.8s;
  }
  & > svg > *:nth-of-type(8) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
  }
  & > svg > *:nth-of-type(7) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }
  & > svg > *:nth-of-type(6) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
  & > svg > *:nth-of-type(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
  }
  & > svg > *:nth-of-type(4) {
    -webkit-animation-delay: 0.5s;
    animation-delay: 0.5s;
  }
  & > svg > *:nth-of-type(3) {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  
  & > svg > *:nth-of-type(2) {
    -webkit-animation-delay: 0.7s;
    animation-delay: 0.7s;
  }
  & > svg > *:nth-of-type(1) {
    animation-delay: 0.8s;
  }
`;
function LoadingSpinner({ isDarkMode }) {
  return /* @__PURE__ */ React.createElement(Wrapper$h, {
    isDarkMode
  }, /* @__PURE__ */ React.createElement("svg", {
    viewBox: "156 -189 512 512"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M636 99h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32S653.7 99 636 99z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M547.8-23.5C535.2-11 515-11 502.5-23.5s-12.5-32.8 0-45.2l45.2-45.2c12.5-12.5 32.8-12.5 45.2 0s12.5 32.8 0 45.2L547.8-23.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M412-61c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64C444-75.3 429.7-61 412-61z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M276.2-23.5L231-68.8c-12.5-12.5-12.5-32.8 0-45.2s32.8-12.5 45.2 0l45.2 45.2c12.5 12.5 12.5 32.8 0 45.2S288.8-11 276.2-23.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M284 67c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64C269.7 35 284 49.3 284 67z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M276.2 248c-12.5 12.5-32.8 12.5-45.2 0 -12.5-12.5-12.5-32.8 0-45.2l45.2-45.2c12.5-12.5 32.8-12.5 45.2 0s12.5 32.8 0 45.2L276.2 248z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M412 323c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64C444 308.7 429.7 323 412 323z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M547.8 157.5l45.2 45.2c12.5 12.5 12.5 32.8 0 45.2 -12.5 12.5-32.8 12.5-45.2 0l-45.2-45.2c-12.5-12.5-12.5-32.8 0-45.2S535.2 145 547.8 157.5z"
  })));
}
const SVG$d = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Check$1 = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$d, {
    width,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5.4025 10.2565L1.37237 6.21402L0 7.58091L5.4025 13L17 1.36689L15.6373 0L5.4025 10.2565Z"
  }));
};
const SVG$c = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Check = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$c, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8.99984 0.666992C4.39984 0.666992 0.666504 4.40033 0.666504 9.00033C0.666504 13.6003 4.39984 17.3337 8.99984 17.3337C13.5998 17.3337 17.3332 13.6003 17.3332 9.00033C17.3332 4.40033 13.5998 0.666992 8.99984 0.666992ZM8.99984 15.667C5.32484 15.667 2.33317 12.6753 2.33317 9.00033C2.33317 5.32533 5.32484 2.33366 8.99984 2.33366C12.6748 2.33366 15.6665 5.32533 15.6665 9.00033C15.6665 12.6753 12.6748 15.667 8.99984 15.667ZM12.8248 5.31699L7.33317 10.8087L5.17484 8.65866L3.99984 9.83366L7.33317 13.167L13.9998 6.50033L12.8248 5.31699Z",
    fill: "#201F2C"
  }));
};
const Lock = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
  })));
};
const SVG$b = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Plus = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$b, {
    width,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
  }));
};
const SVG$a = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Delete = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$a, {
    width,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
  }));
};
const SVG$9 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Bank = () => {
  return /* @__PURE__ */ React.createElement(SVG$9, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z"
  }));
};
const SVG$8 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Shield = () => {
  return /* @__PURE__ */ React.createElement(SVG$8, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z"
  }));
};
const SVG$7 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Paper = () => {
  return /* @__PURE__ */ React.createElement(SVG$7, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"
  }));
};
const SVG$6 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const PlusCircle = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$6, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }));
};
const SVG$5 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const MinusCircle = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$5, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }));
};
const SVG$4 = styled.svg`
  path {
    fill: ${(props) => props.color || colorPalette.primary.charcoal};
  }
`;
const Warning = () => {
  return /* @__PURE__ */ React.createElement(SVG$4, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
  }));
};
const SVG$3 = styled.svg`
  path {
    fill: ${({ theme, color }) => {
  var _a;
  return color || ((_a = theme == null ? void 0 : theme.themeColors) == null ? void 0 : _a.text) || colorPalette.primary.charcoal;
}};
  }
`;
const Copy = () => {
  return /* @__PURE__ */ React.createElement(SVG$3, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
  }));
};
const SVG$2 = styled.svg`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const CaretUp = () => {
  return /* @__PURE__ */ React.createElement(SVG$2, {
    viewBox: "-1 -1 12 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 5.65687L0.550251 5.65687C0.104798 5.65687 -0.118284 5.1183 0.196699 4.80331L4.64645 0.353566C4.84171 0.158303 5.15829 0.158303 5.35355 0.353566L9.8033 4.80331C10.1183 5.1183 9.8952 5.65687 9.44975 5.65687L5 5.65687Z"
  }));
};
const SVG$1 = styled.svg`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const CaretDown = () => {
  return /* @__PURE__ */ React.createElement(SVG$1, {
    viewBox: "-1 -1 12 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 0.656854L9.44975 0.656854C9.8952 0.656854 10.1183 1.19543 9.8033 1.51041L5.35355 5.96015C5.15829 6.15542 4.84171 6.15542 4.64645 5.96015L0.196699 1.51041C-0.118283 1.19542 0.1048 0.656854 0.550253 0.656854L5 0.656854Z"
  }));
};
const SVG = styled.svg`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const Minus = () => {
  return /* @__PURE__ */ React.createElement(SVG, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M20 14H4V10H20V14Z"
  }));
};
const Calendar = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
  })));
};
const Compass = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M7,17L10.2,10.2L17,7L13.8,13.8L7,17M12,11.1A0.9,0.9 0 0,0 11.1,12A0.9,0.9 0 0,0 12,12.9A0.9,0.9 0 0,0 12.9,12A0.9,0.9 0 0,0 12,11.1M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z"
  })));
};
const Fire = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z"
  })));
};
const Heartbeat = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M7.5,4A5.5,5.5 0 0,0 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5A5.5,5.5 0 0,0 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5A1,1 0 0,0 2,13.5A1,1 0 0,0 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21A1,1 0 0,0 22,13.5A1,1 0 0,0 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z"
  })));
};
const Lightbulb = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M12,2A7,7 0 0,1 19,9C19,11.38 17.81,13.47 16,14.74V17A1,1 0 0,1 15,18H9A1,1 0 0,1 8,17V14.74C6.19,13.47 5,11.38 5,9A7,7 0 0,1 12,2M9,21V20H15V21A1,1 0 0,1 14,22H10A1,1 0 0,1 9,21M12,4A5,5 0 0,0 7,9C7,11.05 8.23,12.81 10,13.58V16H14V13.58C15.77,12.81 17,11.05 17,9A5,5 0 0,0 12,4Z"
  })));
};
const Microchip = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z"
  })));
};
const Money = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z"
  })));
};
const PercentSign = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4A3,3 0 0,0 4,7A3,3 0 0,0 7,10A3,3 0 0,0 10,7A3,3 0 0,0 7,4M17,14A3,3 0 0,0 14,17A3,3 0 0,0 17,20A3,3 0 0,0 20,17A3,3 0 0,0 17,14Z"
  })));
};
const Podcast = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17,18.25V21.5H7V18.25C7,16.87 9.24,15.75 12,15.75C14.76,15.75 17,16.87 17,18.25M12,5.5A6.5,6.5 0 0,1 18.5,12C18.5,13.25 18.15,14.42 17.54,15.41L16,14.04C16.32,13.43 16.5,12.73 16.5,12C16.5,9.5 14.5,7.5 12,7.5C9.5,7.5 7.5,9.5 7.5,12C7.5,12.73 7.68,13.43 8,14.04L6.46,15.41C5.85,14.42 5.5,13.25 5.5,12A6.5,6.5 0 0,1 12,5.5M12,1.5A10.5,10.5 0 0,1 22.5,12C22.5,14.28 21.77,16.39 20.54,18.11L19.04,16.76C19.96,15.4 20.5,13.76 20.5,12A8.5,8.5 0 0,0 12,3.5A8.5,8.5 0 0,0 3.5,12C3.5,13.76 4.04,15.4 4.96,16.76L3.46,18.11C2.23,16.39 1.5,14.28 1.5,12A10.5,10.5 0 0,1 12,1.5M12,9.5A2.5,2.5 0 0,1 14.5,12A2.5,2.5 0 0,1 12,14.5A2.5,2.5 0 0,1 9.5,12A2.5,2.5 0 0,1 12,9.5Z"
  })));
};
const Plug = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z"
  })));
};
const Tree = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16M20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18H24L20.14 12M13 19H17V22H13V19Z"
  })));
};
const Wrapper$g = styled.div``;
const ToggleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
`;
const ToggleButtonWrapper = styled.div`
  flex: 1;

  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }) => theme.themeColors.primaryCtaButton};

  padding: 16px 12px;

  text-align: center;
  font-size: 14px;
  line-height: 18px;
  font-family: 'Bolton-Bold', Arial;
  font-weight: 500;

  cursor: pointer;

  ${({ isSelected, theme }) => isSelected ? `background-color: ${theme.themeColors.primaryCtaButton}; color: ${theme.themeColors.buttonText};` : `background-color: transparent; color: ${theme.themeColors.primaryCtaButton};`}

  ${({ isSelected, index }) => {
  if (index === 0) {
    return `
        border-right-width: ${isSelected ? "1px" : 0};
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      `;
  } else {
    return `
        border-left-width: ${isSelected ? 0 : "1px"};
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      `;
  }
}}
  
  &:hover {
    ${({ isSelected, theme }) => isSelected ? `` : `background-color: ${convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)}`}
  }
`;
const ErrorText$2 = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
  text-align: center;
`;
const createToggleItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const ToggleButton = (props) => {
  const { index, name: name2, value, onClick, text, isSelected, color } = props;
  const handleClick = () => {
    return onClick(name2)(value);
  };
  return /* @__PURE__ */ React.createElement(ToggleButtonWrapper, {
    className: "no-select",
    isSelected,
    index,
    onClick: handleClick,
    color
  }, text);
};
const Toggle = ({
  name: name2,
  value,
  error,
  color,
  items,
  onChange
}) => {
  const checkIfActive = React.useCallback((itemValue) => itemValue === value, [value]);
  return /* @__PURE__ */ React.createElement(Wrapper$g, null, /* @__PURE__ */ React.createElement(ToggleContainer, null, /* @__PURE__ */ React.createElement(ToggleButton, {
    key: items[0].text,
    index: 0,
    name: name2,
    ...items[0],
    isSelected: checkIfActive(items[0].value),
    onClick: onChange,
    color
  }), /* @__PURE__ */ React.createElement(ToggleButton, {
    key: items[1].text,
    index: 1,
    name: name2,
    ...items[1],
    isSelected: checkIfActive(items[1].value),
    onClick: onChange,
    color
  })), error && /* @__PURE__ */ React.createElement(ErrorText$2, null, /* @__PURE__ */ React.createElement(Text, {
    fontSize: "14px"
  }, error)));
};
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  border-radius: 8px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.themeColors.border};
  background: ${({ theme }) => theme.themeColors.component};
`;
const ToggleRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid ${({ theme }) => theme.themeColors.border};

  :last-child {
    border: none;
  }

  padding: 12px 16px;

  text-align: left;
  font-size: 14px;
  line-height: 18px;
  font-family: 'Bolton-Bold', Arial;
  font-weight: 500;

  cursor: pointer;

  &:hover {
    ${({ isSelected, theme }) => isSelected ? `` : `background-color: ${convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)}`}
  }

  svg {
    path {
      fill: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
const ErrorText$1 = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
  text-align: center;
`;
const createListToggleItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const ToggleRow = (props) => {
  const { name: name2, value, onClick, text, isSelected, color } = props;
  const handleClick = () => {
    return onClick(name2)(value);
  };
  return /* @__PURE__ */ React.createElement(ToggleRowWrapper, {
    className: "no-select",
    isSelected,
    onClick: handleClick,
    color
  }, /* @__PURE__ */ React.createElement(Body5, null, text), isSelected && /* @__PURE__ */ React.createElement(Check$1, {
    width: "17px"
  }));
};
const ListToggle = ({
  name: name2,
  value,
  error,
  items,
  onClick
}) => {
  const checkIfActive = React.useCallback((itemValue) => itemValue === value, [value]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListContainer, null, items.map((r, i) => /* @__PURE__ */ React.createElement(ToggleRow, {
    key: r.text,
    index: i,
    name: name2,
    ...r,
    isSelected: checkIfActive(r.value),
    onClick
  }))), error && /* @__PURE__ */ React.createElement(ErrorText$1, null, /* @__PURE__ */ React.createElement(Text, {
    fontSize: "14px"
  }, error)));
};
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function IMask(el) {
  let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new IMask.InputMask(el, opts);
}
class ChangeDetails {
  constructor(details) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: false,
      tailShift: 0
    }, details);
  }
  aggregate(details) {
    this.rawInserted += details.rawInserted;
    this.skip = this.skip || details.skip;
    this.inserted += details.inserted;
    this.tailShift += details.tailShift;
    return this;
  }
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
IMask.ChangeDetails = ChangeDetails;
function isString(str) {
  return typeof str === "string" || str instanceof String;
}
const DIRECTION = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function normalizePrepare(prep) {
  return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
}
function objectIncludes(b, a) {
  if (a === b)
    return true;
  var arrA = Array.isArray(a), arrB = Array.isArray(b), i;
  if (arrA && arrB) {
    if (a.length != b.length)
      return false;
    for (i = 0; i < a.length; i++)
      if (!objectIncludes(a[i], b[i]))
        return false;
    return true;
  }
  if (arrA != arrB)
    return false;
  if (a && b && typeof a === "object" && typeof b === "object") {
    var dateA = a instanceof Date, dateB = b instanceof Date;
    if (dateA && dateB)
      return a.getTime() == b.getTime();
    if (dateA != dateB)
      return false;
    var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
    if (regexpA && regexpB)
      return a.toString() == b.toString();
    if (regexpA != regexpB)
      return false;
    var keys = Object.keys(a);
    for (i = 0; i < keys.length; i++)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
        return false;
    for (i = 0; i < keys.length; i++)
      if (!objectIncludes(b[keys[i]], a[keys[i]]))
        return false;
    return true;
  } else if (a && b && typeof a === "function" && typeof b === "function") {
    return a.toString() === b.toString();
  }
  return false;
}
class ActionDetails {
  constructor(value, cursorPos, oldValue, oldSelection) {
    this.value = value;
    this.cursorPos = cursorPos;
    this.oldValue = oldValue;
    this.oldSelection = oldSelection;
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
  }
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || this.oldValue.length - this.value.length, 0);
  }
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  get removeDirection() {
    if (!this.removedCount || this.insertedCount)
      return DIRECTION.NONE;
    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
  }
}
class ContinuousTailDetails {
  constructor() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    let stop = arguments.length > 2 ? arguments[2] : void 0;
    this.value = value;
    this.from = from;
    this.stop = stop;
  }
  toString() {
    return this.value;
  }
  extend(tail) {
    this.value += String(tail);
  }
  appendTo(masked) {
    return masked.append(this.toString(), {
      tail: true
    }).aggregate(masked._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
  unshift(beforePos) {
    if (!this.value.length || beforePos != null && this.from >= beforePos)
      return "";
    const shiftChar = this.value[0];
    this.value = this.value.slice(1);
    return shiftChar;
  }
  shift() {
    if (!this.value.length)
      return "";
    const shiftChar = this.value[this.value.length - 1];
    this.value = this.value.slice(0, -1);
    return shiftChar;
  }
}
class Masked {
  constructor(opts) {
    this._value = "";
    this._update(Object.assign({}, Masked.DEFAULTS, opts));
    this.isInitialized = true;
  }
  updateOptions(opts) {
    if (!Object.keys(opts).length)
      return;
    this.withValueRefresh(this._update.bind(this, opts));
  }
  _update(opts) {
    Object.assign(this, opts);
  }
  get state() {
    return {
      _value: this.value
    };
  }
  set state(state) {
    this._value = state._value;
  }
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this.resolve(value);
  }
  resolve(value) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      input: true
    };
    this.reset();
    this.append(value, flags, "");
    this.doCommit();
    return this.value;
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(value) {
    this.reset();
    this.append(value, {}, "");
    this.doCommit();
  }
  get typedValue() {
    return this.doParse(this.value);
  }
  set typedValue(value) {
    this.value = this.doFormat(value);
  }
  get rawInputValue() {
    return this.extractInput(0, this.value.length, {
      raw: true
    });
  }
  set rawInputValue(value) {
    this.reset();
    this.append(value, {
      raw: true
    }, "");
    this.doCommit();
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return this.isComplete;
  }
  nearestInputPos(cursorPos, direction) {
    return cursorPos;
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return Math.min(this.value.length, toPos - fromPos);
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(fromPos, toPos);
  }
  extractTail() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
  }
  appendTail(tail) {
    if (isString(tail))
      tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  _appendCharRaw(ch) {
    if (!ch)
      return new ChangeDetails();
    this._value += ch;
    return new ChangeDetails({
      inserted: ch,
      rawInserted: ch
    });
  }
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let checkTail = arguments.length > 2 ? arguments[2] : void 0;
    const consistentState = this.state;
    let details;
    [ch, details] = normalizePrepare(this.doPrepare(ch, flags));
    details = details.aggregate(this._appendCharRaw(ch, flags));
    if (details.inserted) {
      let consistentTail;
      let appended = this.doValidate(flags) !== false;
      if (appended && checkTail != null) {
        const beforeTailState = this.state;
        if (this.overwrite === true) {
          consistentTail = checkTail.state;
          checkTail.unshift(this.value.length - details.tailShift);
        }
        let tailDetails = this.appendTail(checkTail);
        appended = tailDetails.rawInserted === checkTail.toString();
        if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
          this.state = beforeTailState;
          consistentTail = checkTail.state;
          checkTail.shift();
          tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted === checkTail.toString();
        }
        if (appended && tailDetails.inserted)
          this.state = beforeTailState;
      }
      if (!appended) {
        details = new ChangeDetails();
        this.state = consistentState;
        if (checkTail && consistentTail)
          checkTail.state = consistentTail;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    return new ChangeDetails();
  }
  _appendEager() {
    return new ChangeDetails();
  }
  append(str, flags, tail) {
    if (!isString(str))
      throw new Error("value should be string");
    const details = new ChangeDetails();
    const checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
    if (flags !== null && flags !== void 0 && flags.tail)
      flags._beforeTailState = this.state;
    for (let ci = 0; ci < str.length; ++ci) {
      const d = this._appendChar(str[ci], flags, checkTail);
      if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail))
        break;
      details.aggregate(d);
    }
    if ((this.eager === true || this.eager === "append") && flags !== null && flags !== void 0 && flags.input && str) {
      details.aggregate(this._appendEager());
    }
    if (checkTail != null) {
      details.tailShift += this.appendTail(checkTail).tailShift;
    }
    return details;
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
    return new ChangeDetails();
  }
  withValueRefresh(fn) {
    if (this._refreshing || !this.isInitialized)
      return fn();
    this._refreshing = true;
    const rawInput = this.rawInputValue;
    const value = this.value;
    const ret = fn();
    this.rawInputValue = rawInput;
    if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
      this.append(value.slice(this.value.length), {}, "");
    }
    delete this._refreshing;
    return ret;
  }
  runIsolated(fn) {
    if (this._isolated || !this.isInitialized)
      return fn(this);
    this._isolated = true;
    const state = this.state;
    const ret = fn(this);
    this.state = state;
    delete this._isolated;
    return ret;
  }
  doSkipInvalid(ch) {
    return this.skipInvalid;
  }
  doPrepare(str) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.prepare ? this.prepare(str, this, flags) : str;
  }
  doValidate(flags) {
    return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
  }
  doCommit() {
    if (this.commit)
      this.commit(this.value, this);
  }
  doFormat(value) {
    return this.format ? this.format(value, this) : value;
  }
  doParse(str) {
    return this.parse ? this.parse(str, this) : str;
  }
  splice(start, deleteCount, inserted, removeDirection) {
    let flags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      input: true
    };
    const tailPos = start + deleteCount;
    const tail = this.extractTail(tailPos);
    const eagerRemove = this.eager === true || this.eager === "remove";
    let oldRawValue;
    if (eagerRemove) {
      removeDirection = forceDirection(removeDirection);
      oldRawValue = this.extractInput(0, tailPos, {
        raw: true
      });
    }
    let startChangePos = start;
    const details = new ChangeDetails();
    if (removeDirection !== DIRECTION.NONE) {
      startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);
      details.tailShift = startChangePos - start;
    }
    details.aggregate(this.remove(startChangePos));
    if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
      if (removeDirection === DIRECTION.FORCE_LEFT) {
        let valLength;
        while (oldRawValue === this.rawInputValue && (valLength = this.value.length)) {
          details.aggregate(new ChangeDetails({
            tailShift: -1
          })).aggregate(this.remove(valLength - 1));
        }
      } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
        tail.unshift();
      }
    }
    return details.aggregate(this.append(inserted, flags, tail));
  }
  maskEquals(mask) {
    return this.mask === mask;
  }
  typedValueEquals(value) {
    const tval = this.typedValue;
    return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
  }
}
Masked.DEFAULTS = {
  format: String,
  parse: (v) => v,
  skipInvalid: true
};
Masked.EMPTY_VALUES = [void 0, null, ""];
IMask.Masked = Masked;
function maskedClass(mask) {
  if (mask == null) {
    throw new Error("mask property should be defined");
  }
  if (mask instanceof RegExp)
    return IMask.MaskedRegExp;
  if (isString(mask))
    return IMask.MaskedPattern;
  if (mask instanceof Date || mask === Date)
    return IMask.MaskedDate;
  if (mask instanceof Number || typeof mask === "number" || mask === Number)
    return IMask.MaskedNumber;
  if (Array.isArray(mask) || mask === Array)
    return IMask.MaskedDynamic;
  if (IMask.Masked && mask.prototype instanceof IMask.Masked)
    return mask;
  if (mask instanceof IMask.Masked)
    return mask.constructor;
  if (mask instanceof Function)
    return IMask.MaskedFunction;
  console.warn("Mask not found for mask", mask);
  return IMask.Masked;
}
function createMask(opts) {
  if (IMask.Masked && opts instanceof IMask.Masked)
    return opts;
  opts = Object.assign({}, opts);
  const mask = opts.mask;
  if (IMask.Masked && mask instanceof IMask.Masked)
    return mask;
  const MaskedClass = maskedClass(mask);
  if (!MaskedClass)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new MaskedClass(opts);
}
IMask.createMask = createMask;
const _excluded$5 = ["parent", "isOptional", "placeholderChar", "displayChar", "lazy", "eager"];
const DEFAULT_INPUT_DEFINITIONS = {
  "0": /\d/,
  "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  "*": /./
};
class PatternInputDefinition {
  constructor(opts) {
    const {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager
    } = opts, maskOpts = _objectWithoutPropertiesLoose$1(opts, _excluded$5);
    this.masked = createMask(maskOpts);
    Object.assign(this, {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager
    });
  }
  reset() {
    this.isFilled = false;
    this.masked.reset();
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    if (fromPos === 0 && toPos >= 1) {
      this.isFilled = false;
      return this.masked.remove(fromPos, toPos);
    }
    return new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.isFilled)
      return new ChangeDetails();
    const state = this.masked.state;
    const details = this.masked._appendChar(ch, flags);
    if (details.inserted && this.doValidate(flags) === false) {
      details.inserted = details.rawInserted = "";
      this.masked.state = state;
    }
    if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
      details.inserted = this.placeholderChar;
    }
    details.skip = !details.inserted && !this.isOptional;
    this.isFilled = Boolean(details.inserted);
    return details;
  }
  append() {
    return this.masked.append(...arguments);
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled || this.isOptional)
      return details;
    this.isFilled = true;
    details.inserted = this.placeholderChar;
    return details;
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail() {
    return this.masked.extractTail(...arguments);
  }
  appendTail() {
    return this.masked.appendTail(...arguments);
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 ? arguments[2] : void 0;
    return this.masked.extractInput(fromPos, toPos, flags);
  }
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
    const minPos = 0;
    const maxPos = this.value.length;
    const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? boundPos : minPos;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? boundPos : maxPos;
      case DIRECTION.NONE:
      default:
        return boundPos;
    }
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(fromPos, toPos).length;
  }
  doValidate() {
    return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(state) {
    this.masked.state = state.masked;
    this.isFilled = state.isFilled;
  }
}
class PatternFixedDefinition {
  constructor(opts) {
    Object.assign(this, opts);
    this._value = "";
    this.isFixed = true;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = false;
    this._value = "";
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
    if (!this._value)
      this._isRawInput = false;
    return new ChangeDetails();
  }
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
    const minPos = 0;
    const maxPos = this._value.length;
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return minPos;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return maxPos;
    }
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._isRawInput ? toPos - fromPos : 0;
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    let flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const details = new ChangeDetails();
    if (this.isFilled)
      return details;
    const appendEager = this.eager === true || this.eager === "append";
    const appended = this.char === ch;
    const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
    if (isResolved)
      details.rawInserted = this.char;
    this._value = details.inserted = this.char;
    this._isRawInput = isResolved && (flags.raw || flags.input);
    return details;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: true
    });
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled)
      return details;
    this._value = details.inserted = this.char;
    return details;
  }
  extractTail() {
    arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return new ContinuousTailDetails("");
  }
  appendTail(tail) {
    if (isString(tail))
      tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  append(str, flags, tail) {
    const details = this._appendChar(str[0], flags);
    if (tail != null) {
      details.tailShift += this.appendTail(tail).tailShift;
    }
    return details;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _isRawInput: this._isRawInput
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
}
const _excluded$4 = ["chunks"];
class ChunksTailDetails {
  constructor() {
    let chunks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.chunks = chunks;
    this.from = from;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(tailChunk) {
    if (!String(tailChunk))
      return;
    if (isString(tailChunk))
      tailChunk = new ContinuousTailDetails(String(tailChunk));
    const lastChunk = this.chunks[this.chunks.length - 1];
    const extendLast = lastChunk && (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && tailChunk.from === lastChunk.from + lastChunk.toString().length;
    if (tailChunk instanceof ContinuousTailDetails) {
      if (extendLast) {
        lastChunk.extend(tailChunk.toString());
      } else {
        this.chunks.push(tailChunk);
      }
    } else if (tailChunk instanceof ChunksTailDetails) {
      if (tailChunk.stop == null) {
        let firstTailChunk;
        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
          firstTailChunk = tailChunk.chunks.shift();
          firstTailChunk.from += tailChunk.from;
          this.extend(firstTailChunk);
        }
      }
      if (tailChunk.toString()) {
        tailChunk.stop = tailChunk.blockIndex;
        this.chunks.push(tailChunk);
      }
    }
  }
  appendTo(masked) {
    if (!(masked instanceof IMask.MaskedPattern)) {
      const tail = new ContinuousTailDetails(this.toString());
      return tail.appendTo(masked);
    }
    const details = new ChangeDetails();
    for (let ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
      const chunk = this.chunks[ci];
      const lastBlockIter = masked._mapPosToBlock(masked.value.length);
      const stop = chunk.stop;
      let chunkBlock;
      if (stop != null && (!lastBlockIter || lastBlockIter.index <= stop)) {
        if (chunk instanceof ChunksTailDetails || masked._stops.indexOf(stop) >= 0) {
          const phDetails = masked._appendPlaceholder(stop);
          details.aggregate(phDetails);
        }
        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
      }
      if (chunkBlock) {
        const tailDetails = chunkBlock.appendTail(chunk);
        tailDetails.skip = false;
        details.aggregate(tailDetails);
        masked._value += tailDetails.inserted;
        const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
        if (remainChars)
          details.aggregate(masked.append(remainChars, {
            tail: true
          }));
      } else {
        details.aggregate(masked.append(chunk.toString(), {
          tail: true
        }));
      }
    }
    return details;
  }
  get state() {
    return {
      chunks: this.chunks.map((c) => c.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(state) {
    const {
      chunks
    } = state, props = _objectWithoutPropertiesLoose$1(state, _excluded$4);
    Object.assign(this, props);
    this.chunks = chunks.map((cstate) => {
      const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
      chunk.state = cstate;
      return chunk;
    });
  }
  unshift(beforePos) {
    if (!this.chunks.length || beforePos != null && this.from >= beforePos)
      return "";
    const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
    let ci = 0;
    while (ci < this.chunks.length) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.unshift(chunkShiftPos);
      if (chunk.toString()) {
        if (!shiftChar)
          break;
        ++ci;
      } else {
        this.chunks.splice(ci, 1);
      }
      if (shiftChar)
        return shiftChar;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let ci = this.chunks.length - 1;
    while (0 <= ci) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.shift();
      if (chunk.toString()) {
        if (!shiftChar)
          break;
        --ci;
      } else {
        this.chunks.splice(ci, 1);
      }
      if (shiftChar)
        return shiftChar;
    }
    return "";
  }
}
class PatternCursor {
  constructor(masked, pos) {
    this.masked = masked;
    this._log = [];
    const {
      offset,
      index
    } = masked._mapPosToBlock(pos) || (pos < 0 ? {
      index: 0,
      offset: 0
    } : {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = offset;
    this.index = index;
    this.ok = false;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(s) {
    Object.assign(this, s);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const s = this._log.pop();
    this.state = s;
    return s;
  }
  bindBlock() {
    if (this.block)
      return;
    if (this.index < 0) {
      this.index = 0;
      this.offset = 0;
    }
    if (this.index >= this.masked._blocks.length) {
      this.index = this.masked._blocks.length - 1;
      this.offset = this.block.value.length;
    }
  }
  _pushLeft(fn) {
    this.pushState();
    for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0) {
      var _this$block;
      if (fn())
        return this.ok = true;
    }
    return this.ok = false;
  }
  _pushRight(fn) {
    this.pushState();
    for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
      if (fn())
        return this.ok = true;
    }
    return this.ok = false;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (this.block.isFixed || !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
      if (this.offset !== 0)
        return true;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (this.block.isFixed)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (this.block.isFixed || !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
      if (this.offset !== this.block.value.length)
        return true;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (this.block.isFixed)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
}
class MaskedRegExp extends Masked {
  _update(opts) {
    if (opts.mask)
      opts.validate = (value) => value.search(opts.mask) >= 0;
    super._update(opts);
  }
}
IMask.MaskedRegExp = MaskedRegExp;
const _excluded$3 = ["_blocks"];
class MaskedPattern extends Masked {
  constructor() {
    let opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
    super(Object.assign({}, MaskedPattern.DEFAULTS, opts));
  }
  _update() {
    let opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
    super._update(opts);
    this._rebuildMask();
  }
  _rebuildMask() {
    const defs = this.definitions;
    this._blocks = [];
    this._stops = [];
    this._maskedBlocks = {};
    let pattern = this.mask;
    if (!pattern || !defs)
      return;
    let unmaskingBlock = false;
    let optionalBlock = false;
    for (let i = 0; i < pattern.length; ++i) {
      var _defs$char, _defs$char2;
      if (this.blocks) {
        const p = pattern.slice(i);
        const bNames = Object.keys(this.blocks).filter((bName2) => p.indexOf(bName2) === 0);
        bNames.sort((a, b) => b.length - a.length);
        const bName = bNames[0];
        if (bName) {
          const maskedBlock = createMask(Object.assign({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite
          }, this.blocks[bName]));
          if (maskedBlock) {
            this._blocks.push(maskedBlock);
            if (!this._maskedBlocks[bName])
              this._maskedBlocks[bName] = [];
            this._maskedBlocks[bName].push(this._blocks.length - 1);
          }
          i += bName.length - 1;
          continue;
        }
      }
      let char = pattern[i];
      let isInput = char in defs;
      if (char === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (char === "{" || char === "}") {
        unmaskingBlock = !unmaskingBlock;
        continue;
      }
      if (char === "[" || char === "]") {
        optionalBlock = !optionalBlock;
        continue;
      }
      if (char === MaskedPattern.ESCAPE_CHAR) {
        ++i;
        char = pattern[i];
        if (!char)
          break;
        isInput = false;
      }
      const maskOpts = (_defs$char = defs[char]) !== null && _defs$char !== void 0 && _defs$char.mask && !(((_defs$char2 = defs[char]) === null || _defs$char2 === void 0 ? void 0 : _defs$char2.mask.prototype) instanceof IMask.Masked) ? defs[char] : {
        mask: defs[char]
      };
      const def = isInput ? new PatternInputDefinition(Object.assign({
        parent: this,
        isOptional: optionalBlock,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar
      }, maskOpts)) : new PatternFixedDefinition({
        char,
        eager: this.eager,
        isUnmasking: unmaskingBlock
      });
      this._blocks.push(def);
    }
  }
  get state() {
    return Object.assign({}, super.state, {
      _blocks: this._blocks.map((b) => b.state)
    });
  }
  set state(state) {
    const {
      _blocks
    } = state, maskedState = _objectWithoutPropertiesLoose$1(state, _excluded$3);
    this._blocks.forEach((b, bi) => b.state = _blocks[bi]);
    super.state = maskedState;
  }
  reset() {
    super.reset();
    this._blocks.forEach((b) => b.reset());
  }
  get isComplete() {
    return this._blocks.every((b) => b.isComplete);
  }
  get isFilled() {
    return this._blocks.every((b) => b.isFilled);
  }
  get isFixed() {
    return this._blocks.every((b) => b.isFixed);
  }
  get isOptional() {
    return this._blocks.every((b) => b.isOptional);
  }
  doCommit() {
    this._blocks.forEach((b) => b.doCommit());
    super.doCommit();
  }
  get unmaskedValue() {
    return this._blocks.reduce((str, b) => str += b.unmaskedValue, "");
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get value() {
    return this._blocks.reduce((str, b) => str += b.value, "");
  }
  set value(value) {
    super.value = value;
  }
  get displayValue() {
    return this._blocks.reduce((str, b) => str += b.displayValue, "");
  }
  appendTail(tail) {
    return super.appendTail(tail).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var _this$_mapPosToBlock;
    const details = new ChangeDetails();
    let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
    if (startBlockIndex == null)
      return details;
    if (this._blocks[startBlockIndex].isFilled)
      ++startBlockIndex;
    for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
      const d = this._blocks[bi]._appendEager();
      if (!d.inserted)
        break;
      details.aggregate(d);
    }
    return details;
  }
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const blockIter = this._mapPosToBlock(this.value.length);
    const details = new ChangeDetails();
    if (!blockIter)
      return details;
    for (let bi = blockIter.index; ; ++bi) {
      var _flags$_beforeTailSta, _flags$_beforeTailSta2;
      const block = this._blocks[bi];
      if (!block)
        break;
      const blockDetails = block._appendChar(ch, Object.assign({}, flags, {
        _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi]
      }));
      const skip = blockDetails.skip;
      details.aggregate(blockDetails);
      if (skip || blockDetails.rawInserted)
        break;
    }
    return details;
  }
  extractTail() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const chunkTail = new ChunksTailDetails();
    if (fromPos === toPos)
      return chunkTail;
    this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
      const blockChunk = b.extractTail(bFromPos, bToPos);
      blockChunk.stop = this._findStopBefore(bi);
      blockChunk.from = this._blockStartPos(bi);
      if (blockChunk instanceof ChunksTailDetails)
        blockChunk.blockIndex = bi;
      chunkTail.extend(blockChunk);
    });
    return chunkTail;
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (fromPos === toPos)
      return "";
    let input = "";
    this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos2, toPos2) => {
      input += b.extractInput(fromPos2, toPos2, flags);
    });
    return input;
  }
  _findStopBefore(blockIndex) {
    let stopBefore;
    for (let si = 0; si < this._stops.length; ++si) {
      const stop = this._stops[si];
      if (stop <= blockIndex)
        stopBefore = stop;
      else
        break;
    }
    return stopBefore;
  }
  _appendPlaceholder(toBlockIndex) {
    const details = new ChangeDetails();
    if (this.lazy && toBlockIndex == null)
      return details;
    const startBlockIter = this._mapPosToBlock(this.value.length);
    if (!startBlockIter)
      return details;
    const startBlockIndex = startBlockIter.index;
    const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
    this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b) => {
      if (!b.lazy || toBlockIndex != null) {
        const args = b._blocks != null ? [b._blocks.length] : [];
        const bDetails = b._appendPlaceholder(...args);
        this._value += bDetails.inserted;
        details.aggregate(bDetails);
      }
    });
    return details;
  }
  _mapPosToBlock(pos) {
    let accVal = "";
    for (let bi = 0; bi < this._blocks.length; ++bi) {
      const block = this._blocks[bi];
      const blockStartPos = accVal.length;
      accVal += block.value;
      if (pos <= accVal.length) {
        return {
          index: bi,
          offset: pos - blockStartPos
        };
      }
    }
  }
  _blockStartPos(blockIndex) {
    return this._blocks.slice(0, blockIndex).reduce((pos, b) => pos += b.value.length, 0);
  }
  _forEachBlocksInRange(fromPos) {
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    let fn = arguments.length > 2 ? arguments[2] : void 0;
    const fromBlockIter = this._mapPosToBlock(fromPos);
    if (fromBlockIter) {
      const toBlockIter = this._mapPosToBlock(toPos);
      const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
      const fromBlockStartPos = fromBlockIter.offset;
      const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
      fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
      if (toBlockIter && !isSameBlock) {
        for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
          fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
        }
        fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
      }
    }
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const removeDetails = super.remove(fromPos, toPos);
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      removeDetails.aggregate(b.remove(bFromPos, bToPos));
    });
    return removeDetails;
  }
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
    if (!this._blocks.length)
      return 0;
    const cursor = new PatternCursor(this, cursorPos);
    if (direction === DIRECTION.NONE) {
      if (cursor.pushRightBeforeInput())
        return cursor.pos;
      cursor.popState();
      if (cursor.pushLeftBeforeInput())
        return cursor.pos;
      return this.value.length;
    }
    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeFilled();
        if (cursor.ok && cursor.pos === cursorPos)
          return cursorPos;
        cursor.popState();
      }
      cursor.pushLeftBeforeInput();
      cursor.pushLeftBeforeRequired();
      cursor.pushLeftBeforeFilled();
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.ok && cursor.pos <= cursorPos)
          return cursor.pos;
        cursor.popState();
        if (cursor.ok && cursor.pos <= cursorPos)
          return cursor.pos;
        cursor.popState();
      }
      if (cursor.ok)
        return cursor.pos;
      if (direction === DIRECTION.FORCE_LEFT)
        return 0;
      cursor.popState();
      if (cursor.ok)
        return cursor.pos;
      cursor.popState();
      if (cursor.ok)
        return cursor.pos;
      return 0;
    }
    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
      cursor.pushRightBeforeInput();
      cursor.pushRightBeforeRequired();
      if (cursor.pushRightBeforeFilled())
        return cursor.pos;
      if (direction === DIRECTION.FORCE_RIGHT)
        return this.value.length;
      cursor.popState();
      if (cursor.ok)
        return cursor.pos;
      cursor.popState();
      if (cursor.ok)
        return cursor.pos;
      return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
    }
    return cursorPos;
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    let total = 0;
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      total += b.totalInputPositions(bFromPos, bToPos);
    });
    return total;
  }
  maskedBlock(name2) {
    return this.maskedBlocks(name2)[0];
  }
  maskedBlocks(name2) {
    const indices = this._maskedBlocks[name2];
    if (!indices)
      return [];
    return indices.map((gi) => this._blocks[gi]);
  }
}
MaskedPattern.DEFAULTS = {
  lazy: true,
  placeholderChar: "_"
};
MaskedPattern.STOP_CHAR = "`";
MaskedPattern.ESCAPE_CHAR = "\\";
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;
class MaskedRange extends MaskedPattern {
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  _update(opts) {
    opts = Object.assign({
      to: this.to || 0,
      from: this.from || 0,
      maxLength: this.maxLength || 0
    }, opts);
    let maxLength = String(opts.to).length;
    if (opts.maxLength != null)
      maxLength = Math.max(maxLength, opts.maxLength);
    opts.maxLength = maxLength;
    const fromStr = String(opts.from).padStart(maxLength, "0");
    const toStr = String(opts.to).padStart(maxLength, "0");
    let sameCharsCount = 0;
    while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])
      ++sameCharsCount;
    opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(maxLength - sameCharsCount);
    super._update(opts);
  }
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(str) {
    let minstr = "";
    let maxstr = "";
    const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
    if (num) {
      minstr = "0".repeat(placeholder.length) + num;
      maxstr = "9".repeat(placeholder.length) + num;
    }
    minstr = minstr.padEnd(this.maxLength, "0");
    maxstr = maxstr.padEnd(this.maxLength, "9");
    return [minstr, maxstr];
  }
  doPrepare(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let details;
    [ch, details] = normalizePrepare(super.doPrepare(ch.replace(/\D/g, ""), flags));
    if (!this.autofix || !ch)
      return ch;
    const fromStr = String(this.from).padStart(this.maxLength, "0");
    const toStr = String(this.to).padStart(this.maxLength, "0");
    let nextVal = this.value + ch;
    if (nextVal.length > this.maxLength)
      return "";
    const [minstr, maxstr] = this.boundaries(nextVal);
    if (Number(maxstr) < this.from)
      return fromStr[nextVal.length - 1];
    if (Number(minstr) > this.to) {
      if (this.autofix === "pad" && nextVal.length < this.maxLength) {
        return ["", details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
      }
      return toStr[nextVal.length - 1];
    }
    return ch;
  }
  doValidate() {
    const str = this.value;
    const firstNonZero = str.search(/[^0]/);
    if (firstNonZero === -1 && str.length <= this._matchFrom)
      return true;
    const [minstr, maxstr] = this.boundaries(str);
    return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(...arguments);
  }
}
IMask.MaskedRange = MaskedRange;
class MaskedDate extends MaskedPattern {
  constructor(opts) {
    super(Object.assign({}, MaskedDate.DEFAULTS, opts));
  }
  _update(opts) {
    if (opts.mask === Date)
      delete opts.mask;
    if (opts.pattern)
      opts.mask = opts.pattern;
    const blocks = opts.blocks;
    opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    if (opts.min)
      opts.blocks.Y.from = opts.min.getFullYear();
    if (opts.max)
      opts.blocks.Y.to = opts.max.getFullYear();
    if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
      opts.blocks.m.from = opts.min.getMonth() + 1;
      opts.blocks.m.to = opts.max.getMonth() + 1;
      if (opts.blocks.m.from === opts.blocks.m.to) {
        opts.blocks.d.from = opts.min.getDate();
        opts.blocks.d.to = opts.max.getDate();
      }
    }
    Object.assign(opts.blocks, this.blocks, blocks);
    Object.keys(opts.blocks).forEach((bk) => {
      const b = opts.blocks[bk];
      if (!("autofix" in b) && "autofix" in opts)
        b.autofix = opts.autofix;
    });
    super._update(opts);
  }
  doValidate() {
    const date = this.date;
    return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
  }
  isDateExist(str) {
    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
  }
  get date() {
    return this.typedValue;
  }
  set date(date) {
    this.typedValue = date;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(value) {
    super.typedValue = value;
  }
  maskEquals(mask) {
    return mask === Date || super.maskEquals(mask);
  }
}
MaskedDate.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: (date) => {
    if (!date)
      return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return [day, month, year].join(".");
  },
  parse: (str) => {
    const [day, month, year] = str.split(".");
    return new Date(year, month - 1, day);
  }
};
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999
  }
});
IMask.MaskedDate = MaskedDate;
class MaskElement {
  get selectionStart() {
    let start;
    try {
      start = this._unsafeSelectionStart;
    } catch (e) {
    }
    return start != null ? start : this.value.length;
  }
  get selectionEnd() {
    let end;
    try {
      end = this._unsafeSelectionEnd;
    } catch (e) {
    }
    return end != null ? end : this.value.length;
  }
  select(start, end) {
    if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd)
      return;
    try {
      this._unsafeSelect(start, end);
    } catch (e) {
    }
  }
  _unsafeSelect(start, end) {
  }
  get isActive() {
    return false;
  }
  bindEvents(handlers) {
  }
  unbindEvents() {
  }
}
IMask.MaskElement = MaskElement;
class HTMLMaskElement extends MaskElement {
  constructor(input) {
    super();
    this.input = input;
    this._handlers = {};
  }
  get rootElement() {
    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
    return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
  }
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  get _unsafeSelectionStart() {
    return this.input.selectionStart;
  }
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  _unsafeSelect(start, end) {
    this.input.setSelectionRange(start, end);
  }
  get value() {
    return this.input.value;
  }
  set value(value) {
    this.input.value = value;
  }
  bindEvents(handlers) {
    Object.keys(handlers).forEach((event) => this._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]));
  }
  unbindEvents() {
    Object.keys(this._handlers).forEach((event) => this._toggleEventHandler(event));
  }
  _toggleEventHandler(event, handler) {
    if (this._handlers[event]) {
      this.input.removeEventListener(event, this._handlers[event]);
      delete this._handlers[event];
    }
    if (handler) {
      this.input.addEventListener(event, handler);
      this._handlers[event] = handler;
    }
  }
}
HTMLMaskElement.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
IMask.HTMLMaskElement = HTMLMaskElement;
class HTMLContenteditableMaskElement extends HTMLMaskElement {
  get _unsafeSelectionStart() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }
  get _unsafeSelectionEnd() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }
  _unsafeSelect(start, end) {
    if (!this.rootElement.createRange)
      return;
    const range = this.rootElement.createRange();
    range.setStart(this.input.firstChild || this.input, start);
    range.setEnd(this.input.lastChild || this.input, end);
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
  get value() {
    return this.input.textContent;
  }
  set value(value) {
    this.input.textContent = value;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
const _excluded$2 = ["mask"];
class InputMask {
  constructor(el, opts) {
    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = "";
    this._unmaskedValue = "";
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();
    this.updateValue();
    this._onChange();
  }
  get mask() {
    return this.masked.mask;
  }
  maskEquals(mask) {
    var _this$masked;
    return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
  }
  set mask(mask) {
    if (this.maskEquals(mask))
      return;
    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
      this.masked.updateOptions({
        mask
      });
      return;
    }
    const masked = createMask({
      mask
    });
    masked.unmaskedValue = this.masked.unmaskedValue;
    this.masked = masked;
  }
  get value() {
    return this._value;
  }
  set value(str) {
    if (this.value === str)
      return;
    this.masked.value = str;
    this.updateControl();
    this.alignCursor();
  }
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(str) {
    if (this.unmaskedValue === str)
      return;
    this.masked.unmaskedValue = str;
    this.updateControl();
    this.alignCursor();
  }
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(val) {
    if (this.masked.typedValueEquals(val))
      return;
    this.masked.typedValue = val;
    this.updateControl();
    this.alignCursor();
  }
  get displayValue() {
    return this.masked.displayValue;
  }
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }
  _unbindEvents() {
    if (this.el)
      this.el.unbindEvents();
  }
  _fireEvent(ev) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const listeners = this._listeners[ev];
    if (!listeners)
      return;
    listeners.forEach((l) => l(...args));
  }
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(pos) {
    if (!this.el || !this.el.isActive)
      return;
    this.el.select(pos, pos);
    this._saveSelection();
  }
  _saveSelection() {
    if (this.displayValue !== this.el.value) {
      console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.");
    }
    this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  updateValue() {
    this.masked.value = this.el.value;
    this._value = this.masked.value;
  }
  updateControl() {
    const newUnmaskedValue = this.masked.unmaskedValue;
    const newValue = this.masked.value;
    const newDisplayValue = this.displayValue;
    const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
    this._unmaskedValue = newUnmaskedValue;
    this._value = newValue;
    if (this.el.value !== newDisplayValue)
      this.el.value = newDisplayValue;
    if (isChanged)
      this._fireChangeEvents();
  }
  updateOptions(opts) {
    const {
      mask
    } = opts, restOpts = _objectWithoutPropertiesLoose$1(opts, _excluded$2);
    const updateMask = !this.maskEquals(mask);
    const updateOpts = !objectIncludes(this.masked, restOpts);
    if (updateMask)
      this.mask = mask;
    if (updateOpts)
      this.masked.updateOptions(restOpts);
    if (updateMask || updateOpts)
      this.updateControl();
  }
  updateCursor(cursorPos) {
    if (cursorPos == null)
      return;
    this.cursorPos = cursorPos;
    this._delayUpdateCursor(cursorPos);
  }
  _delayUpdateCursor(cursorPos) {
    this._abortUpdateCursor();
    this._changingCursorPos = cursorPos;
    this._cursorChanging = setTimeout(() => {
      if (!this.el)
        return;
      this.cursorPos = this._changingCursorPos;
      this._abortUpdateCursor();
    }, 10);
  }
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent);
    if (this.masked.isComplete)
      this._fireEvent("complete", this._inputEvent);
  }
  _abortUpdateCursor() {
    if (this._cursorChanging) {
      clearTimeout(this._cursorChanging);
      delete this._cursorChanging;
    }
  }
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }
  alignCursorFriendly() {
    if (this.selectionStart !== this.cursorPos)
      return;
    this.alignCursor();
  }
  on(ev, handler) {
    if (!this._listeners[ev])
      this._listeners[ev] = [];
    this._listeners[ev].push(handler);
    return this;
  }
  off(ev, handler) {
    if (!this._listeners[ev])
      return this;
    if (!handler) {
      delete this._listeners[ev];
      return this;
    }
    const hIndex = this._listeners[ev].indexOf(handler);
    if (hIndex >= 0)
      this._listeners[ev].splice(hIndex, 1);
    return this;
  }
  _onInput(e) {
    this._inputEvent = e;
    this._abortUpdateCursor();
    if (!this._selection)
      return this.updateValue();
    const details = new ActionDetails(
      this.el.value,
      this.cursorPos,
      this.displayValue,
      this._selection
    );
    const oldRawValue = this.masked.rawInputValue;
    const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
      input: true,
      raw: true
    }).offset;
    const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
    let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
    if (removeDirection !== DIRECTION.NONE)
      cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
    this.updateControl();
    this.updateCursor(cursorPos);
    delete this._inputEvent;
  }
  _onChange() {
    if (this.displayValue !== this.el.value) {
      this.updateValue();
    }
    this.masked.doCommit();
    this.updateControl();
    this._saveSelection();
  }
  _onDrop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }
  _onFocus(ev) {
    this.alignCursorFriendly();
  }
  _onClick(ev) {
    this.alignCursorFriendly();
  }
  destroy() {
    this._unbindEvents();
    this._listeners.length = 0;
    delete this.el;
  }
}
IMask.InputMask = InputMask;
class MaskedEnum extends MaskedPattern {
  _update(opts) {
    if (opts.enum)
      opts.mask = "*".repeat(opts.enum[0].length);
    super._update(opts);
  }
  doValidate() {
    return this.enum.some((e) => e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
  }
}
IMask.MaskedEnum = MaskedEnum;
class MaskedNumber extends Masked {
  constructor(opts) {
    super(Object.assign({}, MaskedNumber.DEFAULTS, opts));
  }
  _update(opts) {
    super._update(opts);
    this._updateRegExps();
  }
  _updateRegExps() {
    let start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
    let mid = "\\d*";
    let end = (this.scale ? "(".concat(escapeRegExp(this.radix), "\\d{0,").concat(this.scale, "})?") : "") + "$";
    this._numberRegExp = new RegExp(start + mid + end);
    this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map(escapeRegExp).join(""), "]"), "g");
    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(value) {
    return value.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(value) {
    const parts = value.split(this.radix);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    return parts.join(this.radix);
  }
  doPrepare(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    ch = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch);
    const [prepCh, details] = normalizePrepare(super.doPrepare(ch, flags));
    if (ch && !prepCh)
      details.skip = true;
    return [prepCh, details];
  }
  _separatorsCount(to) {
    let extendOnSeparators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    let count = 0;
    for (let pos = 0; pos < to; ++pos) {
      if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
        ++count;
        if (extendOnSeparators)
          to += this.thousandsSeparator.length;
      }
    }
    return count;
  }
  _separatorsCountFromSlice() {
    let slice = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
    return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 ? arguments[2] : void 0;
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
  }
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.thousandsSeparator)
      return super._appendCharRaw(ch, flags);
    const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
    this._value = this._removeThousandsSeparators(this.value);
    const appendDetails = super._appendCharRaw(ch, flags);
    this._value = this._insertThousandsSeparators(this._value);
    const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
    appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
    appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
    return appendDetails;
  }
  _findSeparatorAround(pos) {
    if (this.thousandsSeparator) {
      const searchFrom = pos - this.thousandsSeparator.length + 1;
      const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
      if (separatorPos <= pos)
        return separatorPos;
    }
    return -1;
  }
  _adjustRangeWithSeparators(from, to) {
    const separatorAroundFromPos = this._findSeparatorAround(from);
    if (separatorAroundFromPos >= 0)
      from = separatorAroundFromPos;
    const separatorAroundToPos = this._findSeparatorAround(to);
    if (separatorAroundToPos >= 0)
      to = separatorAroundToPos + this.thousandsSeparator.length;
    return [from, to];
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    const valueBeforePos = this.value.slice(0, fromPos);
    const valueAfterPos = this.value.slice(toPos);
    const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
    return new ChangeDetails({
      tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(cursorPos, direction) {
    if (!this.thousandsSeparator)
      return cursorPos;
    switch (direction) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT: {
        const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
        if (separatorAtLeftPos >= 0) {
          const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
          if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
            return separatorAtLeftPos;
          }
        }
        break;
      }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT: {
        const separatorAtRightPos = this._findSeparatorAround(cursorPos);
        if (separatorAtRightPos >= 0) {
          return separatorAtRightPos + this.thousandsSeparator.length;
        }
      }
    }
    return cursorPos;
  }
  doValidate(flags) {
    let valid = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
    if (valid) {
      const number = this.number;
      valid = valid && !isNaN(number) && (this.min == null || this.min >= 0 || this.min <= this.number) && (this.max == null || this.max <= 0 || this.number <= this.max);
    }
    return valid && super.doValidate(flags);
  }
  doCommit() {
    if (this.value) {
      const number = this.number;
      let validnum = number;
      if (this.min != null)
        validnum = Math.max(validnum, this.min);
      if (this.max != null)
        validnum = Math.min(validnum, this.max);
      if (validnum !== number)
        this.unmaskedValue = this.doFormat(validnum);
      let formatted = this.value;
      if (this.normalizeZeros)
        formatted = this._normalizeZeros(formatted);
      if (this.padFractionalZeros && this.scale > 0)
        formatted = this._padFractionalZeros(formatted);
      this._value = formatted;
    }
    super.doCommit();
  }
  _normalizeZeros(value) {
    const parts = this._removeThousandsSeparators(value).split(this.radix);
    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
    if (value.length && !/\d$/.test(parts[0]))
      parts[0] = parts[0] + "0";
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/0*$/, "");
      if (!parts[1].length)
        parts.length = 1;
    }
    return this._insertThousandsSeparators(parts.join(this.radix));
  }
  _padFractionalZeros(value) {
    if (!value)
      return value;
    const parts = value.split(this.radix);
    if (parts.length < 2)
      parts.push("");
    parts[1] = parts[1].padEnd(this.scale, "0");
    return parts.join(this.radix);
  }
  doSkipInvalid(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let checkTail = arguments.length > 2 ? arguments[2] : void 0;
    const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
    return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.doParse(this.unmaskedValue);
  }
  set typedValue(n) {
    this.rawInputValue = this.doFormat(n).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }
  get number() {
    return this.typedValue;
  }
  set number(number) {
    this.typedValue = number;
  }
  get allowNegative() {
    return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  typedValueEquals(value) {
    return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
  }
}
MaskedNumber.UNMASKED_RADIX = ".";
MaskedNumber.DEFAULTS = {
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [MaskedNumber.UNMASKED_RADIX],
  scale: 2,
  signed: false,
  normalizeZeros: true,
  padFractionalZeros: false,
  parse: Number,
  format: (n) => n.toLocaleString("en-US", {
    useGrouping: false,
    maximumFractionDigits: 20
  })
};
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
IMask.MaskedNumber = MaskedNumber;
class MaskedFunction extends Masked {
  _update(opts) {
    if (opts.mask)
      opts.validate = opts.mask;
    super._update(opts);
  }
}
IMask.MaskedFunction = MaskedFunction;
const _excluded$1 = ["compiledMasks", "currentMaskRef", "currentMask"], _excluded2 = ["mask"];
class MaskedDynamic extends Masked {
  constructor(opts) {
    super(Object.assign({}, MaskedDynamic.DEFAULTS, opts));
    this.currentMask = null;
  }
  _update(opts) {
    super._update(opts);
    if ("mask" in opts) {
      this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m) => createMask(m)) : [];
    }
  }
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const details = this._applyDispatch(ch, flags);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
    }
    return details;
  }
  _applyDispatch() {
    let appended = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let tail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
    const inputValue = this.rawInputValue;
    const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
    const tailValue = inputValue.slice(insertValue.length);
    const prevMask = this.currentMask;
    const details = new ChangeDetails();
    const prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state;
    this.currentMask = this.doDispatch(appended, Object.assign({}, flags), tail);
    if (this.currentMask) {
      if (this.currentMask !== prevMask) {
        this.currentMask.reset();
        if (insertValue) {
          const d = this.currentMask.append(insertValue, {
            raw: true
          });
          details.tailShift = d.inserted.length - prevValueBeforeTail.length;
        }
        if (tailValue) {
          details.tailShift += this.currentMask.append(tailValue, {
            raw: true,
            tail: true
          }).tailShift;
        }
      } else {
        this.currentMask.state = prevMaskState;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    const details = this._applyDispatch(...arguments);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendPlaceholder());
    }
    return details;
  }
  _appendEager() {
    const details = this._applyDispatch(...arguments);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendEager());
    }
    return details;
  }
  appendTail(tail) {
    const details = new ChangeDetails();
    if (tail)
      details.aggregate(this._applyDispatch("", {}, tail));
    return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
    return Object.assign({}, flags, {
      _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
    });
  }
  doDispatch(appended) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let tail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return this.dispatch(appended, this, flags, tail);
  }
  doValidate(flags) {
    return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
  }
  doPrepare(str) {
    let flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let [s, details] = normalizePrepare(super.doPrepare(str, flags));
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = normalizePrepare(super.doPrepare(s, this.currentMaskFlags(flags)));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }
  reset() {
    var _this$currentMask;
    (_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 ? void 0 : _this$currentMask.reset();
    this.compiledMasks.forEach((m) => m.reset());
  }
  get value() {
    return this.currentMask ? this.currentMask.value : "";
  }
  set value(value) {
    super.value = value;
  }
  get unmaskedValue() {
    return this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(value) {
    let unmaskedValue = String(value);
    if (this.currentMask) {
      this.currentMask.typedValue = value;
      unmaskedValue = this.currentMask.unmaskedValue;
    }
    this.unmaskedValue = unmaskedValue;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var _this$currentMask2;
    return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
  }
  get isFilled() {
    var _this$currentMask3;
    return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
  }
  remove() {
    const details = new ChangeDetails();
    if (this.currentMask) {
      details.aggregate(this.currentMask.remove(...arguments)).aggregate(this._applyDispatch());
    }
    return details;
  }
  get state() {
    var _this$currentMask4;
    return Object.assign({}, super.state, {
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((m) => m.state),
      currentMaskRef: this.currentMask,
      currentMask: (_this$currentMask4 = this.currentMask) === null || _this$currentMask4 === void 0 ? void 0 : _this$currentMask4.state
    });
  }
  set state(state) {
    const {
      compiledMasks,
      currentMaskRef,
      currentMask
    } = state, maskedState = _objectWithoutPropertiesLoose$1(state, _excluded$1);
    this.compiledMasks.forEach((m, mi) => m.state = compiledMasks[mi]);
    if (currentMaskRef != null) {
      this.currentMask = currentMaskRef;
      this.currentMask.state = currentMask;
    }
    super.state = maskedState;
  }
  extractInput() {
    return this.currentMask ? this.currentMask.extractInput(...arguments) : "";
  }
  extractTail() {
    return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
  }
  doCommit() {
    if (this.currentMask)
      this.currentMask.doCommit();
    super.doCommit();
  }
  nearestInputPos() {
    return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : super.overwrite;
  }
  set overwrite(overwrite) {
    console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : super.eager;
  }
  set eager(eager) {
    console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
  }
  set skipInvalid(skipInvalid) {
    if (this.isInitialized || skipInvalid !== Masked.DEFAULTS.skipInvalid) {
      console.warn('"skipInvalid" option is not available in dynamic mask, use this option in siblings');
    }
  }
  maskEquals(mask) {
    return Array.isArray(mask) && this.compiledMasks.every((m, mi) => {
      if (!mask[mi])
        return;
      const _mask$mi = mask[mi], {
        mask: oldMask
      } = _mask$mi, restOpts = _objectWithoutPropertiesLoose$1(_mask$mi, _excluded2);
      return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
    });
  }
  typedValueEquals(value) {
    var _this$currentMask5;
    return Boolean((_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.typedValueEquals(value));
  }
}
MaskedDynamic.DEFAULTS = {
  dispatch: (appended, masked, flags, tail) => {
    if (!masked.compiledMasks.length)
      return;
    const inputValue = masked.rawInputValue;
    const inputs = masked.compiledMasks.map((m, index) => {
      const isCurrent = masked.currentMask === m;
      const startInputPos = isCurrent ? m.value.length : m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT);
      if (m.rawInputValue !== inputValue) {
        m.reset();
        m.append(inputValue, {
          raw: true
        });
      } else if (!isCurrent) {
        m.remove(startInputPos);
      }
      m.append(appended, masked.currentMaskFlags(flags));
      m.appendTail(tail);
      return {
        index,
        weight: m.rawInputValue.length,
        totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT)))
      };
    });
    inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;
const PIPE_TYPE = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function createPipe(mask) {
  let from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PIPE_TYPE.MASKED;
  let to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : PIPE_TYPE.MASKED;
  const masked = createMask(mask);
  return (value) => masked.runIsolated((m) => {
    m[from] = value;
    return m[to];
  });
}
function pipe(value) {
  for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipeArgs[_key - 1] = arguments[_key];
  }
  return createPipe(...pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;
try {
  globalThis.IMask = IMask;
} catch (e) {
}
function _objectDestructuringEmpty(obj) {
  if (obj == null)
    throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
    );
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
const MASK_PROPS = {
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.instanceOf(RegExp), PropTypes.oneOf([Date, Number, IMask.Masked]), PropTypes.instanceOf(IMask.Masked)]),
  value: PropTypes.any,
  unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["typed"])]),
  prepare: PropTypes.func,
  validate: PropTypes.func,
  commit: PropTypes.func,
  overwrite: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["shift"])]),
  eager: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["append", "remove"])]),
  skipInvalid: PropTypes.bool,
  onAccept: PropTypes.func,
  onComplete: PropTypes.func,
  placeholderChar: PropTypes.string,
  displayChar: PropTypes.string,
  lazy: PropTypes.bool,
  definitions: PropTypes.object,
  blocks: PropTypes.object,
  pattern: PropTypes.string,
  format: PropTypes.func,
  parse: PropTypes.func,
  autofix: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["pad"])]),
  radix: PropTypes.string,
  thousandsSeparator: PropTypes.string,
  mapToRadix: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.number,
  signed: PropTypes.bool,
  normalizeZeros: PropTypes.bool,
  padFractionalZeros: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  dispatch: PropTypes.func,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })])
};
const MASK_PROPS_NAMES = Object.keys(MASK_PROPS).filter((p) => p !== "value");
const NON_MASK_OPTIONS_PROPS_NAMES = ["value", "unmask", "onAccept", "onComplete", "inputRef"];
const MASK_OPTIONS_PROPS_NAMES = MASK_PROPS_NAMES.filter((pName) => NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0);
function IMaskMixin(ComposedComponent) {
  const MaskedComponent = class extends React.Component {
    constructor(props) {
      super(props);
      this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      if (!this.props.mask)
        return;
      this.initMask();
    }
    componentDidUpdate() {
      const props = this.props;
      const maskOptions = this._extractMaskOptionsFromProps(props);
      if (maskOptions.mask) {
        if (this.maskRef) {
          this.maskRef.updateOptions(maskOptions);
          if ("value" in props)
            this.maskValue = props.value;
        } else {
          this.initMask(maskOptions);
        }
      } else {
        this.destroyMask();
        if ("value" in props)
          this.element.value = props.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(el) {
      this.element = el;
      if (this.props.inputRef) {
        if (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current"))
          this.props.inputRef.current = el;
        else
          this.props.inputRef(el);
      }
    }
    initMask() {
      let maskOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._extractMaskOptionsFromProps(this.props);
      this.maskRef = IMask(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
      if ("value" in this.props)
        this.maskValue = this.props.value;
    }
    destroyMask() {
      if (this.maskRef) {
        this.maskRef.destroy();
        delete this.maskRef;
      }
    }
    _extractMaskOptionsFromProps(props) {
      const cloneProps = Object.assign({}, (_objectDestructuringEmpty(props), props));
      Object.keys(cloneProps).filter((prop) => MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0).forEach((nonMaskProp) => {
        delete cloneProps[nonMaskProp];
      });
      return cloneProps;
    }
    _extractNonMaskProps(props) {
      const _ref = props, cloneProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
      MASK_PROPS_NAMES.forEach((maskProp) => {
        delete cloneProps[maskProp];
      });
      if (!("defaultValue" in cloneProps))
        cloneProps.defaultValue = props.mask ? "" : cloneProps.value;
      delete cloneProps.value;
      return cloneProps;
    }
    get maskValue() {
      if (this.props.unmask === "typed")
        return this.maskRef.typedValue;
      if (this.props.unmask)
        return this.maskRef.unmaskedValue;
      return this.maskRef.value;
    }
    set maskValue(value) {
      value = value == null && this.props.unmask !== "typed" ? "" : value;
      if (this.props.unmask === "typed")
        this.maskRef.typedValue = value;
      else if (this.props.unmask)
        this.maskRef.unmaskedValue = value;
      else
        this.maskRef.value = value;
    }
    _onAccept(e) {
      if (this.props.onAccept && this.maskRef)
        this.props.onAccept(this.maskValue, this.maskRef, e);
    }
    _onComplete(e) {
      if (this.props.onComplete && this.maskRef)
        this.props.onComplete(this.maskValue, this.maskRef, e);
    }
    render() {
      return React.createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), {
        inputRef: this._inputRef
      }));
    }
  };
  const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
  MaskedComponent.propTypes = MASK_PROPS;
  return React.forwardRef((props, ref) => React.createElement(MaskedComponent, Object.assign({}, props, {
    ref
  })));
}
const _excluded = ["inputRef"];
const IMaskInputClass = IMaskMixin((_ref) => {
  let {
    inputRef
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement("input", Object.assign({}, props, {
    ref: inputRef
  }));
});
const IMaskInputFn = (props, ref) => React.createElement(IMaskInputClass, Object.assign({}, props, {
  ref
}));
const IMaskInput = React.forwardRef(IMaskInputFn);
const Wrapper$f = styled.div`
  border: none;
  padding: 0;
  margin: 0;

  input {
    width: 100%;
    background: transparent;
    color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    display: block;
  }

  label {
    cursor: pointer;
    color: ${({ theme }) => theme.themeColors.text};
  }

  input::placeholder {
    color: ${({ theme }) => convertHexToRGBA(theme.themeColors.text, 0.3)};
  }

  .input-text-prefix,
  input,
  input::placeholder {
    font-size: 16px;
    line-height: 18px;
  }
`;
const InputWrapper$1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const ErrorMessage$5 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const Prefix = styled.div`
  margin-right: 2px;

  &,
  * {
    color: ${({ theme }) => theme.themeColors.text};
  }
`;
const generateMaskOptions = (maskType) => {
  if (INPUT_MASK_TYPES.phone === maskType) {
    return {
      mask: "000-000-0000"
    };
  }
  if (INPUT_MASK_TYPES.dollarAmount === maskType) {
    return {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: ",",
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: ".",
      mapToRadix: ["."],
      max: 1e6
    };
  }
  if (INPUT_MASK_TYPES.centsAmount === maskType) {
    return {
      mask: Number,
      scale: 2,
      signed: true,
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: ".",
      mapToRadix: ["."],
      max: 0.99
    };
  }
  return {
    mask: null
  };
};
const TextInput = ({
  name: name2,
  inputRef,
  type,
  prefix,
  value,
  valueSanitizer,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  label,
  error,
  disabled,
  inputProps,
  autoFocus,
  maskType
}) => {
  const ref = React.useRef(null);
  const [opts, setOpts] = React.useState(generateMaskOptions(maskType));
  const [isFocused, setIsFocused] = React.useState(false);
  React.useEffect(() => {
    var _a, _b;
    if (autoFocus) {
      (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.focus();
      (_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.focus();
    }
  }, []);
  const handleChange = React.useCallback(
    (e) => {
      if (opts.mask) {
        return;
      }
      const prevValue = value;
      let newValue = e.target.value;
      if (valueSanitizer) {
        newValue = valueSanitizer(newValue, prevValue);
      }
      onChange(name2)(newValue);
    },
    [value, onChange, valueSanitizer, opts]
  );
  const handleAccept = React.useCallback(
    (v) => {
      onChange(name2)(v);
    },
    [value, onChange, valueSanitizer]
  );
  const handleFocus = () => {
    setIsFocused(true);
    onFocus && onFocus(name2);
  };
  const handleBlur = () => {
    setIsFocused(false);
    onBlur && onBlur(name2);
  };
  return /* @__PURE__ */ React.createElement(Wrapper$f, {
    className: `text-wrapper ${isFocused ? "focused" : ""}`
  }, /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, label && /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputWrapper$1, {
    className: "sc-input-wrapper"
  }, prefix && /* @__PURE__ */ React.createElement(Prefix, {
    className: "input-text-prefix"
  }, prefix), !!maskType ? /* @__PURE__ */ React.createElement(IMaskInput, {
    ...opts,
    inputRef: (el) => ref.current = el,
    id: name2,
    type: type || "text",
    name: name2,
    placeholder: placeholder || "",
    value,
    onChange: handleChange,
    onAccept: (value2, mask) => {
      handleAccept(value2);
    },
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled,
    ...inputProps || {}
  }) : /* @__PURE__ */ React.createElement("input", {
    ref: inputRef || ref,
    id: name2,
    type: type || "text",
    name: name2,
    placeholder: placeholder || "",
    value,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled,
    ...inputProps || {}
  })), error && /* @__PURE__ */ React.createElement(ErrorMessage$5, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
var reactDayPicker_min = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t(React);
  }("undefined" != typeof self ? self : commonjsGlobal, function(e) {
    return function(e2) {
      function t(o) {
        if (n[o])
          return n[o].exports;
        var r = n[o] = { i: o, l: false, exports: {} };
        return e2[o].call(r.exports, r, r.exports, t), r.l = true, r.exports;
      }
      var n = {};
      return t.m = e2, t.c = n, t.d = function(e3, n2, o) {
        t.o(e3, n2) || Object.defineProperty(e3, n2, { configurable: false, enumerable: true, get: o });
      }, t.n = function(e3) {
        var n2 = e3 && e3.__esModule ? function() {
          return e3.default;
        } : function() {
          return e3;
        };
        return t.d(n2, "a", n2), n2;
      }, t.o = function(e3, t2) {
        return Object.prototype.hasOwnProperty.call(e3, t2);
      }, t.p = "", t(t.s = 8);
    }([function(t, n) {
      t.exports = e;
    }, function(e2, t, n) {
      function o(e3) {
        return new Date(e3.getTime());
      }
      function r(e3) {
        return e3 instanceof Date && !isNaN(e3.valueOf());
      }
      function a(e3, t2) {
        var n2 = o(e3);
        return n2.setMonth(e3.getMonth() + t2), n2;
      }
      function s(e3, t2) {
        return !(!e3 || !t2) && (e3.getDate() === t2.getDate() && e3.getMonth() === t2.getMonth() && e3.getFullYear() === t2.getFullYear());
      }
      function i(e3, t2) {
        return !(!e3 || !t2) && (e3.getMonth() === t2.getMonth() && e3.getFullYear() === t2.getFullYear());
      }
      function u(e3, t2) {
        return o(e3).setHours(0, 0, 0, 0) < o(t2).setHours(0, 0, 0, 0);
      }
      function l(e3, t2) {
        return o(e3).setHours(0, 0, 0, 0) > o(t2).setHours(0, 0, 0, 0);
      }
      function c(e3) {
        var t2 = new Date();
        return t2.setHours(0, 0, 0, 0), u(e3, t2);
      }
      function p(e3) {
        var t2 = new Date(new Date().getTime() + 864e5);
        return t2.setHours(0, 0, 0, 0), e3 >= t2;
      }
      function f(e3, t2, n2) {
        var r2 = o(e3);
        return r2.setHours(0, 0, 0, 0), l(r2, t2) && u(r2, n2) || l(r2, n2) && u(r2, t2);
      }
      function h(e3) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { from: null, to: null }, n2 = t2.from, o2 = t2.to;
        return n2 ? n2 && o2 && s(n2, o2) && s(e3, n2) ? (n2 = null, o2 = null) : o2 && u(e3, n2) ? n2 = e3 : o2 && s(e3, o2) ? (n2 = e3, o2 = e3) : (o2 = e3, u(o2, n2) && (o2 = n2, n2 = e3)) : n2 = e3, { from: n2, to: o2 };
      }
      function d(e3, t2) {
        var n2 = t2.from, o2 = t2.to;
        return n2 && s(e3, n2) || o2 && s(e3, o2) || n2 && o2 && f(e3, n2, o2);
      }
      function y(e3) {
        var t2 = o(e3);
        return t2.setHours(0, 0, 0), t2.setDate(t2.getDate() + 4 - (t2.getDay() || 7)), Math.ceil(((t2 - new Date(t2.getFullYear(), 0, 1)) / 864e5 + 1) / 7);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.clone = o, t.isDate = r, t.addMonths = a, t.isSameDay = s, t.isSameMonth = i, t.isDayBefore = u, t.isDayAfter = l, t.isPastDay = c, t.isFutureDay = p, t.isDayBetween = f, t.addDayToRange = h, t.isDayInRange = d, t.getWeekNumber = y, t.default = { addDayToRange: h, addMonths: a, clone: o, getWeekNumber: y, isDate: r, isDayAfter: l, isDayBefore: u, isDayBetween: f, isDayInRange: d, isFutureDay: p, isPastDay: c, isSameDay: s, isSameMonth: i };
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      t.LEFT = 37, t.UP = 38, t.RIGHT = 39, t.DOWN = 40, t.ENTER = 13, t.SPACE = 32, t.ESC = 27, t.TAB = 9;
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true }), t.default = { container: "DayPicker", wrapper: "DayPicker-wrapper", interactionDisabled: "DayPicker--interactionDisabled", months: "DayPicker-Months", month: "DayPicker-Month", navBar: "DayPicker-NavBar", navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev", navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next", navButtonInteractionDisabled: "DayPicker-NavButton--interactionDisabled", caption: "DayPicker-Caption", weekdays: "DayPicker-Weekdays", weekdaysRow: "DayPicker-WeekdaysRow", weekday: "DayPicker-Weekday", body: "DayPicker-Body", week: "DayPicker-Week", weekNumber: "DayPicker-WeekNumber", day: "DayPicker-Day", footer: "DayPicker-Footer", todayButton: "DayPicker-TodayButton", today: "today", selected: "selected", disabled: "disabled", outside: "outside" };
    }, function(e2, t, n) {
      function o(e3) {
        e3.preventDefault(), e3.stopPropagation();
      }
      function r(e3) {
        return new Date(e3.getFullYear(), e3.getMonth(), 1, 12);
      }
      function a(e3) {
        var t2 = r(e3);
        return t2.setMonth(t2.getMonth() + 1), t2.setDate(t2.getDate() - 1), t2.getDate();
      }
      function s(e3) {
        var t2 = y({}, e3.modifiers);
        return e3.selectedDays && (t2[e3.classNames.selected] = e3.selectedDays), e3.disabledDays && (t2[e3.classNames.disabled] = e3.disabledDays), t2;
      }
      function i(e3) {
        var t2 = e3.firstDayOfWeek, n2 = e3.locale, o2 = void 0 === n2 ? "en" : n2, r2 = e3.localeUtils, a2 = void 0 === r2 ? {} : r2;
        return isNaN(t2) ? a2.getFirstDayOfWeek ? a2.getFirstDayOfWeek(o2) : 0 : t2;
      }
      function u(e3) {
        return !!(e3 && e3.from && e3.to);
      }
      function l(e3, t2) {
        return t2.getMonth() - e3.getMonth() + 12 * (t2.getFullYear() - e3.getFullYear());
      }
      function c(e3) {
        for (var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, m.getFirstDayOfWeek)(), n2 = arguments[2], o2 = a(e3), r2 = [], s2 = [], i2 = [], u2 = 1; u2 <= o2; u2 += 1)
          r2.push(new Date(e3.getFullYear(), e3.getMonth(), u2, 12));
        r2.forEach(function(e4) {
          s2.length > 0 && e4.getDay() === t2 && (i2.push(s2), s2 = []), s2.push(e4), r2.indexOf(e4) === r2.length - 1 && i2.push(s2);
        });
        for (var l2 = i2[0], c2 = 7 - l2.length; c2 > 0; c2 -= 1) {
          var p2 = (0, v.clone)(l2[0]);
          p2.setDate(l2[0].getDate() - 1), l2.unshift(p2);
        }
        for (var f2 = i2[i2.length - 1], h2 = f2.length; h2 < 7; h2 += 1) {
          var d2 = (0, v.clone)(f2[f2.length - 1]);
          d2.setDate(f2[f2.length - 1].getDate() + 1), f2.push(d2);
        }
        if (n2 && i2.length < 6)
          for (var y2 = void 0, k2 = i2.length; k2 < 6; k2 += 1) {
            y2 = i2[i2.length - 1];
            for (var D2 = y2[y2.length - 1], b = [], g = 0; g < 7; g += 1) {
              var w = (0, v.clone)(D2);
              w.setDate(D2.getDate() + g + 1), b.push(w);
            }
            i2.push(b);
          }
        return i2;
      }
      function p(e3) {
        var t2 = (0, v.clone)(e3);
        return t2.setDate(1), t2.setHours(12, 0, 0, 0), t2;
      }
      function f(e3, t2) {
        var n2 = void 0;
        n2 = t2 === D.default ? t2.day + "--" + t2.outside : "" + t2.outside;
        var o2 = t2.day.replace(/ /g, "."), r2 = n2.replace(/ /g, "."), a2 = "." + o2 + ":not(." + r2 + ")";
        return e3.querySelectorAll(a2);
      }
      function h(e3) {
        return Array.prototype.slice.call(e3, 0);
      }
      function d(e3, t2) {
        return Object.prototype.hasOwnProperty.call(e3, t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var y = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      };
      t.cancelEvent = o, t.getFirstDayOfMonth = r, t.getDaysInMonth = a, t.getModifiersFromProps = s, t.getFirstDayOfWeekFromProps = i, t.isRangeOfDates = u, t.getMonthsDiff = l, t.getWeekArray = c, t.startOfMonth = p, t.getDayNodes = f, t.nodeListToArray = h, t.hasOwnProp = d;
      var v = n(1), m = n(5), k = n(3), D = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(k);
    }, function(e2, t, n) {
      function o(e3) {
        return e3.toDateString();
      }
      function r(e3) {
        return p[e3.getMonth()] + " " + e3.getFullYear();
      }
      function a(e3) {
        return c[e3];
      }
      function s(e3) {
        return l[e3];
      }
      function i() {
        return 0;
      }
      function u() {
        return p;
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.formatDay = o, t.formatMonthTitle = r, t.formatWeekdayShort = a, t.formatWeekdayLong = s, t.getFirstDayOfWeek = i, t.getMonths = u;
      var l = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], c = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], p = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      t.default = { formatDay: o, formatMonthTitle: r, formatWeekdayShort: a, formatWeekdayLong: s, getFirstDayOfWeek: i, getMonths: u };
    }, function(e2, t, n) {
      function o(e3, t2) {
        return !!t2 && (Array.isArray(t2) ? t2 : [t2]).some(function(t3) {
          return !!t3 && (t3 instanceof Date ? (0, a.isSameDay)(e3, t3) : (0, s.isRangeOfDates)(t3) ? (0, a.isDayInRange)(e3, t3) : t3.after && t3.before && (0, a.isDayAfter)(t3.before, t3.after) ? (0, a.isDayAfter)(e3, t3.after) && (0, a.isDayBefore)(e3, t3.before) : t3.after && t3.before && ((0, a.isDayAfter)(t3.after, t3.before) || (0, a.isSameDay)(t3.after, t3.before)) ? (0, a.isDayAfter)(e3, t3.after) || (0, a.isDayBefore)(e3, t3.before) : t3.after ? (0, a.isDayAfter)(e3, t3.after) : t3.before ? (0, a.isDayBefore)(e3, t3.before) : t3.daysOfWeek ? t3.daysOfWeek.some(function(t4) {
            return e3.getDay() === t4;
          }) : "function" == typeof t3 && t3(e3));
        });
      }
      function r(e3) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Object.keys(t2).reduce(function(n2, r2) {
          var a2 = t2[r2];
          return o(e3, a2) && n2.push(r2), n2;
        }, []);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.dayMatchesModifier = o, t.getModifiersForDay = r;
      var a = n(1), s = n(4);
      t.default = { dayMatchesModifier: o, getModifiersForDay: r };
    }, function(e2, t, n) {
      function o(e3) {
        if (e3 && e3.__esModule)
          return e3;
        var t2 = {};
        if (null != e3)
          for (var n2 in e3)
            Object.prototype.hasOwnProperty.call(e3, n2) && (t2[n2] = e3[n2]);
        return t2.default = e3, t2;
      }
      function r(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function a(e3, t2) {
        var n2 = {};
        for (var o2 in e3)
          t2.indexOf(o2) >= 0 || Object.prototype.hasOwnProperty.call(e3, o2) && (n2[o2] = e3[o2]);
        return n2;
      }
      function s(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function u(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.ModifiersUtils = t.LocaleUtils = t.DateUtils = t.DayPicker = void 0;
      var l = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      }, c = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), p = n(0), f = r(p), h = n(9), d = r(h), y = n(10), v = r(y), m = n(11), k = r(m), D = n(14), b = r(D), g = n(4), w = o(g), M = n(1), P = o(M), O = n(5), N = o(O), C = n(6), E = o(C), _ = n(3), j = r(_), x = n(2), T = t.DayPicker = function(e3) {
        function t2(e4) {
          s(this, t2);
          var n2 = i(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          n2.dayPicker = null, n2.showNextMonth = function(e5) {
            if (n2.allowNextMonth()) {
              var t3 = n2.props.pagedNavigation ? n2.props.numberOfMonths : 1, o3 = P.addMonths(n2.state.currentMonth, t3);
              n2.showMonth(o3, e5);
            }
          }, n2.showPreviousMonth = function(e5) {
            if (n2.allowPreviousMonth()) {
              var t3 = n2.props.pagedNavigation ? n2.props.numberOfMonths : 1, o3 = P.addMonths(n2.state.currentMonth, -t3);
              n2.showMonth(o3, e5);
            }
          }, n2.handleKeyDown = function(e5) {
            switch (e5.persist(), e5.keyCode) {
              case x.LEFT:
                "rtl" === n2.props.dir ? n2.showNextMonth() : n2.showPreviousMonth(), w.cancelEvent(e5);
                break;
              case x.RIGHT:
                "rtl" === n2.props.dir ? n2.showPreviousMonth() : n2.showNextMonth(), w.cancelEvent(e5);
                break;
              case x.UP:
                n2.showPreviousYear(), w.cancelEvent(e5);
                break;
              case x.DOWN:
                n2.showNextYear(), w.cancelEvent(e5);
            }
            n2.props.onKeyDown && n2.props.onKeyDown(e5);
          }, n2.handleDayKeyDown = function(e5, t3, o3) {
            switch (o3.persist(), o3.keyCode) {
              case x.LEFT:
                w.cancelEvent(o3), "rtl" === n2.props.dir ? n2.focusNextDay(o3.target) : n2.focusPreviousDay(o3.target);
                break;
              case x.RIGHT:
                w.cancelEvent(o3), "rtl" === n2.props.dir ? n2.focusPreviousDay(o3.target) : n2.focusNextDay(o3.target);
                break;
              case x.UP:
                w.cancelEvent(o3), n2.focusPreviousWeek(o3.target);
                break;
              case x.DOWN:
                w.cancelEvent(o3), n2.focusNextWeek(o3.target);
                break;
              case x.ENTER:
              case x.SPACE:
                w.cancelEvent(o3), n2.props.onDayClick && n2.handleDayClick(e5, t3, o3);
            }
            n2.props.onDayKeyDown && n2.props.onDayKeyDown(e5, t3, o3);
          }, n2.handleDayClick = function(e5, t3, o3) {
            o3.persist(), t3[n2.props.classNames.outside] && n2.props.enableOutsideDaysClick && n2.handleOutsideDayClick(e5), n2.props.onDayClick && n2.props.onDayClick(e5, t3, o3);
          }, n2.handleTodayButtonClick = function(e5) {
            var t3 = new Date(), o3 = new Date(t3.getFullYear(), t3.getMonth());
            n2.showMonth(o3), e5.target.blur(), n2.props.onTodayButtonClick && (e5.persist(), n2.props.onTodayButtonClick(new Date(t3.getFullYear(), t3.getMonth(), t3.getDate()), E.getModifiersForDay(t3, n2.props.modifiers), e5));
          };
          var o2 = n2.getCurrentMonthFromProps(e4);
          return n2.state = { currentMonth: o2 }, n2;
        }
        return u(t2, e3), c(t2, [{ key: "componentDidUpdate", value: function(e4) {
          if (e4.month !== this.props.month && !P.isSameMonth(e4.month, this.props.month)) {
            var t3 = this.getCurrentMonthFromProps(this.props);
            this.setState({ currentMonth: t3 });
          }
        } }, { key: "getCurrentMonthFromProps", value: function(e4) {
          var t3 = w.startOfMonth(e4.month || e4.initialMonth || new Date()), n2 = t3;
          if (e4.pagedNavigation && e4.numberOfMonths > 1 && e4.fromMonth) {
            var o2 = w.startOfMonth(e4.fromMonth), r2 = w.getMonthsDiff(o2, n2);
            n2 = P.addMonths(o2, Math.floor(r2 / e4.numberOfMonths) * e4.numberOfMonths);
          } else
            e4.toMonth && e4.numberOfMonths > 1 && w.getMonthsDiff(n2, e4.toMonth) <= 0 && (n2 = P.addMonths(w.startOfMonth(e4.toMonth), 1 - this.props.numberOfMonths));
          return n2;
        } }, { key: "getNextNavigableMonth", value: function() {
          return P.addMonths(this.state.currentMonth, this.props.numberOfMonths);
        } }, { key: "getPreviousNavigableMonth", value: function() {
          return P.addMonths(this.state.currentMonth, -1);
        } }, { key: "allowPreviousMonth", value: function() {
          var e4 = P.addMonths(this.state.currentMonth, -1);
          return this.allowMonth(e4);
        } }, { key: "allowNextMonth", value: function() {
          var e4 = P.addMonths(this.state.currentMonth, this.props.numberOfMonths);
          return this.allowMonth(e4);
        } }, { key: "allowMonth", value: function(e4) {
          var t3 = this.props, n2 = t3.fromMonth, o2 = t3.toMonth;
          return !(!t3.canChangeMonth || n2 && w.getMonthsDiff(n2, e4) < 0 || o2 && w.getMonthsDiff(o2, e4) > 0);
        } }, { key: "allowYearChange", value: function() {
          return this.props.canChangeMonth;
        } }, { key: "showMonth", value: function(e4, t3) {
          var n2 = this;
          this.allowMonth(e4) && this.setState({ currentMonth: w.startOfMonth(e4) }, function() {
            t3 && t3(), n2.props.onMonthChange && n2.props.onMonthChange(n2.state.currentMonth);
          });
        } }, { key: "showNextYear", value: function() {
          if (this.allowYearChange()) {
            var e4 = P.addMonths(this.state.currentMonth, 12);
            this.showMonth(e4);
          }
        } }, { key: "showPreviousYear", value: function() {
          if (this.allowYearChange()) {
            var e4 = P.addMonths(this.state.currentMonth, -12);
            this.showMonth(e4);
          }
        } }, { key: "focus", value: function() {
          this.wrapper.focus();
        } }, { key: "focusFirstDayOfMonth", value: function() {
          w.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
        } }, { key: "focusLastDayOfMonth", value: function() {
          var e4 = w.getDayNodes(this.dayPicker, this.props.classNames);
          e4[e4.length - 1].focus();
        } }, { key: "focusPreviousDay", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          -1 !== o2 && (0 === o2 ? this.showPreviousMonth(function() {
            return t3.focusLastDayOfMonth();
          }) : n2[o2 - 1].focus());
        } }, { key: "focusNextDay", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          -1 !== o2 && (o2 === n2.length - 1 ? this.showNextMonth(function() {
            return t3.focusFirstDayOfMonth();
          }) : n2[o2 + 1].focus());
        } }, { key: "focusNextWeek", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 > n2.length - 8 ? this.showNextMonth(function() {
            var e5 = n2.length - o2, r2 = 7 - e5;
            w.getDayNodes(t3.dayPicker, t3.props.classNames)[r2].focus();
          }) : n2[o2 + 7].focus();
        } }, { key: "focusPreviousWeek", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 <= 6 ? this.showPreviousMonth(function() {
            var e5 = w.getDayNodes(t3.dayPicker, t3.props.classNames);
            e5[e5.length - 7 + o2].focus();
          }) : n2[o2 - 7].focus();
        } }, { key: "handleOutsideDayClick", value: function(e4) {
          var t3 = this.state.currentMonth, n2 = this.props.numberOfMonths, o2 = w.getMonthsDiff(t3, e4);
          o2 > 0 && o2 >= n2 ? this.showNextMonth() : o2 < 0 && this.showPreviousMonth();
        } }, { key: "renderNavbar", value: function() {
          var e4 = this.props, t3 = e4.labels, n2 = e4.locale, o2 = e4.localeUtils, r2 = e4.canChangeMonth, s2 = e4.navbarElement, i2 = a(e4, ["labels", "locale", "localeUtils", "canChangeMonth", "navbarElement"]);
          if (!r2)
            return null;
          var u2 = { month: this.state.currentMonth, classNames: this.props.classNames, className: this.props.classNames.navBar, nextMonth: this.getNextNavigableMonth(), previousMonth: this.getPreviousNavigableMonth(), showPreviousButton: this.allowPreviousMonth(), showNextButton: this.allowNextMonth(), onNextClick: this.showNextMonth, onPreviousClick: this.showPreviousMonth, dir: i2.dir, labels: t3, locale: n2, localeUtils: o2 };
          return f.default.isValidElement(s2) ? f.default.cloneElement(s2, u2) : f.default.createElement(s2, u2);
        } }, { key: "renderMonths", value: function() {
          for (var e4 = [], t3 = w.getFirstDayOfWeekFromProps(this.props), n2 = 0; n2 < this.props.numberOfMonths; n2 += 1) {
            var o2 = P.addMonths(this.state.currentMonth, n2);
            e4.push(f.default.createElement(k.default, l({ key: n2 }, this.props, { month: o2, firstDayOfWeek: t3, onDayKeyDown: this.handleDayKeyDown, onDayClick: this.handleDayClick })));
          }
          return this.props.reverseMonths && e4.reverse(), e4;
        } }, { key: "renderFooter", value: function() {
          return this.props.todayButton ? f.default.createElement("div", { className: this.props.classNames.footer }, this.renderTodayButton()) : null;
        } }, { key: "renderTodayButton", value: function() {
          return f.default.createElement("button", { type: "button", tabIndex: 0, className: this.props.classNames.todayButton, "aria-label": this.props.todayButton, onClick: this.handleTodayButtonClick }, this.props.todayButton);
        } }, { key: "render", value: function() {
          var e4 = this, t3 = this.props.classNames.container;
          return this.props.onDayClick || (t3 = t3 + " " + this.props.classNames.interactionDisabled), this.props.className && (t3 = t3 + " " + this.props.className), f.default.createElement("div", l({}, this.props.containerProps, { className: t3, ref: function(t4) {
            return e4.dayPicker = t4;
          }, lang: this.props.locale }), f.default.createElement("div", { className: this.props.classNames.wrapper, ref: function(t4) {
            return e4.wrapper = t4;
          }, tabIndex: this.props.canChangeMonth && void 0 !== this.props.tabIndex ? this.props.tabIndex : -1, onKeyDown: this.handleKeyDown, onFocus: this.props.onFocus, onBlur: this.props.onBlur }, this.renderNavbar(), f.default.createElement("div", { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
        } }]), t2;
      }(p.Component);
      T.defaultProps = { classNames: j.default, tabIndex: 0, numberOfMonths: 1, labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, locale: "en", localeUtils: N, showOutsideDays: false, enableOutsideDaysClick: true, fixedWeeks: false, canChangeMonth: true, reverseMonths: false, pagedNavigation: false, showWeekNumbers: false, showWeekDays: true, renderDay: function(e3) {
        return e3.getDate();
      }, renderWeek: function(e3) {
        return e3;
      }, weekdayElement: f.default.createElement(b.default, null), navbarElement: f.default.createElement(v.default, { classNames: j.default }), captionElement: f.default.createElement(d.default, { classNames: j.default }) }, T.VERSION = "7.4.10", T.DateUtils = P, T.LocaleUtils = N, T.ModifiersUtils = E, t.DateUtils = P, t.LocaleUtils = N, t.ModifiersUtils = E, t.default = T;
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var o = n(7).default;
      o.Input = n(15).default, t.default = o;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function s(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), u = n(0), l = o(u), c = n(5), p = o(c), f = n(2), h = function(e3) {
        function t2(e4) {
          r(this, t2);
          var n2 = a(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          return n2.handleKeyUp = n2.handleKeyUp.bind(n2), n2;
        }
        return s(t2, e3), i(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return e4.locale !== this.props.locale || e4.classNames !== this.props.classNames || e4.date.getMonth() !== this.props.date.getMonth() || e4.date.getFullYear() !== this.props.date.getFullYear();
        } }, { key: "handleKeyUp", value: function(e4) {
          e4.keyCode === f.ENTER && this.props.onClick(e4);
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.date, o2 = e4.months, r2 = e4.locale, a2 = e4.localeUtils, s2 = e4.onClick;
          return l.default.createElement("div", { className: t3.caption, role: "heading", "aria-live": "polite" }, l.default.createElement("div", { onClick: s2, onKeyUp: this.handleKeyUp }, o2 ? o2[n2.getMonth()] + " " + n2.getFullYear() : a2.formatMonthTitle(n2, r2)));
        } }]), t2;
      }(u.Component);
      h.defaultProps = { localeUtils: p.default }, t.default = h;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function s(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), u = n(0), l = o(u), c = n(3), p = o(c), f = n(2), h = function(e3) {
        function t2() {
          var e4, n2, o2, s2;
          r(this, t2);
          for (var i2 = arguments.length, u2 = Array(i2), l2 = 0; l2 < i2; l2++)
            u2[l2] = arguments[l2];
          return n2 = o2 = a(this, (e4 = t2.__proto__ || Object.getPrototypeOf(t2)).call.apply(e4, [this].concat(u2))), o2.handleNextClick = function() {
            o2.props.onNextClick && o2.props.onNextClick();
          }, o2.handlePreviousClick = function() {
            o2.props.onPreviousClick && o2.props.onPreviousClick();
          }, o2.handleNextKeyDown = function(e5) {
            e5.keyCode !== f.ENTER && e5.keyCode !== f.SPACE || (e5.preventDefault(), o2.handleNextClick());
          }, o2.handlePreviousKeyDown = function(e5) {
            e5.keyCode !== f.ENTER && e5.keyCode !== f.SPACE || (e5.preventDefault(), o2.handlePreviousClick());
          }, s2 = n2, a(o2, s2);
        }
        return s(t2, e3), i(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return e4.labels !== this.props.labels || e4.dir !== this.props.dir || this.props.showPreviousButton !== e4.showPreviousButton || this.props.showNextButton !== e4.showNextButton;
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.className, o2 = e4.showPreviousButton, r2 = e4.showNextButton, a2 = e4.labels, s2 = e4.dir, i2 = void 0, u2 = void 0, c2 = void 0, p2 = void 0, f2 = void 0, h2 = void 0;
          "rtl" === s2 ? (i2 = this.handleNextClick, u2 = this.handlePreviousClick, c2 = this.handleNextKeyDown, p2 = this.handlePreviousKeyDown, h2 = o2, f2 = r2) : (i2 = this.handlePreviousClick, u2 = this.handleNextClick, c2 = this.handlePreviousKeyDown, p2 = this.handleNextKeyDown, h2 = r2, f2 = o2);
          var d = f2 ? t3.navButtonPrev : t3.navButtonPrev + " " + t3.navButtonInteractionDisabled, y = h2 ? t3.navButtonNext : t3.navButtonNext + " " + t3.navButtonInteractionDisabled, v = l.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": a2.previousMonth, key: "previous", className: d, onKeyDown: f2 ? c2 : void 0, onClick: f2 ? i2 : void 0 }), m = l.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": a2.nextMonth, key: "right", className: y, onKeyDown: h2 ? p2 : void 0, onClick: h2 ? u2 : void 0 });
          return l.default.createElement("div", { className: n2 || t3.navBar }, "rtl" === s2 ? [m, v] : [v, m]);
        } }]), t2;
      }(u.Component);
      h.defaultProps = { classNames: p.default, dir: "ltr", labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, showPreviousButton: true, showNextButton: true }, t.default = h;
    }, function(e2, t, n) {
      function o(e3) {
        if (e3 && e3.__esModule)
          return e3;
        var t2 = {};
        if (null != e3)
          for (var n2 in e3)
            Object.prototype.hasOwnProperty.call(e3, n2) && (t2[n2] = e3[n2]);
        return t2.default = e3, t2;
      }
      function r(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function a(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function s(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function i(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var u = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), l = n(0), c = r(l), p = n(12), f = r(p), h = n(13), d = r(h), y = n(2), v = n(6), m = o(v), k = n(4), D = o(k), b = n(1), g = o(b), w = function(e3) {
        function t2() {
          var e4, n2, o2, r2;
          a(this, t2);
          for (var i2 = arguments.length, u2 = Array(i2), l2 = 0; l2 < i2; l2++)
            u2[l2] = arguments[l2];
          return n2 = o2 = s(this, (e4 = t2.__proto__ || Object.getPrototypeOf(t2)).call.apply(e4, [this].concat(u2))), o2.renderDay = function(e5) {
            var t3 = o2.props.month.getMonth(), n3 = D.getModifiersFromProps(o2.props), r3 = m.getModifiersForDay(e5, n3);
            g.isSameDay(e5, new Date()) && !Object.prototype.hasOwnProperty.call(n3, o2.props.classNames.today) && r3.push(o2.props.classNames.today), e5.getMonth() !== t3 && r3.push(o2.props.classNames.outside);
            var a2 = e5.getMonth() !== t3, s2 = -1;
            o2.props.onDayClick && !a2 && 1 === e5.getDate() && (s2 = o2.props.tabIndex);
            var i3 = "" + e5.getFullYear() + e5.getMonth() + e5.getDate(), u3 = {};
            return r3.forEach(function(e6) {
              u3[e6] = true;
            }), c.default.createElement(d.default, { key: (a2 ? "outside-" : "") + i3, classNames: o2.props.classNames, day: e5, modifiers: u3, modifiersStyles: o2.props.modifiersStyles, empty: a2 && !o2.props.showOutsideDays && !o2.props.fixedWeeks, tabIndex: s2, ariaLabel: o2.props.localeUtils.formatDay(e5, o2.props.locale), ariaDisabled: a2 || r3.indexOf(o2.props.classNames.disabled) > -1, ariaSelected: r3.indexOf(o2.props.classNames.selected) > -1, onClick: o2.props.onDayClick, onFocus: o2.props.onDayFocus, onKeyDown: o2.props.onDayKeyDown, onMouseEnter: o2.props.onDayMouseEnter, onMouseLeave: o2.props.onDayMouseLeave, onMouseDown: o2.props.onDayMouseDown, onMouseUp: o2.props.onDayMouseUp, onTouchEnd: o2.props.onDayTouchEnd, onTouchStart: o2.props.onDayTouchStart }, o2.props.renderDay(e5, u3));
          }, r2 = n2, s(o2, r2);
        }
        return i(t2, e3), u(t2, [{ key: "render", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.classNames, o2 = t3.month, r2 = t3.months, a2 = t3.fixedWeeks, s2 = t3.captionElement, i2 = t3.weekdayElement, u2 = t3.locale, l2 = t3.localeUtils, p2 = t3.weekdaysLong, h2 = t3.weekdaysShort, d2 = t3.firstDayOfWeek, v2 = t3.onCaptionClick, m2 = t3.showWeekNumbers, k2 = t3.showWeekDays, b2 = t3.onWeekClick, w2 = { date: o2, classNames: n2, months: r2, localeUtils: l2, locale: u2, onClick: v2 ? function(e5) {
            return v2(o2, e5);
          } : void 0 }, M = c.default.isValidElement(s2) ? c.default.cloneElement(s2, w2) : c.default.createElement(s2, w2), P = D.getWeekArray(o2, d2, a2);
          return c.default.createElement("div", { className: n2.month, role: "grid" }, M, k2 && c.default.createElement(f.default, { classNames: n2, weekdaysShort: h2, weekdaysLong: p2, firstDayOfWeek: d2, showWeekNumbers: m2, locale: u2, localeUtils: l2, weekdayElement: i2 }), c.default.createElement("div", { className: n2.body, role: "rowgroup" }, P.map(function(t4) {
            var r3 = void 0;
            return m2 && (r3 = g.getWeekNumber(t4[6])), c.default.createElement("div", { key: t4[0].getTime(), className: n2.week, role: "row" }, m2 && c.default.createElement("div", { className: n2.weekNumber, tabIndex: b2 ? 0 : -1, role: "gridcell", onClick: b2 ? function(e5) {
              return b2(r3, t4, e5);
            } : void 0, onKeyUp: b2 ? function(e5) {
              return e5.keyCode === y.ENTER && b2(r3, t4, e5);
            } : void 0 }, e4.props.renderWeek(r3, t4, o2)), t4.map(e4.renderDay));
          })));
        } }]), t2;
      }(l.Component);
      t.default = w;
    }, function(e2, t, n) {
      function o(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function r(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function a(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var s = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), i = n(0), u = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(i), l = function(e3) {
        function t2() {
          return o(this, t2), r(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return a(t2, e3), s(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return this.props !== e4;
        } }, { key: "render", value: function() {
          for (var e4 = this.props, t3 = e4.classNames, n2 = e4.firstDayOfWeek, o2 = e4.showWeekNumbers, r2 = e4.weekdaysLong, a2 = e4.weekdaysShort, s2 = e4.locale, i2 = e4.localeUtils, l2 = e4.weekdayElement, c = [], p = 0; p < 7; p += 1) {
            var f = (p + n2) % 7, h = { key: p, className: t3.weekday, weekday: f, weekdaysLong: r2, weekdaysShort: a2, localeUtils: i2, locale: s2 }, d = u.default.isValidElement(l2) ? u.default.cloneElement(l2, h) : u.default.createElement(l2, h);
            c.push(d);
          }
          return u.default.createElement("div", { className: t3.weekdays, role: "rowgroup" }, u.default.createElement("div", { className: t3.weekdaysRow, role: "row" }, o2 && u.default.createElement("div", { className: t3.weekday }), c));
        } }]), t2;
      }(i.Component);
      t.default = l;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function s(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      function i(e3, t2, n2) {
        if (e3)
          return function(o2) {
            o2.persist(), e3(t2, n2, o2);
          };
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var u = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      }, l = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), c = n(0), p = o(c), f = n(1), h = n(4), d = n(3), y = o(d), v = function(e3) {
        function t2() {
          return r(this, t2), a(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return s(t2, e3), l(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          var t3 = this, n2 = Object.keys(this.props), o2 = Object.keys(e4);
          return n2.length !== o2.length || n2.some(function(n3) {
            if ("modifiers" === n3 || "modifiersStyles" === n3 || "classNames" === n3) {
              var o3 = t3.props[n3], r2 = e4[n3], a2 = Object.keys(o3), s2 = Object.keys(r2);
              return a2.length !== s2.length || a2.some(function(e5) {
                return !(0, h.hasOwnProp)(r2, e5) || o3[e5] !== r2[e5];
              });
            }
            return "day" === n3 ? !(0, f.isSameDay)(t3.props[n3], e4[n3]) : !(0, h.hasOwnProp)(e4, n3) || t3.props[n3] !== e4[n3];
          });
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.modifiersStyles, o2 = e4.day, r2 = e4.tabIndex, a2 = e4.empty, s2 = e4.modifiers, l2 = e4.onMouseEnter, c2 = e4.onMouseLeave, f2 = e4.onMouseUp, h2 = e4.onMouseDown, d2 = e4.onClick, v2 = e4.onKeyDown, m = e4.onTouchStart, k = e4.onTouchEnd, D = e4.onFocus, b = e4.ariaLabel, g = e4.ariaDisabled, w = e4.ariaSelected, M = e4.children, P = t3.day;
          t3 !== y.default ? P += " " + Object.keys(s2).join(" ") : P += Object.keys(s2).map(function(e5) {
            return " " + P + "--" + e5;
          }).join("");
          var O = void 0;
          return n2 && Object.keys(s2).filter(function(e5) {
            return !!n2[e5];
          }).forEach(function(e5) {
            O = u({}, O, n2[e5]);
          }), a2 ? p.default.createElement("div", { "aria-disabled": true, className: P, style: O }) : p.default.createElement("div", { className: P, tabIndex: r2, style: O, role: "gridcell", "aria-label": b, "aria-disabled": g, "aria-selected": w, onClick: i(d2, o2, s2), onKeyDown: i(v2, o2, s2), onMouseEnter: i(l2, o2, s2), onMouseLeave: i(c2, o2, s2), onMouseUp: i(f2, o2, s2), onMouseDown: i(h2, o2, s2), onTouchEnd: i(k, o2, s2), onTouchStart: i(m, o2, s2), onFocus: i(D, o2, s2) }, M);
        } }]), t2;
      }(c.Component);
      v.defaultProps = { tabIndex: -1 }, v.defaultProps = { modifiers: {}, modifiersStyles: {}, empty: false }, t.default = v;
    }, function(e2, t, n) {
      function o(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function r(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function a(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var s = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), i = n(0), u = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(i), l = function(e3) {
        function t2() {
          return o(this, t2), r(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return a(t2, e3), s(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return this.props !== e4;
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.weekday, n2 = e4.className, o2 = e4.weekdaysLong, r2 = e4.weekdaysShort, a2 = e4.localeUtils, s2 = e4.locale, i2 = void 0;
          i2 = o2 ? o2[t3] : a2.formatWeekdayLong(t3, s2);
          var l2 = void 0;
          return l2 = r2 ? r2[t3] : a2.formatWeekdayShort(t3, s2), u.default.createElement("div", { className: n2, role: "columnheader" }, u.default.createElement("abbr", { title: i2 }, l2));
        } }]), t2;
      }(i.Component);
      t.default = l;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2, n2) {
        return t2 in e3 ? Object.defineProperty(e3, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t2] = n2, e3;
      }
      function a(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function s(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e3 : t2;
      }
      function i(e3, t2) {
        if ("function" != typeof t2 && null !== t2)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      function u(e3, t2) {
        var n2 = {};
        for (var o2 in e3)
          t2.indexOf(o2) >= 0 || Object.prototype.hasOwnProperty.call(e3, o2) && (n2[o2] = e3[o2]);
        return n2;
      }
      function l(e3) {
        var t2 = (e3.input, e3.selectedDay, e3.month, e3.children), n2 = e3.classNames, o2 = u(e3, ["input", "selectedDay", "month", "children", "classNames"]);
        return y.default.createElement("div", h({ className: n2.overlayWrapper }, o2), y.default.createElement("div", { className: n2.overlay }, t2));
      }
      function c(e3) {
        if ((0, k.isDate)(e3)) {
          return e3.getFullYear() + "-" + ("" + (e3.getMonth() + 1)) + "-" + ("" + e3.getDate());
        }
        return "";
      }
      function p(e3) {
        if ("string" == typeof e3) {
          var t2 = e3.split("-");
          if (3 === t2.length) {
            var n2 = parseInt(t2[0], 10), o2 = parseInt(t2[1], 10) - 1, r2 = parseInt(t2[2], 10);
            if (!(isNaN(n2) || String(n2).length > 4 || isNaN(o2) || isNaN(r2) || r2 <= 0 || r2 > 31 || o2 < 0 || o2 >= 12))
              return new Date(n2, o2, r2, 12, 0, 0, 0);
          }
        }
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.HIDE_TIMEOUT = void 0;
      var f = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), h = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      };
      t.OverlayComponent = l, t.defaultFormat = c, t.defaultParse = p;
      var d = n(0), y = o(d), v = n(7), m = o(v), k = n(1), D = n(6), b = n(2), g = t.HIDE_TIMEOUT = 100, w = function(e3) {
        function t2(e4) {
          a(this, t2);
          var n2 = s(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          return n2.input = null, n2.daypicker = null, n2.clickTimeout = null, n2.hideTimeout = null, n2.inputBlurTimeout = null, n2.inputFocusTimeout = null, n2.state = n2.getInitialStateFromProps(e4), n2.state.showOverlay = e4.showOverlay, n2.hideAfterDayClick = n2.hideAfterDayClick.bind(n2), n2.handleInputClick = n2.handleInputClick.bind(n2), n2.handleInputFocus = n2.handleInputFocus.bind(n2), n2.handleInputBlur = n2.handleInputBlur.bind(n2), n2.handleInputChange = n2.handleInputChange.bind(n2), n2.handleInputKeyDown = n2.handleInputKeyDown.bind(n2), n2.handleInputKeyUp = n2.handleInputKeyUp.bind(n2), n2.handleDayClick = n2.handleDayClick.bind(n2), n2.handleMonthChange = n2.handleMonthChange.bind(n2), n2.handleOverlayFocus = n2.handleOverlayFocus.bind(n2), n2.handleOverlayBlur = n2.handleOverlayBlur.bind(n2), n2;
        }
        return i(t2, e3), f(t2, [{ key: "componentDidUpdate", value: function(e4) {
          var t3 = {}, n2 = this.props, o2 = n2.value, r2 = n2.formatDate, a2 = n2.format, s2 = n2.dayPickerProps;
          o2 === e4.value && s2.locale === e4.dayPickerProps.locale && a2 === e4.format || ((0, k.isDate)(o2) ? t3.value = r2(o2, a2, s2.locale) : t3.value = o2);
          var i2 = e4.dayPickerProps.month;
          s2.month && s2.month !== i2 && !(0, k.isSameMonth)(s2.month, i2) && (t3.month = s2.month), e4.dayPickerProps.selectedDays !== s2.selectedDays && (t3.selectedDays = s2.selectedDays), Object.keys(t3).length > 0 && this.setState(t3);
        } }, { key: "componentWillUnmount", value: function() {
          clearTimeout(this.clickTimeout), clearTimeout(this.hideTimeout), clearTimeout(this.inputFocusTimeout), clearTimeout(this.inputBlurTimeout), clearTimeout(this.overlayBlurTimeout);
        } }, { key: "getInitialMonthFromProps", value: function(e4) {
          var t3 = e4.dayPickerProps, n2 = e4.format, o2 = void 0;
          return e4.value && (o2 = (0, k.isDate)(e4.value) ? e4.value : e4.parseDate(e4.value, n2, t3.locale)), t3.initialMonth || t3.month || o2 || new Date();
        } }, { key: "getInitialStateFromProps", value: function(e4) {
          var t3 = e4.dayPickerProps, n2 = e4.formatDate, o2 = e4.format, r2 = e4.typedValue, a2 = e4.value;
          return e4.value && (0, k.isDate)(e4.value) && (a2 = n2(e4.value, o2, t3.locale)), { value: a2, typedValue: r2, month: this.getInitialMonthFromProps(e4), selectedDays: t3.selectedDays };
        } }, { key: "getInput", value: function() {
          return this.input;
        } }, { key: "getDayPicker", value: function() {
          return this.daypicker;
        } }, { key: "updateState", value: function(e4, t3, n2) {
          var o2 = this, a2 = this.props, s2 = a2.dayPickerProps, i2 = a2.onDayChange;
          this.setState({ month: e4, value: t3, typedValue: "" }, function() {
            if (n2 && n2(), i2) {
              var t4 = h({ disabled: s2.disabledDays, selected: s2.selectedDays }, s2.modifiers), a3 = (0, D.getModifiersForDay)(e4, t4).reduce(function(e5, t5) {
                return h({}, e5, r({}, t5, true));
              }, {});
              i2(e4, a3, o2);
            }
          });
        } }, { key: "showDayPicker", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.parseDate, o2 = t3.format, r2 = t3.dayPickerProps, a2 = this.state, s2 = a2.value;
          if (!a2.showOverlay) {
            var i2 = s2 ? n2(s2, o2, r2.locale) : this.getInitialMonthFromProps(this.props);
            this.setState(function(e5) {
              return { showOverlay: true, month: i2 || e5.month };
            }, function() {
              e4.props.onDayPickerShow && e4.props.onDayPickerShow();
            });
          }
        } }, { key: "hideDayPicker", value: function() {
          var e4 = this;
          false !== this.state.showOverlay && this.setState({ showOverlay: false }, function() {
            e4.props.onDayPickerHide && e4.props.onDayPickerHide();
          });
        } }, { key: "hideAfterDayClick", value: function() {
          var e4 = this;
          this.props.hideOnDayClick && (this.hideTimeout = setTimeout(function() {
            e4.overlayHasFocus = false, e4.hideDayPicker();
          }, g));
        } }, { key: "handleInputClick", value: function(e4) {
          this.showDayPicker(), this.props.inputProps.onClick && (e4.persist(), this.props.inputProps.onClick(e4));
        } }, { key: "handleInputFocus", value: function(e4) {
          var t3 = this;
          this.showDayPicker(), this.inputFocusTimeout = setTimeout(function() {
            t3.overlayHasFocus = false;
          }, 2), this.props.inputProps.onFocus && (e4.persist(), this.props.inputProps.onFocus(e4));
        } }, { key: "handleInputBlur", value: function(e4) {
          var t3 = this;
          this.inputBlurTimeout = setTimeout(function() {
            t3.overlayHasFocus || t3.hideDayPicker();
          }, 1), this.props.inputProps.onBlur && (e4.persist(), this.props.inputProps.onBlur(e4));
        } }, { key: "handleOverlayFocus", value: function(e4) {
          e4.preventDefault(), this.overlayHasFocus = true, this.props.keepFocus && this.input && "function" == typeof this.input.focus && this.input.focus();
        } }, { key: "handleOverlayBlur", value: function() {
          var e4 = this;
          this.overlayBlurTimeout = setTimeout(function() {
            e4.overlayHasFocus = false;
          }, 3);
        } }, { key: "handleInputChange", value: function(e4) {
          var t3 = this.props, n2 = t3.dayPickerProps, o2 = t3.format, r2 = t3.inputProps, a2 = t3.onDayChange, s2 = t3.parseDate;
          r2.onChange && (e4.persist(), r2.onChange(e4));
          var i2 = e4.target.value;
          if ("" === i2.trim())
            return this.setState({ value: i2, typedValue: "" }), void (a2 && a2(void 0, {}, this));
          var u2 = s2(i2, o2, n2.locale);
          if (!u2)
            return this.setState({ value: i2, typedValue: i2 }), void (a2 && a2(void 0, {}, this));
          this.updateState(u2, i2);
        } }, { key: "handleInputKeyDown", value: function(e4) {
          e4.keyCode === b.TAB ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyDown && (e4.persist(), this.props.inputProps.onKeyDown(e4));
        } }, { key: "handleInputKeyUp", value: function(e4) {
          e4.keyCode === b.ESC ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyUp && (e4.persist(), this.props.inputProps.onKeyUp(e4));
        } }, { key: "handleMonthChange", value: function(e4) {
          var t3 = this;
          this.setState({ month: e4 }, function() {
            t3.props.dayPickerProps && t3.props.dayPickerProps.onMonthChange && t3.props.dayPickerProps.onMonthChange(e4);
          });
        } }, { key: "handleDayClick", value: function(e4, t3, n2) {
          var o2 = this, r2 = this.props, a2 = r2.clickUnselectsDay, s2 = r2.dayPickerProps, i2 = r2.onDayChange, u2 = r2.formatDate, l2 = r2.format;
          if (s2.onDayClick && s2.onDayClick(e4, t3, n2), !(t3.disabled || s2 && s2.classNames && t3[s2.classNames.disabled])) {
            if (t3.selected && a2) {
              var c2 = this.state.selectedDays;
              if (Array.isArray(c2)) {
                c2 = c2.slice(0);
                var p2 = c2.indexOf(e4);
                c2.splice(p2, 1);
              } else
                c2 && (c2 = null);
              return this.setState({ value: "", typedValue: "", selectedDays: c2 }, this.hideAfterDayClick), void (i2 && i2(void 0, t3, this));
            }
            var f2 = u2(e4, l2, s2.locale);
            this.setState({ value: f2, typedValue: "", month: e4 }, function() {
              i2 && i2(e4, t3, o2), o2.hideAfterDayClick();
            });
          }
        } }, { key: "renderOverlay", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.classNames, o2 = t3.dayPickerProps, r2 = t3.parseDate, a2 = t3.formatDate, s2 = t3.format, i2 = this.state, u2 = i2.selectedDays, l2 = i2.value, c2 = void 0;
          if (!u2 && l2) {
            var p2 = r2(l2, s2, o2.locale);
            p2 && (c2 = p2);
          } else
            u2 && (c2 = u2);
          var f2 = void 0;
          o2.todayButton && (f2 = function() {
            return e4.updateState(new Date(), a2(new Date(), s2, o2.locale), e4.hideAfterDayClick);
          });
          var d2 = this.props.overlayComponent;
          return y.default.createElement(d2, { classNames: n2, month: this.state.month, selectedDay: c2, input: this.input, tabIndex: 0, onFocus: this.handleOverlayFocus, onBlur: this.handleOverlayBlur }, y.default.createElement(m.default, h({ ref: function(t4) {
            return e4.daypicker = t4;
          }, onTodayButtonClick: f2 }, o2, { month: this.state.month, selectedDays: c2, onDayClick: this.handleDayClick, onMonthChange: this.handleMonthChange })));
        } }, { key: "render", value: function() {
          var e4 = this, t3 = this.props.component, n2 = this.props.inputProps;
          return y.default.createElement("div", { className: this.props.classNames.container, style: this.props.style }, y.default.createElement(t3, h({ ref: function(t4) {
            return e4.input = t4;
          }, placeholder: this.props.placeholder }, n2, { value: this.state.value || this.state.typedValue, onChange: this.handleInputChange, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onKeyDown: this.handleInputKeyDown, onKeyUp: this.handleInputKeyUp, onClick: n2.disabled ? void 0 : this.handleInputClick })), this.state.showOverlay && this.renderOverlay());
        } }]), t2;
      }(y.default.Component);
      w.defaultProps = { dayPickerProps: {}, value: "", typedValue: "", placeholder: "YYYY-M-D", format: "L", formatDate: c, parseDate: p, showOverlay: false, hideOnDayClick: true, clickUnselectsDay: false, keepFocus: true, component: "input", inputProps: {}, overlayComponent: l, classNames: { container: "DayPickerInput", overlayWrapper: "DayPickerInput-OverlayWrapper", overlay: "DayPickerInput-Overlay" } }, t.default = w;
    }]).default;
  });
})(reactDayPicker_min);
var DayPicker = /* @__PURE__ */ getDefaultExportFromCjs(reactDayPicker_min.exports);
var style = "";
const PickerWrapper$2 = styled.div`
  padding-top: 8px;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  .DayPicker-Month {
    border: ${({ theme }) => `1px solid ${theme.themeColors.text}`};
    border-radius: 5px;

    margin: 12px 0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: ${({ theme }) => theme.themeColors.buttonText} !important;
    background-color: ${({ theme }) => theme.themeColors.primaryCtaButton} !important;
    border-radius: 5px !important;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    color: ${({ theme }) => theme.themeColors.text} !important;
    background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)} !important;
    border-radius: 5px !important;
  }

  .DayPicker-NavBar {
    span {
      top: 10px;
      color: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
function YearMonthForm({ date, fromMonth: fromMonth2, toMonth, localeUtils, onChange }) {
  const months2 = localeUtils.getMonths();
  const years = [];
  for (let i = fromMonth2.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }
  const handleChange = function handleChange2(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };
  return /* @__PURE__ */ React.createElement("form", {
    className: "DayPicker-Caption"
  }, /* @__PURE__ */ React.createElement("select", {
    name: "month",
    onChange: handleChange,
    value: date.getMonth()
  }, months2.map((month, i) => /* @__PURE__ */ React.createElement("option", {
    key: month,
    value: i
  }, month))), /* @__PURE__ */ React.createElement("select", {
    name: "year",
    onChange: handleChange,
    value: date.getFullYear()
  }, years.map((year) => /* @__PURE__ */ React.createElement("option", {
    key: year,
    value: year
  }, year))));
}
const DatePicker = ({ name: name2, label, initialDate, toMonth, fromMonth: fromMonth2, value, error, onChange }) => {
  const [monthYear, setMonthYear] = React.useState(initialDate || null);
  const [selectedDay, setSelectedDay] = React.useState(initialDate || null);
  const handleYearMonthChange = (date) => {
    setMonthYear(date);
  };
  const handleDayClick = (d) => {
    setSelectedDay(d);
    if (d) {
      onChange(name2)(d);
    }
  };
  return /* @__PURE__ */ React.createElement(PickerWrapper$2, {
    className: "YearNavigation"
  }, /* @__PURE__ */ React.createElement(DayPicker, {
    selectedDays: selectedDay,
    onDayClick: handleDayClick,
    month: monthYear,
    captionElement: ({ date, localeUtils }) => /* @__PURE__ */ React.createElement(YearMonthForm, {
      date,
      fromMonth: fromMonth2,
      toMonth,
      localeUtils,
      onChange: handleYearMonthChange
    })
  }));
};
const PickerWrapper$1 = styled.form`
  display: block;
  margin: 0;
  padding: 0;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  select {
    color: ${({ theme }) => theme.themeColors.text};
    -webkit-appearance: auto;
  }

  .DayPicker-Month {
    border: ${({ theme }) => `1px solid ${theme.themeColors.text}`};
    border-radius: 5px;

    margin: 12px 0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: ${({ theme }) => theme.colorThemeName === colorThemes.light ? colorPalette.primary.oak : colorPalette.primary.charcoal} !important;
    background-color: ${({ theme }) => theme.themeColors.primaryCtaButton} !important;
    border-radius: 5px !important;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    color: ${({ theme }) => theme.themeColors.text} !important;
    background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)} !important;
    border-radius: 5px !important;
  }

  .DayPicker-NavBar {
    span {
      top: 10px;
      color: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
const InputWrapper = styled.div`
  display: block;
  margin: 0;
  padding: 8px 0;
  height: 46px;
`;
const InputSpacing = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 200px;
  height: 29px;
`;
const ErrorMessage$4 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const currentMonth = new Date().getMonth();
const currentYear = new Date().getFullYear();
const fromMonth = new Date(currentYear, currentMonth);
const defaultToMonth = new Date(currentYear + 10, currentMonth);
const ExpiryDatePicker = ({ name: name2, label, toMonth, value, error, onChange }) => {
  const massagedValue = value === "" || !value ? new Date() : value;
  const years = [];
  for (let i = fromMonth.getFullYear(); i <= (toMonth || defaultToMonth).getFullYear(); i += 1) {
    years.push(i);
  }
  const handleChange = (e) => {
    const { year, month } = e.target.form;
    const date = new Date(year.value, month.value);
    onChange(name2)(date);
  };
  return /* @__PURE__ */ React.createElement(PickerWrapper$1, {
    className: "DayPicker-Caption"
  }, label && /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputWrapper, {
    className: "input-wrapper"
  }, /* @__PURE__ */ React.createElement(InputSpacing, null, /* @__PURE__ */ React.createElement("select", {
    name: "month",
    onChange: handleChange,
    value: massagedValue.getMonth()
  }, months.map((month, i) => /* @__PURE__ */ React.createElement("option", {
    key: month,
    value: i
  }, month))), /* @__PURE__ */ React.createElement("select", {
    name: "year",
    onChange: handleChange,
    value: massagedValue.getFullYear()
  }, years.map((year) => /* @__PURE__ */ React.createElement("option", {
    key: year,
    value: year
  }, year))))), error && /* @__PURE__ */ React.createElement(ErrorMessage$4, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$e = styled.div`
  border: none;

  select {
    display: block;
    width: 100%;

    color: ${({ theme }) => theme.themeColors.text};
    cursor: pointer;

    option {
      color: ${({ theme }) => theme.themeColors.text};
      background: ${({ theme }) => theme.themeColors.component};
      font-size: 16px;
    }
  }
`;
const ErrorMessage$3 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const createDropdownItem = ({ text, value, disabled }) => {
  return {
    text,
    value,
    disabled
  };
};
const Option = ({ item }) => {
  const { text, disabled, value } = item;
  const textWithDisabledMessage = text;
  return /* @__PURE__ */ React.createElement("option", {
    value,
    disabled
  }, disabled ? textWithDisabledMessage : text);
};
const Dropdown = ({ name: name2, value, label, items, onChange, error }) => {
  const handleSelection = React.useCallback(
    (e) => {
      const value2 = e.target.value;
      {
        onChange(name2)(value2);
      }
    },
    [onChange, name2]
  );
  return /* @__PURE__ */ React.createElement(Wrapper$e, null, label && /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement("select", {
    name: name2,
    value,
    onChange: handleSelection
  }, items.map((item) => /* @__PURE__ */ React.createElement(Option, {
    key: `${name2}-${item.value}`,
    item
  }))), error && /* @__PURE__ */ React.createElement(ErrorMessage$3, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$d = styled.div``;
const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
`;
const ErrorMessage$2 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const createMultiSelectItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const MultiSelect = ({ name: name2, values, items, onChange, error, ItemComponent }) => {
  const handleSelection = React.useCallback(
    (value) => {
      if (values.includes(value)) {
        const nextValues = values.filter((v) => v !== value);
        onChange(name2)(nextValues);
      } else {
        const nextValues = [...values, value];
        onChange(name2)(nextValues);
      }
    },
    [onChange, name2, values]
  );
  return /* @__PURE__ */ React.createElement(Wrapper$d, null, /* @__PURE__ */ React.createElement(ItemsWrapper, null, items.map((item) => /* @__PURE__ */ React.createElement(ItemComponent, {
    key: item.value,
    ...item,
    onClick: handleSelection,
    isSelected: values.includes(item.value)
  }))), error && /* @__PURE__ */ React.createElement(ErrorMessage$2, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$c = styled.div`
  padding-right: 16px;
  padding-bottom: 16px;

  button {
    padding: 6px 8px;
  }

  svg {
    margin-left: 12px;
    line-height: 18px;
    height: 14px;
    width: 14px;
  }

  @media (max-width: 360px) {
    padding-right: 8px;

    svg {
      margin-left: 6px;
    }
  }
`;
const UnselectedWrapper = styled.div`
  * {
    transition: all 150ms;
  }
  button {
    display: block;

    background: transparent;
    border: 2px solid ${({ theme }) => theme.themeColors.text};
    border-radius: 5px;
    cursor: pointer;

    * {
      fill: ${({ theme }) => theme.themeColors.text};
      color: ${({ theme }) => theme.themeColors.text};
    }
  }

  button:hover {
    display: block;

    border: 2px solid ${({ theme }) => theme.themeColors.text};
    border-radius: 5px;
    background: ${({ theme }) => theme.themeColors.text};

    cursor: pointer;
    * {
      fill: ${({ theme }) => theme.themeColors.appBackground};
      color: ${({ theme }) => theme.themeColors.appBackground};
    }
  }
`;
const SelectedWrapper = styled.div`
  * {
    transition: all 150ms;
  }
  button {
    display: block;

    border: 2px solid ${({ theme }) => convertHexToRGBA(theme.themeColors.appBackground, 0.2)};
    border-radius: 5px;
    background: ${({ theme }) => theme.themeColors.text};

    cursor: pointer;
    * {
      fill: ${({ theme }) => theme.themeColors.appBackground};
      color: ${({ theme }) => theme.themeColors.appBackground};
    }
  }
`;
const MultiSelectItem = ({ text, value, isSelected, onClick }) => {
  const handleClick = React.useCallback(() => {
    onClick(value);
  }, [onClick, value]);
  if (isSelected) {
    return /* @__PURE__ */ React.createElement(Wrapper$c, null, /* @__PURE__ */ React.createElement(SelectedWrapper, null, /* @__PURE__ */ React.createElement("button", {
      name,
      value,
      onClick: handleClick
    }, /* @__PURE__ */ React.createElement(Body5, null, text), /* @__PURE__ */ React.createElement(Plus, null))));
  }
  return /* @__PURE__ */ React.createElement(Wrapper$c, null, /* @__PURE__ */ React.createElement(UnselectedWrapper, null, /* @__PURE__ */ React.createElement("button", {
    name,
    value,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement(Body5, null, text), /* @__PURE__ */ React.createElement(Plus, null))));
};
const Wrapper$b = styled.div`
  border: none;

  select {
    display: block;
    width: 100%;

    color: ${({ theme }) => theme.themeColors.text};
    cursor: pointer;

    option {
      color: ${({ theme }) => theme.themeColors.text};
      background: ${({ theme }) => theme.themeColors.component};
      font-size: 16px;
    }
  }
`;
const CheckboxWrapper = styled.div`
  background: transparent;
  width: 36px;
`;
const Box = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;

  transition: all 0.2s ease;

  background: transparent;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};

  height: 20px;
  width: 20px;

  &::before,
  &::after {
    position: absolute;
    display: block;
    content: '';
    width: 2px;
    transition: all 0.2s ease;
  }
  &::before {
    height: 3px;
    left: 1px;
    top: 20px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &::after {
    height: 7px;
    right: 3px;
    top: 20px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${({ theme, checked }) => checked ? `
    background-color: ${theme.themeColors.primaryCtaButton};
    
      &::before {
        height: 6px;
        left: 4px;
        top: 9px;
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
        background-color: ${theme.themeColors.component};
      }
      &::after {
        height: 13px;
        right: 6px;
        top: 3px;
        background-color: ${theme.themeColors.component};
      }
  ` : ""};
`;
const ErrorMessage$1 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const Checkbox = ({ name: name2, value, label, onChange, error, stopPropagation }) => {
  const handleClick = React.useCallback(
    (e) => {
      if (stopPropagation) {
        e.stopPropagation();
      }
      {
        onChange(name2)(!value);
      }
    },
    [onChange, name2, value]
  );
  return /* @__PURE__ */ React.createElement(Wrapper$b, null, label && /* @__PURE__ */ React.createElement("label", {
    className: "no-select"
  }, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(CheckboxWrapper, null, /* @__PURE__ */ React.createElement(Box, {
    id: `checkbox-${name2}`,
    checked: value,
    onClick: handleClick
  })), error && /* @__PURE__ */ React.createElement(ErrorMessage$1, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$a = styled.div`
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 0;
  }

  .sc-input-wrapper {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    padding: 7px 0 9px 0;
    font-size: 18px;
    line-height: 27px;
  }

  input {
    padding: 8px 0 8px 3px;

    transform-origin: left;
    transition: border 0.3s ease;
    font-size: 16px;
    line-height: 27px;
    border: none !important;

    &:focus {
      outline: none;
    }
  }

  ${({ theme, isLifted }) => isLifted ? `
      label {
        left: 0px;
      }
    ` : `
      label {
        top: 32px;
        left: 0;

        pointer-events: none;

        * {
          font-size: 16px;
        }
      }
      
      .input-text-prefix {
        display: none;
      }
    `};

  .sc-error-text {
    padding: 4px 0 0 3px;
  }

  ${({ theme, error }) => error !== null ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.error};
      }

      label * {
        color: ${theme.themeColors.error};
     }
  ` : ""};

  ${({ theme, isFocused }) => isFocused ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.primaryCtaButton};
      }

      label * {
        color: ${theme.themeColors.primaryCtaButton};
     }
  ` : ""};
`;
const LabelSpacing = styled.div`
  height: 20px;
`;
const FloatingLabelTextInput = (props) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const { value, placeholder, error, onFocus, onBlur, forceLiftedState } = props;
  const handleFocus = (name2) => {
    onFocus && onFocus(name2);
    setIsFocused(true);
  };
  const handleBlur = (name2) => {
    onBlur && onBlur(name2);
    setIsFocused(false);
  };
  const showLabelAsValue = !isFocused && value === "";
  return /* @__PURE__ */ React.createElement(Wrapper$a, {
    error,
    isFocused,
    isLifted: !showLabelAsValue || forceLiftedState
  }, /* @__PURE__ */ React.createElement(LabelSpacing, null), /* @__PURE__ */ React.createElement(TextInput, {
    ...props,
    value: showLabelAsValue ? "" : value,
    placeholder,
    onFocus: handleFocus,
    onBlur: handleBlur
  }));
};
const Wrapper$9 = styled.div`
  width: 100%;

  label {
    padding: 0;
    margin: 0;
  }

  select {
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    font-size: 16px;
    line-height: 18px;
    height: 46px; // line height doesn't change height of select
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const FloatingLabelDropdown = (props) => {
  return /* @__PURE__ */ React.createElement(Wrapper$9, null, /* @__PURE__ */ React.createElement(Dropdown, {
    ...props
  }));
};
const Wrapper$8 = styled.div``;
function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}
function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}
function countDecimals(str) {
  const num = parseFloat(str);
  if (Math.floor(num) === num)
    return 0;
  return str.split(".")[1].length || 0;
}
const FloatingLabelCurrencyInput = (props) => {
  const valueSanitizer = (newValue, prevValue) => {
    if (newValue === "") {
      return "0";
    }
    if (isNaN(newValue)) {
      return prevValue;
    }
    if (countDecimals(newValue) > 2) {
      return prevValue;
    }
    const parsedFloat = parseFloat(newValue);
    if (isFloat(parsedFloat) && isInt(parsedFloat)) {
      return prevValue;
    }
    if (newValue[newValue.length - 1] === ".") {
      return newValue;
    }
    return parseFloat(newValue).toString();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$8, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, {
    ...props,
    prefix: "$",
    valueSanitizer
  }));
};
const Wrapper$7 = styled.div`
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 0;
  }

  .sc-input-wrapper {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    padding: 8px 0;
  }

  input {
    padding: 8px 0 8px 3px;

    transform-origin: left;
    transition: border 0.3s ease;
    font-size: 16px;
    line-height: 27px;

    &:focus {
      outline: none;
    }
  }

  ${({ theme, isLifted }) => isLifted || true ? `
      label {
        left: 0px;
      }
    ` : `
      label {
        top: 25px;
        left: 0;

        pointer-events: none;

        * {
          font-size: 16px;
        }
      }
      
      .input-text-prefix {
        display: none;
      }
    `};

  .sc-error-text {
    padding: 4px 0 0 3px;
  }

  ${({ theme, error }) => error !== null ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.error};
      }

      label * {
        color: ${theme.themeColors.error};
     }
  ` : ""};
`;
const InputMock = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
  padding: 8px 0 8px 3px;

  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${({ theme }) => theme.themeColors.text};

  font-size: 16px;
  line-height: 27px;
  color: ${({ theme }) => theme.themeColors.text};
  cursor: default;
`;
const ErrorMessage = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const stringifyDate = (d) => {
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
};
const FloatingLabelDatePicker = (props) => {
  const { name: name2, label, value, error } = props;
  return /* @__PURE__ */ React.createElement(Wrapper$7, {
    ...props
  }, /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, label && /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputMock, null, value !== "" ? typeof value === "object" ? stringifyDate(value) : value : "Select With Calender Below"), error && /* @__PURE__ */ React.createElement(ErrorMessage, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)), /* @__PURE__ */ React.createElement(DatePicker, {
    ...props
  }));
};
const PickerWrapper = styled.form`
  display: block;
  margin: 0;
  padding: 0;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  .input-wrapper {
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
  }

  select {
    color: ${({ theme }) => theme.themeColors.text};
    -webkit-appearance: auto;
  }
`;
const FloatingLabelExpiryDatePicker = (props) => {
  return /* @__PURE__ */ React.createElement(PickerWrapper, null, /* @__PURE__ */ React.createElement(ExpiryDatePicker, {
    ...props
  }));
};
const Wrapper$6 = styled.div`
  position: relative;
`;
const InputsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const SingleInputWrapper = styled.div`
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }
`;
const ErrorText = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
`;
const FloatingLabelDateEntry = (props) => {
  const { name: name2, value, error, onChange, autoFocus } = props;
  const [month, setMonth] = React.useState("");
  const [day, setDay] = React.useState("");
  const [year, setYear] = React.useState("");
  const monthRef = React.useRef(null);
  const dayRef = React.useRef(null);
  const yearRef = React.useRef(null);
  const handleMonthChange = (n) => (v) => {
    var _a;
    setMonth(v);
    if (value.length === 2) {
      (_a = dayRef == null ? void 0 : dayRef.current) == null ? void 0 : _a.focus();
    }
  };
  const handleDayChange = (n) => (v) => {
    var _a;
    setDay(v);
    if (v.length === 2) {
      (_a = yearRef == null ? void 0 : yearRef.current) == null ? void 0 : _a.focus();
    }
  };
  const handleYearChange = (n) => (v) => {
    setYear(v);
  };
  React.useEffect(() => {
    if (value !== "") {
      const d = new Date(value);
      if (!isNaN(d.getDate())) {
        const [month2, day2, year2] = value.split("/");
        setMonth(month2);
        setDay(day2);
        setYear(year2);
      }
    }
  }, []);
  React.useEffect(() => {
    var _a;
    if (month.length === 1 && ["3", "4", "5", "6", "7", "8", "9"].includes(month)) {
      setMonth("0" + month);
      (_a = dayRef == null ? void 0 : dayRef.current) == null ? void 0 : _a.focus();
    }
    let autoFormattedMonth = month === "1" ? "01" : month;
    let autoFormattedDay = day.length === 1 ? "0" + day : day;
    const concatDate = `${autoFormattedMonth}/${autoFormattedDay}/${year}`;
    const d = new Date(concatDate);
    if (!isNaN(d.getDate()) && month.length > 0 && day.length > 0 && year.length === 4) {
      if (month !== autoFormattedMonth)
        setMonth(autoFormattedMonth);
      if (day !== autoFormattedDay)
        setDay(autoFormattedDay);
      onChange(name2)(concatDate);
    }
  }, [name2, month, day, year, onChange]);
  return /* @__PURE__ */ React.createElement(Wrapper$6, null, /* @__PURE__ */ React.createElement(InputsWrapper, null, /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, {
    ...props,
    name: props.name ? `${props.name}-month` : "date-month",
    inputRef: monthRef,
    onChange: handleMonthChange,
    label: "Month",
    value: month,
    placeholder: "MM",
    forceLiftedState: true,
    autoFocus,
    error: null
  })), /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, {
    ...props,
    name: props.name ? `${props.name}-day` : "date-day",
    inputRef: dayRef,
    onChange: handleDayChange,
    label: "Day",
    value: day,
    placeholder: "DD",
    forceLiftedState: true,
    autoFocus: false,
    error: null
  })), /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, {
    ...props,
    name: props.name ? `${props.name}-year` : "date-year",
    inputRef: yearRef,
    onChange: handleYearChange,
    label: "Year",
    value: year,
    placeholder: "YYYY",
    forceLiftedState: true,
    autoFocus: false,
    error: null
  }))), error !== null && /* @__PURE__ */ React.createElement(ErrorText, null, error));
};
const Wrapper$5 = styled.div`
  select {
    padding: 4px 0;
    margin: 0 4px;

    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    border-top: none;
    border-left: none;
    border-right: none;

    font-size: 16px;
    line-height: 18px;

    // web-ui global overrides
    display: inline-block !important;
    width: auto !important;
    background: none !important;
    -webkit-appearance: auto;
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const InlineTextDropdown = (props) => {
  return /* @__PURE__ */ React.createElement(Wrapper$5, null, /* @__PURE__ */ React.createElement(Dropdown, {
    ...props,
    label: null
  }));
};
const Wrapper$4 = styled.div`
  label {
    padding: 0;
    margin: 0;
  }

  select {
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    font-size: 16px;
    line-height: 18px;
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const AgreementWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Error$1 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const AgreementCheckbox = (props) => {
  const { label, error } = props;
  return /* @__PURE__ */ React.createElement(Wrapper$4, null, /* @__PURE__ */ React.createElement(AgreementWrapper, null, /* @__PURE__ */ React.createElement(Checkbox, {
    ...props,
    label: null,
    error: null
  }), /* @__PURE__ */ React.createElement(Body5, null, label)), error && /* @__PURE__ */ React.createElement(Error$1, null, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$3 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Neutral = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.neutral};
  }
`;
const Positive = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.positive};
  }
`;
const Negative = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.negative};
  }
`;
const ChangeIndicator = ({ value, size }) => {
  if (value === 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Neutral, {
      size
    }, /* @__PURE__ */ React.createElement(Minus, null)));
  }
  if (value > 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Positive, {
      size
    }, /* @__PURE__ */ React.createElement(CaretUp, null)));
  }
  if (value < 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Negative, {
      size
    }, /* @__PURE__ */ React.createElement(CaretDown, null)));
  }
  return null;
};
const isDarkBg$1 = css`
  svg {
    background: #2b2927;
    border-radius: 9px;
    .border-color-app-store {
      fill: #2b2927;
    }
  }
`;
const Wrapper$2 = styled.div`
  cursor: pointer;

  g {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  ${(props) => props.isDarkBg ? isDarkBg$1 : ""};
`;
function AppStore({ forceDarkTheme, height, width, isDarkBg: isDarkBg2, onAfterClick }) {
  const handleClick = () => {
    const APP_STORE = "https://apps.apple.com/us/app/nvstr-invest-trade-discuss/id1481266478?ls=1";
    window == null ? void 0 : window.open(APP_STORE, "_blank").focus();
    onAfterClick();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$2, {
    forceDarkTheme,
    isDarkBg: isDarkBg2,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "0 0 205 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    className: "border-color-app-store",
    d: "M196.667 1.17426C200.169 1.17426 203.019 3.93509 203.019 7.32796V51.296C203.019 54.6889 200.169 57.4497 196.667 57.4497H7.5641C4.06192 57.4497 1.21215 54.6889 1.21215 51.296V7.32796C1.21215 3.93509 4.06192 1.17426 7.5641 1.17426H196.667ZM196.667 -5.01847e-05H7.5641C3.40574 -5.01847e-05 0 3.29938 0 7.32796V51.296C0 55.3246 3.40574 58.624 7.5641 58.624H196.667C200.825 58.624 204.231 55.3246 204.231 51.296V7.32796C204.231 3.29938 200.825 -5.01847e-05 196.667 -5.01847e-05Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M45.578 28.9951C45.5341 24.2715 49.5703 21.9734 49.7549 21.8665C47.469 18.6377 43.926 18.1966 42.6809 18.1614C39.7052 17.858 36.8187 19.8864 35.3029 19.8864C33.7568 19.8864 31.4225 18.1907 28.9067 18.2406C25.6692 18.2889 22.6406 20.1048 20.9795 22.9246C17.5515 28.6742 20.1081 37.1234 23.3925 41.7708C25.0354 44.0469 26.9551 46.5882 29.4679 46.4988C31.9263 46.4006 32.8446 44.9805 35.8112 44.9805C38.7506 44.9805 39.6129 46.4988 42.1756 46.4417C44.814 46.4006 46.4751 44.1553 48.0605 41.8587C49.9591 39.25 50.7216 36.6808 50.7518 36.5489C50.6898 36.5283 45.6279 34.6568 45.578 28.9951Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M40.7369 15.1042C42.0591 13.5023 42.9638 11.3229 42.7127 9.11133C40.799 9.1934 38.4057 10.3937 37.0275 11.9605C35.8082 13.3411 34.7189 15.6039 35.0003 17.732C37.15 17.8874 39.3572 16.6812 40.7369 15.1042Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M81.1547 46.1737H77.7191L75.8372 40.4446H69.2957L67.503 46.1737H64.1582L70.6391 26.6694H74.642L81.1547 46.1737ZM75.2699 38.041L73.5679 32.9481C73.3879 32.4278 73.0506 31.2025 72.5528 29.2738H72.4923C72.2941 30.1033 71.9749 31.3286 71.5362 32.9481L69.8646 38.041H75.2699Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M97.8218 38.9671C97.8218 41.3589 97.1546 43.2496 95.8203 44.6375C94.6252 45.873 93.1411 46.49 91.3696 46.49C89.4574 46.49 88.0837 45.8246 87.2472 44.4939H87.1866V51.9025H83.9613V36.7379C83.9613 35.2342 83.9205 33.6909 83.8418 32.1081H86.6783L86.8584 34.3372H86.9189C87.9945 32.6577 89.6268 31.8193 91.8174 31.8193C93.5299 31.8193 94.9595 32.4745 96.1032 33.7862C97.2499 35.0994 97.8218 36.8258 97.8218 38.9671ZM94.5359 39.0814C94.5359 37.7125 94.2182 36.584 93.5798 35.6959C92.8824 34.7696 91.946 34.3065 90.772 34.3065C89.9763 34.3065 89.2532 34.5644 88.6072 35.073C87.9597 35.5859 87.5361 36.2557 87.3379 37.0852C87.2381 37.4722 87.1882 37.7887 87.1882 38.0379V40.3828C87.1882 41.4058 87.5119 42.2691 88.1594 42.974C88.8069 43.679 89.648 44.0307 90.6828 44.0307C91.8976 44.0307 92.8431 43.5764 93.5193 42.6707C94.1971 41.7634 94.5359 40.5675 94.5359 39.0814Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M114.518 38.9671C114.518 41.3589 113.851 43.2496 112.516 44.6375C111.322 45.873 109.838 46.49 108.066 46.49C106.154 46.49 104.78 45.8246 103.945 44.4939H103.885V51.9025H100.66V36.7379C100.66 35.2342 100.619 33.6909 100.54 32.1081H103.377L103.557 34.3372H103.617C104.691 32.6577 106.324 31.8193 108.516 31.8193C110.227 31.8193 111.656 32.4745 112.803 33.7862C113.945 35.0994 114.518 36.8258 114.518 38.9671ZM111.233 39.0814C111.233 37.7125 110.913 36.584 110.275 35.6959C109.578 34.7696 108.644 34.3065 107.469 34.3065C106.672 34.3065 105.95 34.5644 105.302 35.073C104.655 35.5859 104.233 36.2557 104.035 37.0852C103.936 37.4722 103.885 37.7887 103.885 38.0379V40.3828C103.885 41.4058 104.209 42.2691 104.853 42.974C105.501 43.6775 106.342 44.0307 107.38 44.0307C108.594 44.0307 109.54 43.5764 110.216 42.6707C110.894 41.7634 111.233 40.5675 111.233 39.0814Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M133.186 40.7022C133.186 42.3613 132.592 43.7111 131.398 44.7532C130.086 45.8919 128.26 46.4606 125.914 46.4606C123.748 46.4606 122.011 46.0561 120.696 45.2456L121.444 42.6412C122.86 43.4708 124.413 43.887 126.106 43.887C127.321 43.887 128.266 43.6202 128.946 43.0897C129.622 42.5592 129.959 41.8469 129.959 40.9587C129.959 40.1673 129.681 39.5004 129.123 38.9596C128.567 38.4188 127.64 37.9161 126.345 37.4515C122.82 36.1779 121.059 34.3122 121.059 31.8588C121.059 30.2554 121.677 28.9408 122.913 27.9178C124.144 26.8933 125.787 26.3818 127.841 26.3818C129.673 26.3818 131.195 26.6911 132.41 27.3081L131.604 29.8553C130.469 29.2573 129.186 28.9584 127.751 28.9584C126.616 28.9584 125.729 29.2295 125.094 29.7688C124.557 30.251 124.288 30.8387 124.288 31.5349C124.288 32.3058 124.595 32.9433 125.212 33.4446C125.749 33.9077 126.725 34.4089 128.141 34.9497C129.873 35.6254 131.145 36.4153 131.964 37.3211C132.779 38.2239 133.186 39.3539 133.186 40.7022Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M143.851 34.4527H140.296V41.281C140.296 43.0177 140.922 43.8853 142.178 43.8853C142.754 43.8853 143.232 43.837 143.61 43.7403L143.699 46.1131C143.064 46.3432 142.227 46.4589 141.191 46.4589C139.917 46.4589 138.922 46.0823 138.203 45.3304C137.488 44.5771 137.128 43.3138 137.128 41.5389V34.4498H135.01V32.1048H137.128V29.5298L140.296 28.6035V32.1048H143.851V34.4527Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M159.891 39.0237C159.891 41.1855 159.252 42.9604 157.979 44.3483C156.643 45.7772 154.87 46.4895 152.66 46.4895C150.53 46.4895 148.834 45.8051 147.569 44.4362C146.304 43.0673 145.672 41.3394 145.672 39.2568C145.672 37.0774 146.322 35.2923 147.628 33.9044C148.93 32.515 150.688 31.8203 152.899 31.8203C155.029 31.8203 156.743 32.5047 158.036 33.8751C159.274 35.2044 159.891 36.9206 159.891 39.0237ZM156.545 39.1249C156.545 37.8278 156.259 36.7154 155.679 35.7877C155.003 34.665 154.036 34.1052 152.784 34.1052C151.487 34.1052 150.502 34.6665 149.826 35.7877C149.247 36.7169 148.961 37.8469 148.961 39.1835C148.961 40.4806 149.247 41.5929 149.826 42.5192C150.523 43.6419 151.498 44.2017 152.755 44.2017C153.986 44.2017 154.953 43.6301 155.65 42.4899C156.245 41.5446 156.545 40.4205 156.545 39.1249Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M170.374 34.8561C170.055 34.7989 169.715 34.7696 169.358 34.7696C168.223 34.7696 167.346 35.1844 166.728 36.0154C166.191 36.7482 165.922 37.6744 165.922 38.7927V46.172H162.698L162.728 36.5371C162.728 34.9162 162.688 33.4403 162.607 32.1095H165.417L165.535 34.8004H165.624C165.964 33.8756 166.501 33.131 167.237 32.5727C167.955 32.07 168.731 31.8193 169.568 31.8193C169.866 31.8193 170.135 31.8399 170.374 31.8765V34.8561Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M184.8 38.4742C184.8 39.034 184.762 39.5059 184.682 39.8914H175.006C175.044 41.2808 175.511 42.3433 176.41 43.0761C177.225 43.7313 178.28 44.0596 179.574 44.0596C181.007 44.0596 182.314 43.8383 183.49 43.3942L183.995 45.5633C182.621 46.1437 181 46.4324 179.128 46.4324C176.877 46.4324 175.11 45.7904 173.824 44.508C172.541 43.2256 171.898 41.5036 171.898 39.3433C171.898 37.2225 172.496 35.4565 173.693 34.048C174.945 32.5443 176.638 31.7925 178.768 31.7925C180.86 31.7925 182.444 32.5443 183.52 34.048C184.372 35.2425 184.8 36.7198 184.8 38.4742ZM181.724 37.6637C181.745 36.7374 181.535 35.9372 181.098 35.2616C180.54 34.3925 179.682 33.9586 178.528 33.9586C177.473 33.9586 176.615 34.3822 175.96 35.2322C175.423 35.9079 175.104 36.7184 175.006 37.6622H181.724V37.6637Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M74.2041 14.6694C74.2041 16.3944 73.6701 17.6929 72.6036 18.565C71.6157 19.3696 70.2118 19.7726 68.3934 19.7726C67.4917 19.7726 66.7202 19.7345 66.0742 19.6583V10.233C66.9169 10.1011 67.8246 10.0337 68.8049 10.0337C70.537 10.0337 71.8426 10.3986 72.7231 11.1285C73.7094 11.9536 74.2041 13.1334 74.2041 14.6694ZM72.5325 14.7119C72.5325 13.5936 72.2269 12.7363 71.6157 12.1383C71.0045 11.5418 70.1119 11.2428 68.9365 11.2428C68.4372 11.2428 68.0121 11.2751 67.6597 11.3425V18.5078C67.8548 18.5371 68.2118 18.5503 68.7307 18.5503C69.944 18.5503 70.8805 18.2235 71.54 17.5698C72.1996 16.9162 72.5325 15.9635 72.5325 14.7119Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M83.0677 16.1752C83.0677 17.2377 82.7545 18.1083 82.1282 18.7913C81.4717 19.4933 80.6018 19.8436 79.5156 19.8436C78.4687 19.8436 77.6352 19.5079 77.0134 18.8338C76.3931 18.1611 76.083 17.3125 76.083 16.2895C76.083 15.2196 76.4022 14.3417 77.0436 13.6602C77.6851 12.9787 78.5474 12.6372 79.6336 12.6372C80.6805 12.6372 81.5216 12.9728 82.1585 13.6455C82.7636 14.2992 83.0677 15.1434 83.0677 16.1752ZM81.4233 16.225C81.4233 15.5875 81.2811 15.0408 80.9982 14.585C80.6653 14.0339 80.1918 13.7584 79.5761 13.7584C78.9392 13.7584 78.4551 14.0339 78.1223 14.585C77.8379 15.0408 77.6972 15.5963 77.6972 16.2528C77.6972 16.8904 77.8394 17.4371 78.1223 17.8929C78.4657 18.4439 78.9438 18.7195 79.561 18.7195C80.1661 18.7195 80.6411 18.4395 80.983 17.8782C81.2765 17.4136 81.4233 16.8625 81.4233 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M94.9527 12.7778L92.7213 19.6867H91.269L90.3446 16.6866C90.1101 15.9377 89.9195 15.1931 89.7713 14.4545H89.7425C89.6049 15.2137 89.4142 15.9567 89.1692 16.6866L88.1873 19.6867H86.7184L84.6201 12.7778H86.2494L87.0558 16.0622C87.2509 16.839 87.4113 17.5791 87.5399 18.2797H87.5686C87.6866 17.7023 87.8818 16.9665 88.1571 16.0769L89.1692 12.7793H90.4611L91.4308 16.0066C91.6653 16.7936 91.8559 17.5513 92.0027 18.2812H92.0465C92.154 17.5704 92.3158 16.8126 92.5307 16.0066L93.396 12.7793H94.9527V12.7778Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M103.172 19.6872H101.586V15.7301C101.586 14.5107 101.108 13.901 100.149 13.901C99.6788 13.901 99.299 14.0681 99.004 14.4037C98.7121 14.7394 98.5638 15.1351 98.5638 15.588V19.6858H96.9784V14.7526C96.9784 14.1458 96.9587 13.4877 96.9209 12.7755H98.3142L98.3883 13.8556H98.4322C98.6168 13.52 98.8921 13.243 99.2537 13.0217C99.6833 12.7637 100.164 12.6333 100.691 12.6333C101.356 12.6333 101.91 12.8414 102.35 13.2591C102.898 13.7706 103.172 14.5342 103.172 15.5484V19.6872Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.544 19.6873H105.96V9.6084H107.544V19.6873Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M116.878 16.1752C116.878 17.2377 116.565 18.1083 115.939 18.7913C115.282 19.4933 114.411 19.8436 113.326 19.8436C112.278 19.8436 111.444 19.5079 110.824 18.8338C110.204 18.1611 109.894 17.3125 109.894 16.2895C109.894 15.2196 110.213 14.3417 110.854 13.6602C111.496 12.9787 112.358 12.6372 113.443 12.6372C114.491 12.6372 115.331 12.9728 115.969 13.6455C116.574 14.2992 116.878 15.1434 116.878 16.1752ZM115.232 16.225C115.232 15.5875 115.09 15.0408 114.807 14.585C114.476 14.0339 114.001 13.7584 113.387 13.7584C112.748 13.7584 112.264 14.0339 111.933 14.585C111.648 15.0408 111.508 15.5963 111.508 16.2528C111.508 16.8904 111.65 17.4371 111.933 17.8929C112.276 18.4439 112.754 18.7195 113.372 18.7195C113.977 18.7195 114.45 18.4395 114.792 17.8782C115.087 17.4136 115.232 16.8625 115.232 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M124.551 19.6867H123.127L123.009 18.8909H122.965C122.478 19.5255 121.784 19.8436 120.882 19.8436C120.209 19.8436 119.664 19.634 119.255 19.2178C118.882 18.8396 118.696 18.3692 118.696 17.8108C118.696 16.9666 119.059 16.3232 119.79 15.8777C120.519 15.4321 121.545 15.2137 122.866 15.224V15.095C122.866 14.1849 122.372 13.7305 121.385 13.7305C120.681 13.7305 120.061 13.902 119.525 14.242L119.203 13.2337C119.866 12.8365 120.684 12.6372 121.649 12.6372C123.513 12.6372 124.448 13.5898 124.448 15.4951V18.0394C124.448 18.7297 124.483 19.2793 124.551 19.6867ZM122.905 17.3125V16.247C121.156 16.2177 120.282 16.6823 120.282 17.6393C120.282 17.9998 120.382 18.2695 120.586 18.4498C120.79 18.6301 121.05 18.7195 121.36 18.7195C121.708 18.7195 122.034 18.6125 122.33 18.4C122.628 18.186 122.811 17.9148 122.879 17.5821C122.896 17.5074 122.905 17.4165 122.905 17.3125Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M133.56 19.6873H132.153L132.079 18.5779H132.035C131.585 19.4221 130.82 19.8442 129.744 19.8442C128.885 19.8442 128.169 19.5173 127.602 18.8637C127.035 18.21 126.752 17.3614 126.752 16.3194C126.752 15.2011 127.059 14.2954 127.676 13.6036C128.274 12.9588 129.006 12.6363 129.877 12.6363C130.835 12.6363 131.505 12.9485 131.886 13.5743H131.917V9.6084H133.504V17.826C133.504 18.4987 133.522 19.1187 133.56 19.6873ZM131.917 16.7737V15.6218C131.917 15.4224 131.902 15.2612 131.873 15.1381C131.784 14.7688 131.591 14.4581 131.299 14.2075C131.004 13.9568 130.649 13.8308 130.239 13.8308C129.647 13.8308 129.185 14.058 128.844 14.5138C128.507 14.9696 128.336 15.5514 128.336 16.2622C128.336 16.9452 128.498 17.4992 128.823 17.9257C129.166 18.38 129.629 18.6072 130.209 18.6072C130.729 18.6072 131.145 18.4181 131.461 18.0385C131.767 17.6883 131.917 17.2662 131.917 16.7737Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M147.119 16.1752C147.119 17.2377 146.806 18.1083 146.18 18.7913C145.523 19.4933 144.655 19.8436 143.567 19.8436C142.522 19.8436 141.688 19.5079 141.065 18.8338C140.445 18.1611 140.135 17.3125 140.135 16.2895C140.135 15.2196 140.454 14.3417 141.095 13.6602C141.737 12.9787 142.599 12.6372 143.687 12.6372C144.732 12.6372 145.575 12.9728 146.21 13.6455C146.815 14.2992 147.119 15.1434 147.119 16.1752ZM145.477 16.225C145.477 15.5875 145.334 15.0408 145.051 14.585C144.717 14.0339 144.245 13.7584 143.628 13.7584C142.992 13.7584 142.508 14.0339 142.174 14.585C141.89 15.0408 141.749 15.5963 141.749 16.2528C141.749 16.8904 141.891 17.4371 142.174 17.8929C142.517 18.4439 142.996 18.7195 143.613 18.7195C144.218 18.7195 144.694 18.4395 145.036 17.8782C145.328 17.4136 145.477 16.8625 145.477 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M155.644 19.6872H154.06V15.7301C154.06 14.5107 153.582 13.901 152.621 13.901C152.151 13.901 151.771 14.0681 151.478 14.4037C151.184 14.7394 151.037 15.1351 151.037 15.588V19.6858H149.451V14.7526C149.451 14.1458 149.432 13.4877 149.395 12.7755H150.786L150.86 13.8556H150.904C151.09 13.52 151.366 13.243 151.726 13.0217C152.157 12.7637 152.637 12.6333 153.164 12.6333C153.829 12.6333 154.382 12.8414 154.823 13.2591C155.372 13.7706 155.644 14.5342 155.644 15.5484V19.6872Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M166.314 13.9292H164.568V17.2854C164.568 18.1384 164.878 18.5649 165.493 18.5649C165.777 18.5649 166.013 18.5415 166.199 18.4931L166.24 19.6583C165.927 19.7726 165.515 19.8297 165.008 19.8297C164.382 19.8297 163.895 19.6451 163.543 19.2757C163.189 18.9064 163.013 18.285 163.013 17.413V13.9292H161.971V12.7787H163.013V11.5124L164.567 11.0581V12.7773H166.312V13.9292H166.314Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M174.707 19.6873H173.12V15.7595C173.12 14.5211 172.642 13.9011 171.685 13.9011C170.949 13.9011 170.447 14.2602 170.172 14.9784C170.125 15.1293 170.098 15.314 170.098 15.5309V19.6859H168.514V9.6084H170.098V13.7722H170.128C170.627 13.0145 171.343 12.6363 172.27 12.6363C172.927 12.6363 173.47 12.8444 173.901 13.2621C174.438 13.7824 174.707 14.5563 174.707 15.5793V19.6873Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M183.365 15.906C183.365 16.1815 183.343 16.4131 183.306 16.6022H178.551C178.572 17.2851 178.799 17.8054 179.239 18.166C179.642 18.4884 180.16 18.6496 180.796 18.6496C181.499 18.6496 182.141 18.5411 182.719 18.3228L182.967 19.3897C182.291 19.6741 181.495 19.8162 180.573 19.8162C179.469 19.8162 178.599 19.5011 177.97 18.8709C177.338 18.2407 177.024 17.395 177.024 16.3339C177.024 15.2919 177.316 14.4243 177.905 13.7325C178.519 12.9938 179.35 12.6245 180.398 12.6245C181.424 12.6245 182.203 12.9938 182.729 13.7325C183.154 14.3187 183.365 15.0442 183.365 15.906ZM181.852 15.5088C181.864 15.053 181.76 14.6602 181.545 14.329C181.269 13.9025 180.85 13.6885 180.283 13.6885C179.766 13.6885 179.344 13.8967 179.021 14.3144C178.758 14.647 178.602 15.0442 178.551 15.5088H181.852Z"
  }))));
}
var DownloadOnAppStore = withTheme(AppStore);
const isDarkBg = css`
  svg {
    background: #2b2927;
    border-radius: 9px;
    .border-color-android-app-store {
      fill: #2b2927;
    }
  }
`;
const Wrapper$1 = styled.div`
  cursor: pointer;

  g {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  .text-stroke {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  ${(props) => props.isDarkBg ? isDarkBg : ""};
`;
function GooglePlay({ forceDarkTheme, theme, height, width, isDarkBg: isDarkBg2, onAfterClick }) {
  const handleClick = () => {
    const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.nvstr.app";
    window == null ? void 0 : window.open(GOOGLE_PLAY, "_blank").focus();
    onAfterClick();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$1, {
    forceDarkTheme,
    isDarkBg: isDarkBg2,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "35 30 203 59",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /* @__PURE__ */ React.createElement("path", {
    className: "border-color-android-app-store",
    d: "M230.743 31.1779C234.229 31.1779 237.065 33.9472 237.065 37.3505V81.4532C237.065 84.8565 234.229 87.6258 230.743 87.6258H42.5286C39.0428 87.6258 36.2065 84.8565 36.2065 81.4532V37.3505C36.2065 33.9472 39.0428 31.1779 42.5286 31.1779H230.743ZM230.743 30H42.5286C38.3897 30 35 33.3096 35 37.3505V81.4532C35 85.4942 38.3897 88.8037 42.5286 88.8037H230.743C234.882 88.8037 238.272 85.4942 238.272 81.4532V37.3505C238.272 33.3096 234.882 30 230.743 30Z"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "text-stroke",
    d: "M106.397 45.0591C106.397 46.2866 106.02 47.2698 105.279 48.003C104.426 48.8722 103.316 49.3095 101.955 49.3095C100.654 49.3095 99.5439 48.8648 98.633 47.9883C97.7201 47.0989 97.2646 46.0073 97.2646 44.7008C97.2646 43.3942 97.7201 42.3027 98.633 41.4206C99.5439 40.5367 100.654 40.092 101.955 40.092C102.602 40.092 103.22 40.2225 103.809 40.4651C104.396 40.7095 104.874 41.0403 105.22 41.4482L104.434 42.2237C103.83 41.5272 103.007 41.1836 101.955 41.1836C101.006 41.1836 100.184 41.507 99.4856 42.1594C98.7948 42.8135 98.4485 43.6607 98.4485 44.7008C98.4485 45.7409 98.7948 46.5954 99.4856 47.2496C100.184 47.8946 101.006 48.2253 101.955 48.2253C102.962 48.2253 103.809 47.8946 104.477 47.2422C104.917 46.8104 105.168 46.215 105.234 45.4542H101.955V44.3921H106.329C106.382 44.6218 106.397 44.8441 106.397 45.0591Z",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "text-stroke",
    d: "M113.337 41.3765H109.229V44.1697H112.933V45.2319H109.229V48.025H113.337V49.1074H108.065V40.2942H113.337V41.3765Z",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M118.234 49.1074H117.071V41.3765H114.551V40.2942H120.756V41.3765H118.234V49.1074Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M125.247 49.1074V40.2942H126.408V49.1074H125.247Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M131.556 49.1074H130.403V41.3765H127.873V40.2942H134.086V41.3765H131.556V49.1074Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M145.834 47.9736C144.944 48.8648 143.841 49.3095 142.525 49.3095C141.202 49.3095 140.099 48.8648 139.209 47.9736C138.32 47.0842 137.878 45.9926 137.878 44.7008C137.878 43.4089 138.32 42.3174 139.209 41.428C140.099 40.5367 141.202 40.092 142.525 40.092C143.833 40.092 144.936 40.5367 145.826 41.4353C146.722 42.3321 147.164 43.4163 147.164 44.7008C147.164 45.9926 146.722 47.0842 145.834 47.9736ZM140.069 47.2349C140.739 47.8946 141.554 48.2253 142.525 48.2253C143.489 48.2253 144.311 47.8946 144.974 47.2349C145.642 46.5751 145.981 45.728 145.981 44.7008C145.981 43.6736 145.642 42.8264 144.974 42.1667C144.311 41.507 143.489 41.1762 142.525 41.1762C141.554 41.1762 140.739 41.507 140.069 42.1667C139.401 42.8264 139.062 43.6736 139.062 44.7008C139.062 45.728 139.401 46.5751 140.069 47.2349Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M148.796 49.1074V40.2942H150.208L154.597 47.1485H154.647L154.597 45.4542V40.2942H155.758V49.1074H154.546L149.95 41.915H149.899L149.95 43.6166V49.1074H148.796Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M137.592 61.9783C134.056 61.9783 131.167 64.6061 131.167 68.2317C131.167 71.8279 134.056 74.4833 137.592 74.4833C141.136 74.4833 144.025 71.8279 144.025 68.2317C144.025 64.6061 141.136 61.9783 137.592 61.9783ZM137.592 72.0209C135.652 72.0209 133.982 70.457 133.982 68.2317C133.982 65.9769 135.652 64.4407 137.592 64.4407C139.533 64.4407 141.21 65.9769 141.21 68.2317C141.21 70.457 139.533 72.0209 137.592 72.0209ZM123.572 61.9783C120.028 61.9783 117.147 64.6061 117.147 68.2317C117.147 71.8279 120.028 74.4833 123.572 74.4833C127.114 74.4833 129.998 71.8279 129.998 68.2317C129.998 64.6061 127.114 61.9783 123.572 61.9783ZM123.572 72.0209C121.63 72.0209 119.955 70.457 119.955 68.2317C119.955 65.9769 121.63 64.4407 123.572 64.4407C125.513 64.4407 127.182 65.9769 127.182 68.2317C127.182 70.457 125.513 72.0209 123.572 72.0209ZM106.889 63.8949V66.5521H113.388C113.198 68.0369 112.69 69.1284 111.91 69.8892C110.962 70.808 109.484 71.8279 106.889 71.8279C102.889 71.8279 99.7574 68.6764 99.7574 64.7715C99.7574 60.8665 102.889 57.715 106.889 57.715C109.051 57.715 110.625 58.5401 111.786 59.6096L113.704 57.7371C112.08 56.2229 109.919 55.0597 106.889 55.0597C101.404 55.0597 96.7949 59.4166 96.7949 64.7715C96.7949 70.1263 101.404 74.4833 106.889 74.4833C109.853 74.4833 112.08 73.535 113.83 71.7562C115.624 70.005 116.183 67.5426 116.183 65.5543C116.183 64.9368 116.13 64.369 116.036 63.8949H106.889ZM175.109 65.9549C174.58 64.5565 172.948 61.9783 169.624 61.9783C166.331 61.9783 163.588 64.5124 163.588 68.2317C163.588 71.7342 166.302 74.4833 169.941 74.4833C172.882 74.4833 174.58 72.732 175.278 71.7121L173.095 70.2917C172.367 71.3317 171.375 72.0209 169.941 72.0209C168.516 72.0209 167.494 71.3832 166.839 70.1263L175.404 66.666L175.109 65.9549ZM166.376 68.0369C166.302 65.6259 168.294 64.3911 169.72 64.3911C170.838 64.3911 171.787 64.9368 172.103 65.7178L166.376 68.0369ZM159.414 74.1029H162.229V55.7267H159.414V74.1029ZM154.803 63.3712H154.708C154.076 62.6398 152.87 61.9783 151.341 61.9783C148.134 61.9783 145.202 64.7274 145.202 68.2519C145.202 71.7562 148.134 74.4833 151.341 74.4833C152.87 74.4833 154.076 73.8162 154.708 73.0628H154.803V73.9595C154.803 76.3503 153.494 77.6348 151.385 77.6348C149.664 77.6348 148.597 76.4219 148.157 75.4021L145.708 76.3999C146.414 78.0574 148.283 80.0972 151.385 80.0972C154.686 80.0972 157.471 78.2007 157.471 73.5865V62.3587H154.803V63.3712ZM151.582 72.0209C149.642 72.0209 148.017 70.435 148.017 68.2519C148.017 66.0486 149.642 64.4407 151.582 64.4407C153.494 64.4407 155.002 66.0486 155.002 68.2519C155.002 70.435 153.494 72.0209 151.582 72.0209ZM188.292 55.7267H181.557V74.1029H184.365V67.1401H188.292C191.41 67.1401 194.469 64.9368 194.469 61.4325C194.469 57.93 191.403 55.7267 188.292 55.7267ZM188.365 64.584H184.365V58.2828H188.365C190.462 58.2828 191.659 59.9826 191.659 61.4325C191.659 62.8548 190.462 64.584 188.365 64.584ZM205.724 61.9434C203.695 61.9434 201.585 62.8181 200.717 64.7568L203.209 65.7766C203.746 64.7568 204.732 64.426 205.775 64.426C207.232 64.426 208.709 65.2805 208.732 66.7892V66.9821C208.223 66.6954 207.136 66.271 205.797 66.271C203.113 66.271 200.379 67.7135 200.379 70.4056C200.379 72.868 202.577 74.4539 205.048 74.4539C206.938 74.4539 207.981 73.6214 208.636 72.653H208.732V74.0735H211.444V67.0244C211.444 63.7663 208.952 61.9434 205.724 61.9434ZM205.385 72.0135C204.467 72.0135 203.187 71.5688 203.187 70.457C203.187 69.0347 204.783 68.489 206.164 68.489C207.401 68.489 207.981 68.7554 208.732 69.1064C208.511 70.808 207.011 72.0135 205.385 72.0135ZM221.325 62.3458L218.097 70.3119H218.001L214.664 62.3458H211.636L216.65 73.4781L213.789 79.6727H216.723L224.449 62.3458H221.325ZM196.012 74.1029H198.828V55.7267H196.012V74.1029Z",
    className: "text-stroke"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M50.7119 41.0827C50.2696 41.5347 50.0137 42.2385 50.0137 43.15V75.6611C50.0137 76.5725 50.2696 77.2764 50.7119 77.7284L50.8211 77.8276L69.4807 59.6169V59.1869L50.8211 40.9761L50.7119 41.0827Z",
    fill: "url(#paint0_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.6944 65.6902L69.4814 59.6169V59.1869L75.7019 53.1135L75.8412 53.1926L83.2079 57.2849C85.3103 58.4463 85.3103 60.3574 83.2079 61.5261L75.8412 65.6112L75.6944 65.6902Z",
    fill: "url(#paint1_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.8404 65.6109L69.4806 59.4016L50.7119 77.7282C51.4102 78.4448 52.5489 78.5312 53.8438 77.8145L75.8404 65.6109Z",
    fill: "url(#paint2_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.8404 53.1926L53.8438 40.9889C52.5489 40.2796 51.4102 40.366 50.7119 41.0827L69.4806 59.4019L75.8404 53.1926Z",
    fill: "url(#paint3_linear)"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", {
    id: "filter0_d",
    x: "0.0714417",
    y: "0.892868",
    width: "273.129",
    height: "128.661",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */ React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */ React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /* @__PURE__ */ React.createElement("feOffset", {
    dy: "5.82143"
  }), /* @__PURE__ */ React.createElement("feGaussianBlur", {
    stdDeviation: "17.4643"
  }), /* @__PURE__ */ React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /* @__PURE__ */ React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /* @__PURE__ */ React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "67.8239",
    y1: "75.9996",
    x2: "43.1593",
    y2: "50.7374",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.0066",
    stopColor: "#00A1FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.2601",
    stopColor: "#00BEFF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.5122",
    stopColor: "#00D2FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.7604",
    stopColor: "#00DFFF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#00E3FF"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "85.9455",
    y1: "59.3998",
    x2: "49.5119",
    y2: "59.3998",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#FFE000"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.4087",
    stopColor: "#FFBD00"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.7754",
    stopColor: "#FFA500"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#FF9C00"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: "72.3822",
    y1: "56.0261",
    x2: "38.9349",
    y2: "21.7684",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#C31162"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: "45.9874",
    y1: "88.5447",
    x2: "60.9231",
    y2: "73.2472",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#32A071"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.0685",
    stopColor: "#2DA771"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.4762",
    stopColor: "#15CF74"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.8009",
    stopColor: "#06E775"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#00F076"
  })))));
}
var DownloadOnGooglePlay = withTheme(GooglePlay);
const Wrapper = styled.svg`
  height: ${({ size }) => size === "small" ? "32px" : "64px"};
  width: ${({ size }) => size === "small" ? "32px" : "64px"};

  .outline-stroke {
    stroke: ${({ theme }) => theme.themeColors.appBackground};
    stroke-opacity: 1;
  }
  .rotating-stroke {
    stroke: ${({ theme }) => theme.themeColors.primaryCtaButton};
    stroke-opacity: 0.8;
  }
`;
const Icon = ({ size }) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    size
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "outline-stroke"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2px"
  }, /* @__PURE__ */ React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18",
    className: "rotating-stroke"
  }, /* @__PURE__ */ React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "700ms",
    repeatCount: "indefinite"
  })))));
};
function LoadingAnimation({ size }) {
  return /* @__PURE__ */ React.createElement(Icon, {
    size
  });
}
const SvgWrapper = styled.svg`
  width: 40px;

  rect,
  circle {
    fill: ${({ theme, color }) => color || theme.themeColors.border};
  }
`;
const SVG_LOADING_ICON_TYPES = {
  balls: "3balls",
  bars: "bars"
};
const SvgLoadingIcon = ({ type, color }) => {
  if (type === SVG_LOADING_ICON_TYPES.balls) {
    return /* @__PURE__ */ React.createElement(SvgWrapper, {
      version: "1.1",
      id: "L4",
      x: "0px",
      y: "0px",
      viewBox: "0 0 76 22",
      enableBackground: "new 0 0 0 0",
      "xml:space": "preserve",
      color
    }, /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "12",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.1"
    })), /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "38",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.2"
    })), /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "64",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.3"
    })));
  }
  if (type === SVG_LOADING_ICON_TYPES.bars) {
    return /* @__PURE__ */ React.createElement(SvgWrapper, {
      version: "1.1",
      id: "L9",
      x: "0px",
      y: "0px",
      viewBox: "0 0 30 30",
      enableBackground: "new 0 0 0 0",
      "xml:space": "preserve",
      color
    }, /* @__PURE__ */ React.createElement("rect", {
      x: "5",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0",
      dur: "0.7s",
      repeatCount: "indefinite"
    })), /* @__PURE__ */ React.createElement("rect", {
      x: "13",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0.2s",
      dur: "0.7s",
      repeatCount: "indefinite"
    })), /* @__PURE__ */ React.createElement("rect", {
      x: "21",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0.4s",
      dur: "0.7s",
      repeatCount: "indefinite"
    })));
  }
  return null;
};
const useScript = (src, onBeforeLoad) => {
  const [status, setStatus] = React.useState(src ? "loading" : "idle");
  React.useEffect(() => {
    if (!src) {
      setStatus("idle");
      return;
    }
    let script = document == null ? void 0 : document.querySelector(`script[src="${src}"]`);
    if (!script && document) {
      onBeforeLoad && onBeforeLoad();
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading");
      document.body.appendChild(script);
      const setAttributeFromEvent = (event) => {
        script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(script == null ? void 0 : script.getAttribute("data-status"));
    }
    const setStateFromEvent = (event) => {
      setStatus(event.type === "load" ? "ready" : "error");
    };
    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent);
    return () => {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};
const ADJUST_EVENT_NAMES = {
  VIEW_SECURITY_SCREEN: "lxfonv",
  VIEW_TRADE_SCREEN: "sv1w0c",
  COMPLETED_LIVE_SIGNUP: "llm728",
  COMPLETED_PAPER_SIGNUP: "ohhbcj",
  PLACED_LIVE_TRADE: "52bu6x",
  ADDED_IDEA: "s2pxm9",
  POSTED_THOUGHT: "4w1su4"
};
const initializeAdjust = (Adjust2, appToken, adjustEnvironment, config = {}) => {
};
const addAdjustSessionCallbackParams = (properties = []) => {
};
const logAdjustEvent = (eventId, callbackParams = []) => {
};
const sendAdjustRevenueEvent = (eventId, value, callbackParams = []) => {
};
export { ADJUST_EVENT_NAMES, AgreementCheckbox, Bank, BaseText, Body1, Body10, Body2, Body3, Body4, Body5, Body6, Body7, Body8, Body9, themes as COLOR_THEMES, colorThemes as COLOR_THEME_NAMES, Calendar, CaretDown, CaretUp, ChangeIndicator, Check$1 as Check, Check as CheckCircle, Checkbox, Close, ColorTheme, Column, CommonProps, Compass, Container, Copy, DatePicker, Delete, DownloadOnAppStore, DownloadOnGooglePlay, Dropdown, ExpiryDatePicker, Fire, FloatingLabelCurrencyInput, FloatingLabelDateEntry, FloatingLabelDatePicker, FloatingLabelDropdown, FloatingLabelExpiryDatePicker, FloatingLabelTextInput, H1, H3, H5, Heartbeat, INPUT_MASK_TYPES, InlineTextDropdown, Lightbulb, ListToggle, LoadingAnimation, LoadingSpinner, Lock, LogoFull, LogoShort, Microchip, Minus, MinusCircle, Modal, Money, MultiSelect, MultiSelectItem, Overlay, Page, Paper, PercentSign, Place, Plug, Plus, PlusCircle, Podcast, Row, SCREEN_SIZES, SVG_LOADING_ICON_TYPES, Shield, Spacing, SvgLoadingIcon, Text, TextInput, Toggle, Tree, ValueChangeText, Warning, addAdjustSessionCallbackParams, breakpoints, colorPalette, convertHexToRGBA, createDropdownItem, createListToggleItem, createMultiSelectItem, createToggleItem, defineFontSettings, initializeAdjust, logAdjustEvent, sendAdjustRevenueEvent, theStreetColorPalette, tornadoColorPalette, useScreenSize, useScript };
